import { DAILY_REWARD_STATUS } from '@Data/Models';
import { IGU_WALLET_TRANSACTIONS } from '@models/gamingWallet';
import {
    MARKETPLACE_ORDERS_SORT_OPTION,
    MARKETPLACE_PET_TYPE,
} from '@models/marketplace';
import {
    GAME_DIFFICULTY,
    LUCKY_STRIKE_GAMES_STATUS,
    MYSTERY_GAMES,
    MYSTERY_LIKES_STATUS,
    NFT_ROYAL_GAME_HISTORY_STATUS,
    NFT_ROYAL_GAME_MODE,
    TOKEN_TELLER_GAME_PREDICTION_DIRECTION,
    TOKEN_TELLER_GAME_STATUS,
    TOKEN_TELLER_HISTORY_GAMES_STATUS,
} from '@models/mysteryGames';
import ROUTES from '@navigation/routes';

const ru = {
    createWalletPassphrase: {
        title: 'Ваша сид-фраза',
        text: 'Пожалуйста, запишите эти 12 слов на листе бумаги. Записывайте в том же порядке. Храните их в надежном месте.',
        button: 'Продолжить',
        loading: 'Генерация сид-фразы..',
    },
    createWalletVerification: {
        title: 'Верификация',
        text: 'Выберите правильные слова, основываясь на их номерах (в том порядке, в котором они были написаны на предыдущем экране)',
        button: 'Продолжить',
        errors: {
            passphraseNotCorrect:
                'Порядок слов неправильный. Выберите правильные слова в соответствии с их порядком',
        },
        loading: 'Проверка сид-фразы..',
    },
    createWalletFirst: {
        title: 'Запишите свою сид-фразу',
        text: 'Если ваше устройство потеряно или украдено, вы сможете восстановить доступ к своим средствам с помощью сид-фразы. Если вы потеряете доступ к сид-фразе, это приведет к потере средств',
        button: 'Готово, продолжить',
    },
    importWalletInit: {
        title: 'Мы нашли ваш аккаунт',
        text: 'Вы вошли в систему с другого устройства, и у вас нет доступа к подключенному кошельку. Пожалуйста, укажите 12 слов сид-фразы вашего кошелька, чтобы продолжить использовать приложение',
        pets: 'Домашние животные',
        import: 'Импортировать кошелек',
        loading: 'Импорт кошелька..',
    },
    importWalletScreen: {
        title: 'Импорт кошелька',
        text: 'Введите свою начальную фразу из 12 слов, чтобы иметь возможность использовать кошелек внутри приложения',
        listTitle: 'Сид-фраза',
        inputPlaceholder: 'Введите здесь',
        clearAll: 'Очистить все',
        importWallet: 'Импорт',
        privateKeyButton: 'Импорт из ключа',
        privateKeyModal: {
            title: 'Импорт из приватного ключа',
            text: 'Если у вас нет доступа к сид-фразе, вы можете импортировать свой кошелек с помощью приватного ключа',
            label: 'Приватный ключ',
            placeholder: 'Введите приватный ключ',
            button: 'Импортировать',
        },
        errors: {
            mnemonicError:
                'Кошелька с такой фразой из 12 слов не существует. Пожалуйста, проверьте еще раз или предоставьте другую фразу',
            privateKeyError:
                'Кошелек с таким приватным ключом не существует. Пожалуйста, проверьте его еще раз или предоставьте другой приватный ключ',
            walletNotEqual:
                'Предоставленный кошелек не соответствует кошельку данного аккаунта',
            walletAlreadyVerified:
                'Этот кошелек принадлежит другому аккаунту, не удается импортировать',
        },
        success: 'Кошелек успешно импортирован',
    },
    createWalletInit: {
        createButton: 'Создать кошелек',
        importButton: 'Импорт кошелька',
        slider: {
            titleSlide1: 'Подключить кошелек',
            textSlide1:
                'Создайте новый кошелек или импортируйте существующий, указав начальную фразу из 12 слов',
            titleSlide2: 'Некастодиальные кошельки',
            textSlide2:
                'Кошелек IguVerse является некастодиальным, то есть только вы имеете доступ к своим приватным ключам, которые, в свою очередь, позволяют управлять вашей криптовалютой и доказывают, что средства принадлежат вам',
            titleSlide3: 'Восстановление учетной записи',
            textSlide3:
                'Если вы потеряете доступ к устройству и своей сид-фразе, мы не сможем восстановить ваш кошелек, и средства будут потеряны.',
        },
    },
    createWalletSuccess: {
        title: 'Кошелек создан',
        text: 'Поздравляем! Ваш кошелек был успешно создан, теперь вы можете начать пользоваться своим счетом',
        button: 'Перейти к последнему шагу',
        buttonNew: 'Продолжить',
    },
    importWalletSuccess: {
        title: 'Кошелек импортирован',
        text: 'Поздравляем! Ваш кошелек был успешно импортирован, вы можете начать пользоваться своим счетом',
        button: 'Продолжить',
        buttonNew: 'Перейти к последнему шагу',
    },
    login: {
        facebook: 'Войти с Facebook',
        google: 'Войти с Google',
        apple: 'Войти с Apple',
        email: 'Войти с E-mail',
        twitter: 'Войти с Twitter',
        emailTitle: 'Вход / Регистрация',
        creatingAccount:
            'Создавая аккаунт, я даю согласие на обработку моих данных в согласии с',
        and: 'и',
        privacyPolicy: 'Политикой конфиденциальности',
        termsOfUse: 'Условиями пользования',
        placeholderEmail: 'Введите адрес электронной почты',
        labelEmail: 'Адрес E-mail',
        placeholderVerificationCode: 'Введите код',
        labelVerificationCode: 'Код подтверждения придет на ваш E-mail',
        sendCode: 'Отправить',
        resendIn: 'Повторить через',
        seconds: 'сек',
        welcomeTo: 'Добро пожаловать в',
        codeSent: 'Одноразовый пароль отправлен!',
        errors: {
            invalidEmailAddress: 'Неверный адрес электронной почты',
            emailIsRequired: 'Поле Email является обязательным',
            verificationCodeIsRequired:
                'Для входа в аккаунт требуется одноразовый пароль',
            verificationCodeIsBadOrExpired:
                'Одноразовый пароль неверен или истек срок действия. Попробуйте еще раз',
            verificationCodeTooMuchAttempts:
                'Слишком много попыток. Пожалуйста, повторите попытку позже',
            loginFailed: 'Не удалось войти в систему',
            smthWentWrong:
                'Что-то пошло не так во время входа в систему. Повторите попытку позже или попробуйте другой способ',
        },
        loading: {
            sendingCode: 'Отправка кода..',
            loggingIn: 'Вход в систему..',
        },
    },
    mintPetRank: {
        title: 'Выберите ранг вашего питомца',
        text: 'Ранг определяет, сколько наград будет получать ваш питомец за выполнение ежедневных заданий',
        free: 'Бесплатно',
        roi: 'ROI ≈ ',
        dailyReward: 'Ежедневное вознаграждение ≈ ',
        buttonNext: 'Перейти к следующему шагу',
        disabled:
            'На одном аккаунте можно создать только одну NFT бесплатного ранга',
        info: 'Что такое ранг?',
        whiteList: 'Белый список ({{amount}})',
        mysteryBox: 'Mystery Box',
        mysteryBoxWithAmount: 'Mystery Box ({{amount}})',
    },
    mintPickPhoto: {
        title: 'Выберите фотографию вашего питомца',
        text: 'Сфотографируйте своего питомца или выберите понравившуюся фотографию из галереи',
        or: 'или',
        takePhoto: 'Откройте камеру',
        selectFromGallery: 'Выберите из галереи',
        tips: {
            title: 'Рекомендации по созданию идеальной фотографии',
            visible: 'Правильно',
            cut: 'Обрезанная фотография',
            blurry: 'Размытость',
            glare: 'Блики',
            tipOne: 'Хорошее освещение имеет большое значение',
            tipTwo: 'Постарайтесь сделать снимок с нейтральным фоном',
            tipThree: 'Убедитесь, что на фотографии только ваш питомец',
        },
        analyzingPhoto: 'Анализируем фотографию..',
        errors: {
            explicitContent: {
                title: 'Запрещенный контент',
                text: 'Изображение содержит запрещенный контент. Эти действия могут привести к бану аккаунта',
            },
            uploadError: {
                title: 'Загрузка не удалась',
                text: 'Проверьте подключение к Интернету и повторите попытку',
            },
            processImageFailed: {
                title: 'Ошибка изображения',
                text: 'В данный момент мы не можем обработать ваше изображение. Попробуйте еще раз или используйте другую фотографию',
            },
            notAnimal: {
                title: 'Здесь нет животных',
                text: 'Наши алгоритмы не могут распознать животное на вашей фотографии. Пожалуйста, повторите попытку с другой фотографией',
                try: 'Попробуйте еще раз',
                cancel: 'Отмена',
            },
        },
    },
    mintEditPhoto: {
        title: 'Кастомизация NFT',
        text: 'Подберите фон для вашего NFT-питомца',
        loading: 'Подготовка изображения..',
    },
    mintNamePhoto: {
        title: 'Дайте своему питомцу имя',
        text: 'Ваш питомец заслуживает самого лучшего имени. Длина имени не должна превышать 20 символов',
        inputLabel: 'Имя',
        placeHolder: 'например, Tuzik',
        buttonNext: 'Перейдите к следующему шагу',
        infoText:
            'Наши алгоритмы способны распознавать животных на фотографиях с вероятностью 99%',
        deleteNFTphoto: 'Удалить фотографию',
        deleteNFTphotoText:
            'Вы уверены, что хотите продолжить удаление? Ваш прогресс будет потерян',
        yesDelete: 'Да, вернуться назад',
        noKeep: 'Нет, продолжить',
        errors: {
            startSpace: 'Пробел не может быть первым символом имени',
            specialCharacters: 'Имя не может содержать специальных символов',
            latinCharacters: 'Имя может содержать только символы от A до Z',
            numbers: 'Имя не может содержать цифр',
            doubleSpaces: 'Имя не может содержать двойных пробелов',
            maxLength: 'Имя не может быть длиннее 20 символов',
            minLength: 'Имя не может быть короче 2 символов',
            mint: {
                title: 'Не удалось создать NFT',
                petRankWrongState:
                    'Этот ранг NFT-питомца не доступен для минта',
                obscenePetName:
                    'Имя питомца не должно содержать нецензурных слов. Ваш аккаунт может быть заблокирован',
            },
        },
    },
    mintCheckout: {
        transaction: 'Минт NFT',
        rank: 'Ранг',
        nftCustomization: 'NFT',
        successTitle: 'Создан новый NFT-питомец',
        successText:
            'Вы стали гордым владельцем нового питомца. Не забывайте хорошо заботиться о нем!',
        backToPlaying: 'Начать играть',
        backToCollection: 'Посмотреть коллекцию',
    },
    wallet: {
        screenTitle: 'Кошелек',
        loading: 'Загрузка кошелька..',
        emptyTitle: 'Не удается загрузить кошелек',
        emptyText: 'Ошибка при загрузке кошелька',
        total: 'Всего',
        deposit: 'Пополнить',
        withdraw: 'Вывести',
        trade: 'Обменять',
        balances: 'Баланс',
        exchanges: 'Биржи',
        exchangesInfo:
            'Вы можете купить наши токены на любой из перечисленных ниже бирж',
        available: 'Доступно:',
        view: 'Перейти',
        depositTo: 'Пополнить',
        depositBEP: 'Пополнить {{coin}} (BEP-20)',
        testnet: 'Testnet',
        testnetWarning:
            'Приложение в настоящее время работает в сети Testnet, не отправляйте сюда настоящие токены',
        howToPurchaseBNB: 'Как купить BNB',
        howToPurchaseIGU: 'Как купить IGU',
        warning:
            'Убедитесь, что вы отправляете свои токены на правильный адрес и в правильную сеть (BEP-20)',
        withdrawFrom: 'Выйти из',
        transactionHistory: 'История транзакций',
        viewOnBscScan: 'См. на BscScan',
        noTransactionYet: 'Пока нет сделок',
        noTransactionYetInfo: 'Вы еще не совершали никаких операций',
        transactionDetails: 'Детали сделки',
        amount: 'Сумма',
        type: 'Тип',
        date: 'Дата',
        fromAddress: 'С (Кошелька)',
        toAddress: 'На (Кошелек)',
        blockChainFee: 'Комиссия за транзакцию',
        loadingWithdraw: 'Отправка транзакции..',
        transactions: {
            coin: {
                DEPOSIT: {
                    name: 'Пополнение',
                    text: 'Криптовалюта отправлена на ваш кошелек. Просмотрите историю транзакций для получения более подробной информации',
                },
                WITHDRAW: {
                    name: 'Вывод средств',
                    text: 'Криптовалюта переведена из вашего кошелька. Пожалуйста, свяжитесь с платформой-получателем для получения квитанции о транзакции',
                },
                SWAP: {
                    name: 'Обмен',
                    text: 'Криптовалюта была обменена на другую криптовалюту с помощью встроенного DEX',
                },
                CLAIM: {
                    name: 'Клейм',
                    text: 'Клейм транзакция выполнена и средства конвертированы на баланс вашего кошелька',
                },
                NFT_PAYMENT: {
                    name: 'Оплата NFT',
                    text: 'Криптовалюта была использована для оплаты минта, восстановления здоровья или улучшения NFT в приложении. Для получения более подробной информации просмотрите историю транзакций',
                },
                UNKNOWN: {
                    name: 'Транзакция',
                    text: 'Любая другая транзакция в блокчейне, включая одобрение, комиссию и т.д. Для получения более подробной информации просмотрите историю транзакций',
                },
                CONFIRMED: { title: 'Завершено' },
                FAILED: {
                    title: 'Сбой транзакции',
                    text: 'Из-за проблем с сетью мы не смогли обработать вашу транзакцию',
                },
                PENDING: {
                    title: 'В ожидании',
                    text: 'Транзакция еще не подтверждена в блокчейне. Обычно это занимает от 5 минут до 1 часа',
                },
            },
            nft: {
                DEPOSIT: {
                    name: 'Пополнение',
                    text: 'NFT появилась в вашем кошельке. Просмотрите историю транзакций для получения более подробной информации',
                },
                WITHDRAW: {
                    name: 'Вывод NFT',
                    text: 'NFT переведена из IguVerse. Пожалуйста, свяжитесь с платформой-получателем для получения квитанции о транзакции',
                },
                MINT: {
                    name: 'Минт',
                    text: 'NFT была сминчена в приложении IguVerse',
                },
                CONFIRMED: { title: 'Завершено' },
                FAILED: {
                    title: 'Сбой транзакции',
                    text: 'В связи с техническими работами в сети мы не смогли обработать вашу транзакцию',
                },
                PENDING: {
                    title: 'В ожидании',
                    text: 'Транзакция еще не подтверждена в блокчейне. Обычно это занимает от 5 минут до 1 часа',
                },
            },
            reward: {
                GameIterationReward: {
                    title: 'Награда за задание',
                    text: 'Вознаграждения за выполнение ежедневных заданий',
                },
                ReferralReward: {
                    title: 'Реф. бонус',
                    text: 'Реферальное вознаграждение за активность других пользователей в приложении',
                },
                Claim: {
                    title: 'Клейм',
                    text: 'Данная транзакция переводит имеющиеся у вас вознаграждения VIGUP на виртуальном балансе в токены на блокчейн',
                },
                PetLevelUpPayment: {
                    title: 'Повышение уровня',
                    text: 'Внутренняя оплата за повышение уровня питомца',
                },
                PetRankUpPayment: {
                    title: 'Повышение ранга',
                    text: 'Внутренняя оплата за повышение ранга питомца',
                },
                PetRevivePayment: {
                    title: 'Восстановление',
                    text: 'Внутренняя оплата за восстановление NFT-питомца',
                },
                PetHealUpPayment: {
                    title: 'Лечение',
                    text: 'Внутренняя оплата за лечение NFT-питомца',
                },
                MintBonus: {
                    title: 'Бонус за минт',
                    text: 'Бонусное вознаграждение за минт NFT',
                },
                CharityDonation: {
                    title: 'Пожертвование',
                    text: 'Пожертвование на выбранную благотворительную организацию',
                },
                GameIterationRewardSubtransaction: {
                    title: 'Награда за задание',
                    text: 'Вознаграждения за выполнение ежедневных заданий',
                },
                CONFIRMED: { title: 'Завершено' },
                PENDING: {
                    title: 'В ожидании',
                    text: 'Транзакция клейма была инициирована, но не была завершена. Вам необходимо завершить текущую транзакцию, прежде чем Вы сможете инициировать новую',
                },
                UNLOCK: {
                    title: 'В разблокировке',
                    text: 'Данные награды сейчас недоступны и будут начислены на кошелек в соответствии с графиком разблокировки',
                    locked: '{{amount}} {{coin}} заблокированы',
                },
                unlockTransactions: {
                    title: 'Разблокированные награды',
                },
                UNKNOWN: {
                    name: 'Транзакция',
                    text: 'Транзакция на кошельке',
                },
                GameRewardStakeBonus: {
                    title: 'Бонус за буст',
                    text: 'Замороженные бонусы за буст',
                },
                GameRewardStakeBonusSubtransaction: {
                    title: 'Бонус за буст',
                    text: 'Замороженные бонусы за буст',
                },
            },
        },
        nft: {
            nft: 'NFT',
            tokenId: 'Идентификатор токена',
            myCollection: 'NFT',
            tooltip:
                'Здесь вы можете просмотреть свои коллекционные NFT-предметы',
            noNFTYet: 'Нет коллекционных предметов',
            noNFTYetInfo: 'Здесь пусто',
            mintNewNft: 'Минт новой NFT',
            NFTs: '{{balance}} NFT',
            noNFTs: 'Н/Д',
            deposit: 'Ввести NFT',
            viewAll: 'Смотреть все',
            allNFTs: 'Все NFT',
            withdraw: 'Вывести NFT',
            withdrawNftLabelAddress: 'Адрес',
            withdrawNftPlaceholderAddress: 'Введите адрес',
            withdrawNftTitle: 'Вывести NFT',
            blockchainFee: 'Комиссия за транзакцию',
            confirmButtonLabel: 'Подтвердить вывод',
            confirmModal: {
                title: 'Подтвердить вывод NFT',
                nftName: 'NFT',
                addressFrom: 'Из (Кошелька)',
                addressTo: 'На (Кошелек)',
                send: 'Подтвердить',
                cancel: 'Отмена',
            },
            withdrawSuccess: {
                title: 'Транзакция вывода NFT обрабатывается',
                text: 'NFT {{name}} была успешно выведена. Обычно это занимает от 5 минут до 1 часа',
                addressFrom: 'Из (Кошелька)',
                addressTo: 'На (Кошелек)',
                backToWallet: 'Перейти в кошелек',
            },
            transactionNft: 'Вывод NFT',
            withdrawWarningText:
                'Убедитесь, что вы выводите свои токены на правильный адрес и в правильную сеть (BEP-20). Если вы отправите NFT в любую другую сеть или на биржевой кошелек, вы можете навсегда потерять их',
            transactionHistory: 'История транзакций',
            noTransactionYet: 'Пока нет сделок',
            noTransactionYetInfo:
                'Вы еще не совершили ни одной транзакции. Но это не проблема, можно начать прямо сейчас',
        },
        rewards: {
            tooltipText:
                'Кнопка "Клейм" позволяет конвертировать ваши виртуальные токены вознаграждения в IGUP. Эта транзакция выполнится на блокчейне. Кнопка будет доступна, как только у вас появятся награды доступные для конверсии.',
            claimButton: 'Заклеймить',
            reclaimButton: 'Повторить',
            stakeButton: 'Буст',
            rewardsWallet: 'Кошелек для вознаграждений',
            mainWallet: 'Основной кошелек',
            transactionHistoryText: 'История транзакций',
            rewardsCarousel: {
                availableRewards: 'Доступные награды',
                availableRewards_text: 'Награды, конвертируемые в токены IGUP',
                lockedRewards: 'Заблокированные награды',
                lockedRewards_text: 'Награды, разблокируемые со временем',
                pendingRewards: 'В процессе клейма',
                pendingRewards_text: 'Завершите клейм транзакцию',
                claimReward: 'Заклеймить',
            },
            transactionHistory: {
                Claim: 'Клейм',
                GameIterationReward: 'Награда за задание',
                ReferralReward: 'Реф. бонус',
                PetLevelUpPayment: 'Повышение уровня',
                PetRankUpPayment: 'Повышение ранга',
                PetRevivePayment: 'Восстановление',
                PetHealUpPayment: 'Лечение',
                MintBonus: 'Бонус за минт',
                CharityDonation: 'Благотворительность',
                GameIterationRewardSubtransaction: 'Разблокировка',
                GameRewardStakeBonus: 'Бонус за буст',
                GameRewardStakeBonusSubtransaction: 'Разблокировка',
            },
            filter: {
                title: 'Сортировать по',
                ALL: 'Все',
                Claim: 'Клеймы',
                GameIterationReward: 'Задания',
                ReferralReward: 'Реф. бонусы',
                MintBonus: 'Минт Бонус',
                GameRewardStakeBonus: 'Бонус за буст',
            },
            empty: {
                title: 'Пока нет транзакций',
                text: 'Когда вы получите вознаграждение, оно будет отображаться здесь',
                button: 'Обновить',
            },
            confirmationModal: {
                title: 'Подтвердить запрос на получение',
                keys: {
                    from: 'Из',
                    to: 'На (Wallet)',
                    fee: 'Комиссия за транзакцию',
                    total: 'Общее',
                },
                values: {
                    rewardsWallet: 'Кошелек для наград',
                    mainWallet: 'Кошелек IGUP',
                },
                warning:
                    'Убедитесь, что у вас достаточно средств BNB для оплаты комиссии сети',
            },
            claimSuccess: {
                title: 'Обрабатывается транзакция клейма',
                text: 'Вы инициировали новую транзакцию клейма наград на свой кошелек. Обычно обработка занимает от 5 минут до 1 часа',
                backToWallet: 'Перейти в кошелек',
            },
            claimLoading:
                'В процессе обработки клейма, не закрывайте приложение..',
            claimBusy:
                'Сеть в данный момент перегружена, пожалуйста, повторите попытку через некоторое время',
        },
        gaming: {
            gamingWalletChangeFeatureText:
                'Это приблизительное соотношение обмена с IGU на VIGU',
            gamingWalletCarousel: {
                AvailableWallet: {
                    title: 'Доступный кошелек',
                    text: 'Чтобы принять участие, пополните свой игровой кошелек',
                },
                PendingWallet: {
                    title: 'Кошелек ожидания',
                    text: 'Токены будут заморожены до тех пор, пока вы не закончите игру',
                },
            },
            gamingWalletButtons: {
                topUp: 'Пополнить',
                withdraw: 'Вывести',
            },
            TopUpGamingWalletScreen: {
                screenTitle: 'Пополнить',
                title: 'Пополнить игровой кошелек',
                text: 'Чтобы принять участие, пополните свой игровой кошелек на IGU и получите VIGU',
                infoText: 'Как это работает',
                button: 'Перейти к оплате',
                inputSection: {
                    infoText:
                        'Введите или выберите количество, которое вы хотите приобрести',
                    errors: {
                        digits: 'Должны быть только цифры',
                        min: 'Сумма должна быть не менее {{limit}} {{coin}}',
                        max: 'Сумма должна быть не более {{limit}} {{coin}}',
                    },
                },
                howToModal: {
                    title: 'Пополнить игровой кошелек',
                    text: 'Чтобы принять участие, пополните свой игровой кошелек на IGU и получите VIGU. Используйте кнопку ниже, чтобы пополнить счет токенами',
                },
            },
            SelectWithdrawTokenModal: {
                title: 'Выберите токен для вывода',
                text: ' Вы можете выбрать токен, в котором вы получите свои награды в основном кошельке',
                button: 'Выбрать',
            },
            TopUpSuccessScreen: {
                title: 'Успешное пополнение',
                text: 'Вы успешно пополнили игровой кошелек токенами. Присоединяйтесь к соревновательным играм прямо сейчас!',
                button: 'Изучить игры',
                button2: 'Просмотр истории транзакций',
                buttonBack: 'Назад к игре',
            },
            transactionHistory: {
                filter: {
                    title: 'Сортировать по',
                    [IGU_WALLET_TRANSACTIONS.All]: 'Все',
                    [IGU_WALLET_TRANSACTIONS.Deposit]: 'Пополнить',
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: 'Вывести',
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: 'Возврат Вывод',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: 'Оплата',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]:
                        'Истечение срока',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: 'Ничья',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: 'Победа',
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: 'Комиссия',
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]:
                        'Бонус за пополнение',
                },
                transactions: {
                    [IGU_WALLET_TRANSACTIONS.Deposit]: {
                        title: 'Пополнить',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.Withdraw]: {
                        title: 'Вывести',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.RevertWithdraw]: {
                        title: 'Возврат Вывод',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDraw]: {
                        title: 'Ничья в загадочных лайках',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGamePayment]: {
                        title: 'Оплата в загадочных лайках',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameRefund]: {
                        title: 'Истечение срока в загадочных лайках',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameWin]: {
                        title: 'Победа в загадочных лайках',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DepositBonus]: {
                        title: 'Бонус за пополнение',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.DirectReferralDepositBonus]: {
                        title: 'Бонус за пополнение (Прямые)',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.IndirectReferralDepositBonus]: {
                        title: 'Бонус за пополнение (Косвенные)',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameFee]: {
                        title: 'Загадочные лайки: снятие комиссии',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameDirectReferralBonus]:
                        {
                            title: 'Реферальные начисления (Прямые)',
                            text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.MysteryLikesGameIndirectReferralBonus]:
                        {
                            title: 'Реферальные начисления (Косвенные)',
                            text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                        },
                    [IGU_WALLET_TRANSACTIONS.Breeding]: {
                        title: 'НФТ Эволюция минт',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.GamesTurnoverReward]: {
                        title: 'PVP Бонус',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },

                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameDraw]: {
                        title: 'Фруктовая гонка - Ничья',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGamePayment]: {
                        title: 'Фруктовая гонка - Оплата',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameRefund]: {
                        title: 'Фруктовая гонка - Возврат',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameWin]: {
                        title: 'Фруктовая гонка - Победа',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.NftRoyaleGameFee]: {
                        title: 'Фруктовая гонка - Комиссия',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGameWin]: {
                        title: 'Лаки Страйк - Победа',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.LuckyStrikeGamePayment]: {
                        title: 'Лаки Страйк - Билет',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpinReward]: {
                        title: 'Квантовый диск - Вознаграждение',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.QuantumSpin]: {
                        title: 'Квантовый диск - Оплата',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictWin]: {
                        title: 'Игумания - Вознаграждение',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredict]: {
                        title: 'Игумания - Оплата',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictFee]: {
                        title: 'Игумания - Комиссия',
                        text: 'Криптовалюты переводятся с Игрового кошелька. Проверьте подробности на bscscan',
                    },
                    [IGU_WALLET_TRANSACTIONS.TokentellerGamePredictRefund]: {
                        title: 'Игумания - Ничья',
                        text: 'Криптовалюта переведена на Игровой кошелек. Проверьте подробности на bscscan',
                    },
                },
            },
        },
        stakingBanner: {
            title: 'Увеличьте награды и получите за это бонусы!',
            text: 'Буст за IGUP доступен прямо сейчас во вкладке "Награды"!',
            button: 'Включить буст',
        },
    },
    trade: {
        poweredBy: 'Powered by',
        from: 'С',
        to: 'На',
        estimate: ' (Прибл.)',
        enterAmount: 'Введите значение',
        available: 'Макс.',
        selectToken: 'Выберите токен',
        deposit: 'Пополнить',
        trade: 'Обменять',
        rate: 'Курс',
        confirmTrade: 'Подтвердить обмен',
        cancel: 'Отмена',
        settings: 'Настройки',
        settingTitle: 'Допустимое проскальзывание',
        slippageMainText:
            'Ваша транзакция будет отменена, если цена изменится в неблагоприятную сторону более чем на процент ниже',
        save: 'Сохранить',
        percentFour: 'Введите %',
        inputWarning:
            'Значение проскальзывания должно быть в диапазоне от {{minAmount}}% до {{maxAmount}}%. Пожалуйста, введите другое значение',
        checkout: { estimate: 'Вы платите', to: 'Вы получаете' },
        processingTrade: 'Обработка транзакции..',
        calculatingTrade: 'Идет расчет..',
        button: 'Обменять',
        errors: {
            isRequired: 'Значение обязательно.',
            maxAmountError:
                'Недостаточно токенов на балансе. Пожалуйста, укажите другую сумму или добавьте средств',
            minLimit: 'Сумма обмена должна быть не менее {{limit}} {{coin}}',
            bnbNotEnough:
                'На вашем балансе недостаточно BNB чтобы оплатить комиссию за транзакцию. Пожалуйста, укажите другую сумму или добавьте средств',
            transaction: 'Транзакция не прошла',
            DS_MATH_SUB_UNDERFLOW:
                'Слишком большое кол-во токенов, попробуйте другое кол-во',
        },
        tradeSuccess: {
            title: 'Обмен завершен',
            text: 'Поздравляем! Вы успешно обменяли токены. Токены должны быть вскоре доступны на вашем балансе. Вы можете посмотреть детали транзакции в истории',
            backToWallet: 'Вернуться в кошелек',
            from: 'От',
            to: 'На',
            estimate: '(Прибл.)',
            blockchainFee: 'Комиссия за транзакцию',
            totalSummary: 'Всего',
            back: 'Продолжить торговлю',
        },
    },
    tradingView: {
        title: 'График',
        back: 'Назад к торговле',
    },
    walletSettings: {
        title: 'Настройки кошелька',
        header: 'Настройки безопасности',
        description:
            'Здесь вы можете просмотреть вашу сид-фразу и закрытый ключ, а также устанавливать и изменять пароль',
        backup: {
            title: 'Cид-фраза',
            description:
                'Никогда и никому не показывайте свою сид-фразу! Это ключ ко всем вашим средствам',
            modal: {
                title: 'Фраза / ключ для восстановления кошелька',
                text: 'Убедитесь, что никто не сможет увидеть ваши секретные данные. Открыв их кому-либо, вы рискуете потерять свои средства',
                yes: 'Посмотреть',
                no: 'Назад',
                alert: 'Команда IguVerse никогда не спросит Вашу сид-фразу или приватный ключ. Если кто-то спросит вас, это 100% мошенник, будьте осторожны!',
                checkbox:
                    'Я подтверждаю, что понимаю риск того, что если я отправлю кому-то мою сид-фразу или приватный ключ, мои токены и питомцы могут быть украдены',
            },
        },
        passcode: {
            title: 'Пароль и биометрия',
            description:
                'Установите или измените пароль/включите биометрическую идентификацию',
        },
    },
    passcode: {
        passcode: 'Пароль',
        modal: {
            title: 'Включить пароль',
            subTitle:
                'Четырехзначный код повысит вашу безопасность и будет использоваться для подтверждения важных действий',
        },
        welcome: {
            title: 'Включить пароль',
            subTitle:
                'Введите пароль, который вы будете использовать для доступа к приложению и подтверждения важных действий',
        },
        new: {
            title: 'Включить пароль',
            subTitle:
                'Введите пароль, который вы будете использовать для доступа к приложению и подтверждения важных действий',
        },
        confirm: {
            title: 'Подтвердите пароль',
            subTitle:
                'Введите пароль, который вы будете использовать для доступа к приложению и подтверждения важных действий',
            error: 'Неверный код. Введите тот же код, что и на предыдущем этапе',
        },
        check: {
            title: 'Введите пароль',
            subTitle: 'Введите текущий пароль, чтобы подтвердить действие',
            error: 'Неверный код. Попробуйте еще раз или используйте биометрическую идентификацию',
        },
        success: {
            title: 'Ваша учетная запись защищена!',
            subTitle:
                'Теперь ваша учетная запись и кошелек IguVerse защищены от вредоносных действий. Вы всегда можете изменить пароль в настройках',
        },
        change: {
            title: 'Изменить пароль',
            subTitle:
                'Введите новый пароль, который будет использоваться для подтверждения важных действий',
        },
        faceId: {
            title: 'Включить биометрическую идентификацию',
            subTitle:
                'Подтверждайте важные действия удобнее и быстрее. IguVerse не собирает ваши биометрические данные',
        },
        settings: {
            turnOff: 'Отключить пароль',
            biometric: {
                title: 'Биометрическая идентификация',
                subTitle:
                    'Используйте Face ID или отпечаток пальца для подтверждения важных действий в приложении',
            },
        },
        modalRemove: {
            title: 'Отключить пароль?',
            subTitle:
                'Все ваши данные надежно хранятся с помощью пароля. Вы можете установить его снова в настройках в любое время',
        },
        toasts: {
            turnOff: 'Успех! Пароль отключен!',
            biometricOff: 'Успех! Биометрия отключена!',
            biometricOn: 'Успех! Биометрия включена!',
            change: 'Успех! Пароль изменен!',
            biometricError: 'Ошибка! Попробуйте еще!',
        },
    },
    walletSettingsBackup: {
        mnemonic: {
            title: 'Ваша сид-фраза',
            text: 'Пожалуйста, запишите эти 12 слов на листе бумаги. Записывайте в том же порядке. Храните их в надежном месте.',
            reveal: 'Удерживайте для раскрытия фразы',
        },
        privateKey: {
            title: 'Ваш приватный ключ',
            text: 'Приватный ключ - это случайно сгенерированное число, которое дает пользователю контроль над всеми средствами, привязанными к кошельку. Его необходимо держать в секрете',
            reveal: 'Удерживайте для раскрытия приватного ключа',
        },
        privateKeyModal: {
            title: 'Приватный ключ',
            text: 'Запишите свой Приватный ключ. Храните его в надежном месте',
        },
        buttons: { hidden: 'Придержите, чтобы раскрыть', visible: 'Скрыть' },
        viewPrivateKey: 'Просмотр приватного ключа',
        emptyTitle: 'Ошибка',
        emptyText: 'Не удается загрузить кошелек',
    },
    withdrawScreen: {
        title: 'Вывести',
        labelAddress: 'Адрес',
        labelAmount: 'Сумма',
        placeholderAddress: 'Введите адрес',
        placeholderAmount: 'Введите сумму',
        labelAvailable: 'Доступно',
        allButtonLabel: 'Макс',
        confirmButtonLabel: 'Подтвердить транзакцию',
        depositButtonLabel: 'Пополнить',
        depositBEP: 'Ввод {{coin}} (BEP-20)',
        blockchainFee: 'Комиссия за транзакцию',
        totalSummary: 'Всего',
        errors: {
            address: 'Адрес не может быть пустым',
            amountRequired: 'Сумма не может быть пустой',
            invalidAddress: 'Неверный адрес кошелька',
            sameWallet: 'Невозможно вывести средства на собственный кошелек',
            digits: 'Должны быть только цифры',
            maxAmountError:
                'Недостаточно токенов на балансе. Пожалуйста, укажите другую сумму или введите средства',
            minLimit: 'Вывод средств должен быть не менее {{limit}} {{coin}}',
            bnbNotEnough:
                'На вашем балансе недостаточно BNB чтобы оплатить комиссию за транзакцию. Пожалуйста пополните счет BNB',
        },
        withdrawWarningText:
            'Убедитесь, что вы вывели свои токены на правильный адрес и в правильную сеть (BEP-20)',
        withdrawWarningTextNFT:
            'Если вы отправите свою NFT в любую другую сеть или на обменный кошелек, вы можете навсегда потерять ее',
        transaction: 'Вывод средств',
        withdrawSuccess: {
            title: 'Вывод обрабатывается',
            text: 'Вы инициировали вывод средств из своего кошелька. Обычно это занимает от 5 минут до 1 часа',
            backToWallet: 'Перейти в кошелек',
            viewTransactionHistory: 'Просмотр истории транзакций',
        },
    },
    ModalConfirmTransaction: {
        title: 'Подтвердить транзакцию',
        confirm: 'Подтвердить',
        cancel: 'Отмена',
    },
    ModalCoinSelect: { select: 'Выберите валюту' },
    ModalCropImage: {
        title: 'Обрезать изображение',
        crop: 'Обрезать и продолжить',
    },
    qrCodeScanner: {
        openSettings: 'Настройки',
        noAccessToCamera: 'Нет доступа к камере',
        title: 'Расположите QR-код в кадре',
        wallet: {
            titleScanned: 'Адрес отсканирован',
            text: 'Отсканируйте QR-код адреса токена. Убедитесь, что все данные видны',
        },
        referral: {
            titleScanned: 'Сканирование кода направления',
            text: 'Отсканируйте реферальный QR-код. Убедитесь, что все детали видны',
        },
        verify: {
            titleScanned: 'Проверка сканирования кода',
            text: 'Отсканируйте QR-код верификации. Убедитесь, что все детали видны',
        },
    },
    nftSelectGeneration: {
        continue: 'Продолжить',
        search: 'Поиск',
        pageTitle: 'Создайте своего NFT-питомца',
        pageInfo: 'Вы можете выбрать способ создания вашей NFT',
        nftFromPhoto: 'NFT из фотографии',
        nftFromPhotoText:
            'Создайте красивую NFT из фотографии вашего питомца. Выберите один из наших великолепных фонов для вашего будущего компаньона',
        nftFromImagination: 'NFT из вашего воображения',
        nftFromImaginationText:
            'Наши алгоритмы AI / ML могут нарисовать вашего виртуального питомца именно таким, каким вы его себе представляете. Опишите особенности вашего питомца и наслаждайтесь результатом',
        provideMoreInformation: 'Создайте питомца вашей мечты',
        provideMoreInformationInfo:
            'Выберите один из предложенных ниже вариантов, чтобы созданная NFT идеально соответствовала вашим представлениям о ней',
        selectAccessories: 'Выберите аксессуары',
        maximumAccessories: 'Вы можете выбрать максимум {{num}} аксессуаров',
        selectGeneratedNFT: 'Выберите своего питомца',
        selectGeneratedNFTInfo:
            'Мы создали несколько уникальных питомцев по вашему желанию. Выберите того, кто вам больше всего нравится',
        continueNextStep: 'Перейдите к следующему шагу',
        generateNewNFT: 'Повторная попытка',
        generateNFTButton: 'Генерировать NFT',
        loadingModalText: 'Загрузка..',
        randomize: 'Рандомизировать',
        clear: 'Очистить',
        select: 'Выбрать',
        noResult: 'Нет результатов',
        noResultText:
            'Для "{{query}}" не найдено результатов. Введите другие ключевые слова для поиска',
        form: {
            animal: {
                label: 'Животное',
                placeHolder: 'Выберите животное',
                modalTitle: 'Выберите животное',
            },
            'drawing-type': {
                label: 'Тип рисунка',
                placeHolder: 'Выберите тип рисунка',
                modalTitle: 'Выберите тип рисунка',
            },
            cat: {
                label: 'Порода кошек',
                placeHolder: 'Выберите породу кошки',
                modalTitle: 'Выберите породу кошек',
            },
            dog: {
                label: 'Порода собак',
                placeHolder: 'Выберите породу собаки',
                modalTitle: 'Выберите породу собаки',
            },
            'maturity-size': {
                label: 'Возраст / Размер',
                placeHolder: 'Выберите возраст или размер',
                modalTitle: 'Выберите возраст или размер',
            },
            color: {
                label: 'Цвет',
                placeHolder: 'Выберите цвет',
                modalTitle: 'Выберите цвет',
            },
            emotion: {
                label: 'Эмоции',
                placeHolder: 'Выберите эмоцию',
                modalTitle: 'Выберите эмоцию',
            },
            accessories: {
                label: 'Аксессуары',
                placeHolder: 'Выберите аксессуары',
                modalTitle: 'Выберите аксессуары',
            },
            context: {
                label: 'Контекст',
                placeHolder: 'Выберите контекст',
                modalTitle: 'Выберите контекст',
            },
            style: {
                label: 'Стиль',
                placeHolder: 'Выберите стиль',
                modalTitle: 'Выберите стиль',
            },
        },
        errors: {
            maintenance: {
                title: 'Наши модели искусственного интеллекта перегружены',
                text: 'К сожалению, наши модели искусственного интеллекта не могут обслужить ваш запрос в данный момент. Пожалуйста, попробуйте еще раз',
            },
        },
    },
    bottomNavigation: {
        play: 'Играть',
        charity: 'Благотворительность',
        statistics: 'Статистика',
        collection: 'Коллекция',
        marketplace: 'Магазин',
    },
    playScreen: {
        timeToComplete: 'До окончания раунда',
        startPlaying: 'Начать играть',
        howToPlay: 'Как играть?',
        nftToPlay: 'Ваши питомцы',
        edit: 'Ред.',
        nftToPlayInfo:
            'Выберите своих питомцев, которые будут участвовать в игре и зарабатывать награды',
        nftToPlayHint:
            'Порядок расположения ваших питомцев имеет значение. Первым будет тот питомец, который будет виден на вашем Pet ID. Первый питомец также получает наибольшее кол-во опыта за выполнение заданий',
        noNFTyet: 'Здесь никто не живет',
        noNFTyetInfo:
            'К сожалению, у вас еще нет животного. Заведите своего первого питомца и начинайте играть',
        exploreShop: 'Исследуйте магазин',
        mintNew: 'Заведите питомца',
        dailyTasks: 'Ежедневные задания',
        dailyTasksInfo:
            'Выполняйте ежедневные задания, чтобы заработать энергию, которая конвертируется в токены IGUP',
        timeLeftToComplete: 'До окончания раунда',
        selectNFT: 'Добавить питомцев',
        playCards: {
            SHARE_title: 'Поделитесь своим питомцем ',
            SHARE_info:
                'Ваши питомцы нуждаются в ежедневном внимании.\n' +
                'Поделитесь ими в социальных сетях',
            SHARE_button: 'Перейти к заданию',
            addSocialAccount: 'Добавить социальный аккаунт',
            socialAlert:
                'Проверка социального задания может занять до 12 часов и есть риск что оно будет проверено только в следующей итерации игры',
            MOVE_title: 'Выгуливайте своих питомцев',
            MOVE_info:
                'Ваши питомцы нуждаются в ежедневных прогулках.\n' +
                'Гуляйте со своими питомцами',
            MOVE_button: 'Перейти к заданию',
            PLAY_title: 'Играйте в игру с питомцами',
            PLAY_info: 'Играйте в аркадную игру с вашими домашними питомцами',
            PLAY_button: 'Перейти к заданию',
            VERIFY_title: 'Найти других животных',
            VERIFY_info:
                'Найдите домашних животных других пользователей в социальных сетях',
            VERIFY_button1: 'Перейти к заданию',
            VERIFY_button2: 'Перейти к заданию',
            completedEnergy:
                '{{energyRewarded}} / {{maxEnergyReward}} Собранная энергия',
            SHARE_failed_title: 'Ваш пост не удалось проверить',
            SHARE_failed_text:
                'При проверке вашего поста другим пользователям не удалось найти или полностью рассмотреть ваш Pet ID. К сожалению, сегодня вы не сможете получить энергию за эту задачу',
            SHARE_failed_button: 'Вернуться к играм',
            knowledgeBase: 'Просмотреть базу знаний',

            SHARE_failed_reasons: {
                notEnoughFollowers:
                    'Похоже, ваш аккаунт недостаточно активен. Пожалуйста, выберите другой аккаунт или займитесь развитием этого',
                petIdNotFound:
                    'Другие пользователи утверждают, что не могут найти пост с Pet ID в вашем профиле. Пожалуйста, не забудьте выложить его в следующий раз',
                petIdIncorrectPosition:
                    'Ваш Pet ID размещен таким образом, что другие пользователи не могут разобрать, что на нем. Постарайтесь быть внимательнее в следующий раз',
                userNotFound:
                    'Ни пользователи, ни администраторы не смогли найти вашу учетную запись. С ней что-нибудь случилось?',
            },
            SHARE_success_title: 'Социальное задание выполнено',
            SHARE_success_text:
                'Поздравляем! Вы поделились фотографией и она прошла проверку. Приходите завтра, чтобы получить больше заданий',
            SHARE_success_button: 'Посмотреть детали',
        },
        modalAllDead: {
            title: 'Ваши домашние животные мертвы',
            text: 'Вы не можете играть в задания, пока хотя бы один из ваших питомцев не будет в хорошей форме. Восстановите своих питомцев и возвращайтесь',
            button: 'Восстановить',
        },
        modalSomeDead: {
            title: 'Некоторые из ваших домашних животных мертвы',
            text: 'Некоторые из ваших питомцев мертвы, и они не будут получать награды. Вы уверены, что хотите продолжить?',
            button: 'Восстановить',
            button2: 'Продолжить игру',
        },
    },
    collectionsScreen: {
        title: 'Моя коллекция',
        text: 'Это дом для ваших замечательных питомцев',
        mintNewNft: 'Заведите своего первого питомца',
        mintPet: 'Создать питомца',
        noCollectionsYet: 'Здесь никто не живет',
        noCollectionsYetInfo:
            'К сожалению, у вас пока нет животного. Как вам удается жить без домашнего животного?',
        levelUp: 'Повысить',
        rankUp: 'Повысить',
        restore: 'Лечить',
        feed: 'Покормить',
        healAllButtonTooltip:
            'Вы можете использовать массовое лечение питомцев, только если у вас есть как минимум 2 питомца со здоровьем ниже 100%',
    },
    detailedPet: {
        headerSubtitle:
            'Это ваш питомец NFT, с его помощью вы можете выполнять ежедневные задания и получать за это токены. Ухаживайте за ним',
        levelXP: {
            title: 'Уровень и XP',
            text: 'Зарабатывайте XP за выполнение заданий и повышайте уровень своего питомца. После достижения определенного уровня питомца можно перевести на более высокий ранг',
            textUpgrade:
                'Вы получили весь опыт на уровне {{level}}. Повысьте свою NFT до нового уровня, чтобы заработать больше токенов',
            upgrade: 'Повышение до {{level}} уровня',
        },
        animalType: {
            title: 'Вид животного',
            text: 'Наши алгоритмы способны распознавать животных на фотографиях с высокой вероятностью',
        },
        rank: {
            title: 'Ранг {{rank}}',
            text: 'Ранг - это одна из основных характеристик питомца. Более высокие ранги позволяют получать больше наград и имеют более высокую скорость разблокировки наград',
            upgrade: 'Повышение до ранга "{{rank}}"',
            textUpgrade:
                'Вы достигли всех уровней в ранге "{{rank}}". Перейдите на новый ранг, чтобы заработать больше токенов',
        },
        age: {
            button: 'Восстановить NFT',
            Baby: 'Ребенок NFT = {{current}} / {{max}} дней',
            Young: 'Подросток NFT = {{current}} / {{max}} дней',
            Adult: 'Взрослый NFT = {{current}} / {{max}} дней',
            Old: 'Старый NFT = {{current}} / {{max}} дней',
            description:
                'Возраст вашего питомца считается с момента его создания. Когда питомец состарится, он умрет, и его нужно будет восстановить',
            descriptionDead:
                'Питомец прожил долгую и счастливую жизнь и ушел из жизни. Не нужно расстраиваться, вы можете восстановить его и играть снова!',
            dailyUnlock: 'Ежедневная разблокировка = ',
            daysMore: 'еще дней',

            modalWhatIsAge: {
                title: 'Что такое возраст?',
                text: 'Как только вы создадите свого питомца, он начнет жить и стареть. В приклонном возрасте он умрет от старости. В этом случае его можно будет оживить. Продолжительность жизни вашего виртуального питомца зависит от его ранга',
                feature: {
                    title: 'Скидка на восстановление = {{discount}}%',
                    text: 'После смерти NFT вы сможете восстановить ее со скидкой {{discount}}% (при сохранении ранга)',
                    alert: 'Повышение ранга обнулит возраст вашего питомца, а улучшенный виртуальный питомец будет жить в соответствии с возрастным лимитом нового ранга. После возрождения питомец будет иметь 1 уровень',
                },
            },
            modalNFTisAgeDead: {
                button: 'Восстановить',
                title: 'Питомец умер от старости!',
                text: 'Питомец "{{name}}" прожил долгую и счастливую жизнь и ушел из жизни. Не нужно расстраиваться, вы можете восстановить его и играть снова!',
                feature: {
                    title: 'Скидка на восстановление = {{discount}}%',
                    text: 'После смерти питомца вы сможете восстановить его со скидкой {{discount}}% (при сохранении ранга)',
                    alert: 'Повышение ранга обнулит возраст вашего питомца, а улучшенный виртуальный питомец будет жить в соответствии с возрастным лимитом нового ранга. После возрождения питомец начнет с 1 уровня',
                },
            },
            checkoutAgeRevive: {
                title: 'Восстановить питомца',
                text: 'Ваш питомец недоступен для выполнения ежедневных заданий. Восстановите его, чтобы играть и зарабатывать больше токенов',
                restoreTo: 'Восстановить до',
                transaction: 'Восстановление питомца "{{name}}"',
                errors: {
                    wrongState: 'Что-то не так, не получается оживить питомца.',
                },
            },
            successAgeRevive: {
                title: 'Питомец восстановлен!',
                text: 'Питомец был успешно восстановлен. Выполняйте ежедневные задания и зарабатывайте еще больше токенов',
                backToPet: 'Перейти к питомцу',
            },
        },
        earnings: {
            title: 'Заработок',
            text: 'Заработок NFT зависит от ранга и уровня питомца',
            rank: 'Заработок с Ранга = ',
            level: 'Бонус за Уровень = ',
        },
        matching: {
            title: 'Популярность',
            text: 'В ежедневных заданиях другие пользователи могут оценивать ваши NFT и сравнивать их',
            like: '{{like}} Нравится',
            dislike: '{{dislike}} Не нравится',
        },
        health: {
            title: 'Здоровье',
            text: 'Следите за тем, чтобы ваш питомец был сыт, иначе он может потерять здоровье. Как только здоровье питомца достигнет 0, он умрет',
            titleDead: 'NFT мертва',
            textDead:
                'Вы долгое время не кормили животное, и теперь оно умерло. Вы не сможете получать опыт, награды и играть со своим питомцем. Но не волнуйтесь, вы можете оживить его и продолжить игру. Поторопитесь!',
            buttonFeed: 'Накормить питомца',
            buttonRestore: 'Восстановить NFT',
            modalWhatIsHealth: {
                title: 'Что такое здоровье?',
                text: 'Здоровье вашего питомца уменьшается с каждым днем, если вы его не кормите. Держите свое здоровье всегда на максимуме, чтобы зарабатывать больше.',
                card: {
                    title: 'Здоровье питомца = Ежедневные награды',
                    text: 'Награды пропорциональны HP, т.е. имея 80 HP, вы получите 80% наград. Заботьтесь о своем питомце!',
                },
            },
            modalNFTisDead: {
                title: 'NFT мертва',
                text: 'Вы долго не кормили своего питомца "{{petName}}", и теперь оно умерло. Вы не сможете получать опыт, награды и играть со своим питомцем. Но не волнуйтесь, вы можете оживить его и продолжить игру. Поторопитесь!',
                button: 'Восстановить NFT',
            },
            checkoutRevive: {
                title: 'Восстановить NFT',
                text: 'Ваша NFT недоступна для выполнения ежедневных заданий. Восстановите ее, чтобы играть и зарабатывать больше токенов',
                restoreTo: 'Восстановить до',
                transaction: 'Восстановление "{{name}}" NFT',
                max: '100 Здоровья',
                errors: {
                    wrongState: 'Что-то не так, не получается оживить питомца.',
                },
            },
            successRevive: {
                title: 'NFT восстановлена!',
                text: 'NFT была успешно восстановлена. Выполняйте ежедневные задания и зарабатывайте еще больше токенов',
                backToPet: 'Просмотр домашних животных',
            },
            infoMultipleHealUp: {
                title: 'Покормить нескольких питомцев',
                text: 'Используйте одну кнопку, чтобы накормить всех своих питомцев! Питомцы будут лечиться по очереди. Все транзакции происходят в блокчейне, поэтому вы сможете их отследить',
                primaryButton: 'Покормить питомцев',
                secondaryButton: 'Не показывайте это больше',
            },
            checkoutHealUp: {
                title: 'Кормить NFT-питомца',
                text: 'Здоровье вашего животного зависит от ежедневного кормления. При полном здоровье ваше животное зарабатывает больше монет',
                restoreTo: 'Восстановить на',
                transaction: 'Восстановить "{{name}}" NFT',
                max: '{{amount}} Здоровья',
                errors: {
                    wrongState: 'Что-то не так, не получается вылечить питомца',
                },
            },
            checkoutMultipleHealUp: {
                title: 'Покормить нескольких питомцев',
                text: 'Восстановите здоровье всех ваших питомцев. NFT с большим количеством здоровья получат больше наград',
                transaction: 'Восстановить {{count}} NFT',
            },
            proceedingMultipleHealUp: {
                title: 'Здоровье восстанавливается',
                text: 'Пожалуйста, подождите немного, пока все транзакции не будут завершены. Не выходите из экрана, так как транзакции могут не пройти! Как только они будут завершены, вы сможете выйти из экрана',
                error: 'Некоторые транзакции NFT завершились неудачей из-за проблем с блокчейном. Попробуйте еще раз',
            },
            multipleSuccessHealUp: {
                title: 'Здоровье NFT восстановлено!',
                text: 'Здоровье ваших питомцев было восстановлено. Нажмите на кнопку ниже, чтобы получить более подробную информацию о каждой транзакции',
                backToCollection: 'Назад',
                item: 'Кормление {{length}} питомцев',
            },
            successHealUp: {
                title: 'Здоровье NFT восстановлено!',
                text: 'NFT-питомец был успешно накормлен и восстановил здоровье. Выполняйте ежедневные задания и зарабатывайте еще больше токенов',
                backToPet: 'Просмотр домашних животных',
            },
            healUpAmountChoose: {
                title: 'Покормить и восстановить здоровье',
                text: 'Выберите количество очков здоровья, которое вы хотите восстановить',
                button: 'Перейти к оплате',
                loading: 'Подсчет стоимости..',
                label: 'Выберите соответствующее количество',

                errors: {
                    MAX: 'Макс. восстановление {{amount}} здоровья',
                    MIN: 'Мин. восстановление {{amount}} здоровья',
                },
            },
            healthPetCollectionList: {
                health: '{{health}} Здоровья',
            },
            healAllLeave: {
                title: 'Вы уверены, что хотите уйти?',
                text: 'Ваши питомцы кормяться, уход во время этого процесса может привести к ошибкам, двойным тратам или неправильному списанию баланса. Действуйте с осторожностью',
                leave: 'Выйти',
                keep: 'Продолжить кормление',
            },
        },
        blockchainInfo: {
            tokenId: 'Идентификатор токена',
            title: 'Обзор NFT',
            description:
                'Ваш NFT-питомец хранится на блокчейне. Вы можете вывести его из кошелька в любое время',
            descriptionFree:
                'Ваш питомец имеет ранг Free и не является настоящим NFT. Повысьте ранг, и вы сможете сделать из него NFT',
            warningText:
                'После вывода NFT перейдет в режим Cooldown и не будет доступен для игры в течение 24 часов',
            cooldown: 'Cooldown заканчивается в',
            withdraw: 'Вывести',
        },
    },
    mysteryBoxes: {
        title: 'Коробки',
        emptyTitle: 'Коробки пока отсутствуют',
        emptyText: 'У вас нет ни одной коробки',
        emptyButton: 'Купить коробку',
        prepareToOpen:
            'Коробка открывается, ожидание случайного результата оракула ChainLink..',
        banner: {
            isComing: {
                title: 'Распродажа коробок приближается',
                text: ' оставшееся время',
            },
            isStart: {
                title: 'Приобрести коробки',
                text: 'Испытайте свою удачу и выиграйте самый высокий ранг',
            },
            isNotAvailable: {
                title: 'Распродажа коробок закрыта',
                text: 'Распродажа коробок - редкость, и она недоступна до дальнейшего уведомления',
            },
        },
        header: {
            title: 'Коробки',
            text: 'Приобретенные вами загадочные коробки будут храниться здесь. Вы можете открыть их в любое время и создать NFT',
        },
        mysteryBoxCard: { open: 'Открыть', mint: 'Создать NFT' },
        error: {
            title: 'Ошибка',
            text: 'Что-то пошло не так. Попробуйте перезагрузить',
        },
        openRank: {
            button: 'Посмотреть детали',
        },
        openBoxModal: {
            title: 'Хотите открыть коробку?',
            text: 'После открытия коробки вы получите случайный ранг и сможете бесплатно сминтить NFT',
            button1: 'Да, открыть',
            button2: 'Нет, отмена',
        },
        purchaseWelcome: {
            stepOne: {
                title: 'Испытайте свою удачу с Загадочными Коробками',
                text: 'Загадочные коробки дают вам шанс получить лучший ранг NFT по фиксированной цене. Испытайте свою удачу!',
            },
            stepTwo: {
                title: 'Шанс получить высший ранг',
                text: 'После покупки Загадочной коробки вы можете открыть ее в любое время и продолжить процесс минтинга без каких-либо дополнительных затрат',
            },
            stepThree: {
                title: 'Подлинная случайность',
                text: 'Шансы на выигрыш различных рангов с загадочными коробками полностью случайны, вероятность формируется с помощью технологии ChainLink Oracle для генерации настоящих случайных чисел на блокчейне',
            },
            button: 'Выберите кол-во коробок',
        },
        purchaseScreen: {
            title: 'Выберите количество',
            text: 'Вы можете купить несколько коробок за один раз',
            label: 'Введите или выберите количество',
            labelNoInput: 'Выберите количество коробок',
            errors: {
                max: 'Максимально возможное кол-во - 10 коробок',
                min: 'Минимальное кол-во в наличии - 1 коробка',
                noSymbols: 'Разрешены только числа',
            },
            button: 'Перейти к оплате',
            loading: 'Подсчет стоимости..',
        },
        purchaseCheckout: {
            title: 'Купить Коробки',
            text: 'Коробки дают вам шанс получить лучший ранг NFT по фиксированной цене. Испытайте свою удачу!',
            transactionDetails: {
                label: 'Загадочные Коробки',
                text: '{{amount}} Коробок',
                transaction: 'Приобрести {{amount}} коробок',
            },
        },
        purchaseSuccess: {
            title: 'Приобретены коробки!',
            text: 'Коробки были успешно приобретены. Вы можете открыть их на вкладке Коробки',
            button: 'Смотреть все',
        },
        comingSoon: {
            title: 'Загадочные коробки уже скоро',
            text: 'Приближается распродажа "Загадочных коробок". Следите за новостями и испытайте удачу!',
            timer: 'Оставшееся время',
        },
        saleClosed: {
            title: 'Коробки недоступны',
            text: 'Продажа коробок в данный момент недоступна. Следите за официальными объявлениями',
        },
        errors: {
            forbidden: {
                title: 'Распродажа окончена',
                text: 'Распродажа окончена, загадочных коробок не осталось. Попытайте удачу в следующий раз',
            },
        },
        modalMysteryBoxSaleInfo: {
            title: 'Испытайте свою удачу с загадочными коробками',
            text: 'Стоимость выигранной NFT будет не меньше цены самой коробки. Цена одной коробки',
            timerTitle: 'Время до распродажи',
            timerText:
                'Мы подготовили распродажу лимитированной коллекции, которая продлится ограниченное время. Всего ',
            timerAdditionalText: '{{amount}} NFT',
            chanceTitle: 'Шансы на победу',
            chanceText: 'Выиграйте NFT с определенной вероятностью:',
            button: 'Перейти к Коробкам',
        },
    },
    errorBoundary: {
        navigation: 'Ошибка',
        title: 'Ошибка на стороне клиента',
        text: 'К сожалению, что-то пошло не так на нашей стороне. Если вы продолжаете видеть эту ошибку, пожалуйста, свяжитесь с нашей службой поддержки',
        button: 'Перейти на главную страницу',
        reloadApp: 'Перезагрузить приложение',
    },
    pullToRefresh: {
        reloadBalance: {
            text: 'Обновление баланса..',
            modalText: 'Обновление..',
        },
        reloadPets: {
            text: 'Обновление NFT-питомцев..',
            modalText: 'Обновление..',
        },
        reloadMysteryBox: {
            text: 'Обновление коробок..',
            modalText: 'Обновление..',
        },
        reloadTasks: {
            text: 'Обновление заданий..',
            modalText: 'Обновление..',
        },
        reloadVerifyUsers: {
            text: 'Поиск животных..',
            modalText: 'Обновление..',
        },
        reloadRewards: 'Обновление наград..',
        reloadStatistics: 'Обновление статистики..',
        reloadReferrals: 'Обновление рефералов..',
        loading: 'Обновление..',
        pulling: 'Потяните, чтобы обновить',
        releasing: 'Отпустить',
    },
    petLevelUp: {
        readyToUpModal: {
            titleStart: 'Питомец готов к повышению до',
            titleLevelUp: ' {{level}}-го',
            titleEnd: ' Уровня',
            subTitleStart: 'Поздравляем! Вы собрали весь опыт и NFT ',
            subTitleEnd: ' готов к повышению уровня',
            button: 'Повысить',
            featureRankEarnings: {
                title: 'Доходы от ранга ≈ {{igup}} ≈ ({{usd}}$)',
                text: 'Часть вашего заработка, получаемая только с ранга',
            },
            featureLevelEarnings: {
                title: 'Доходы от уровня',
                text: 'Дополнительный доход, получаемый от уровня вашего NFT. Повышение уровня увеличивает ваш заработок',
            },
            featureNextRank: {
                title: '{{levels}} уровня(ей) до “{{rankName}}”',
                text: 'Вам нужно повысить уровень своей NFT еще {{levels}} раза, чтобы иметь возможность перейти на следующий ранг',
            },
        },
        petLevelUpSuccess: {
            title: 'NFT поднялся на уровень выше!',
            text: 'NFT {{name}} был успешно поднят до уровня {{level}}. Выполняйте ежедневные задания и зарабатывайте еще больше токенов с обновленным NFT',
            backToPet: 'Смотреть питомца',
            loading: 'Обновление..',
        },
        headerTitle: 'Повышение уровня NFT',
        checkout: {
            upgrade: 'Обновить до',
            level: 'Уровня {{level}}',
            transaction: 'Повышение уровня для {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Повышение уровня недоступно' },
    },
    petRankUp: {
        readyToUpModal: {
            title: 'Повышение до ранга {{rank}}!',
            subTitle:
                'Вы достигли всех уровней в ранге {{rank}} и ваш питомец готов к повышению ранга',
            button: 'Повысить',
        },
        petLevelUpSuccess: {
            title: 'NFT поднялся в рейтинге!',
            text: 'NFT {{name}} был успешно повышен до ранга {{rank}}. Играйте в ежедневные задания и зарабатывайте еще больше токенов с улучшенным NFT',
            backToCollection: 'Смотреть питомца',
            loading: 'Обновление..',
        },
        headerTitle: 'Повышение уровня NFT',
        checkout: {
            upgrade: 'Повысить до',
            level: 'Уровень {{level}}',
            transaction: 'Повышение уровня для {{name}} NFT',
        },
        errors: { PET_WRONG_STATE: 'Повышение ранга недоступно' },
    },
    petIsPlaying: {
        title: 'Ваш питомец играет',
        text: 'Если вы выведите его до окончания игрового раунда, вы не получите награды за сегодняшний день, а ваш питомец перейдет в режим Cooldown на следующие 24 часа',
        button: 'Я понимаю',
    },
    petOnCooldown: {
        title: 'Cooldown NFT',
        text: 'Ваш NFT находится в режиме Cooldown после трансфера и еще не доступен для игры, после окончания Cooldown периода, питомец снова сможет играть',
    },
    petIsDead: {
        title: 'NFT мертв',
        text: 'Вы долго не кормили свое животное "{{petName}}", и теперь оно умерло. Вы не сможете получать опыт, награды и играть со своим питомцем. Но не волнуйтесь, вы можете оживить его и продолжить игру. Поторопитесь!',
        errors: {
            PET_WRONG_STATE: 'Восстановление питомца недоступно',
        },
    },
    socializeToEarn: {
        welcomeSlidesShare: {
            startSharing: 'Поделиться',
            sharing: 'Делиться - значит заботиться',
            sharingText:
                'Каждый день ваш питомец нуждается в вашем внимании. Подарите его ему, запостив его в социальных сетях со своими друзьями',
            sharingEnergy: ' Энергии',
            socialMedia: 'Расскажите о своем питомце в социальных сетях',
            socialMediaText:
                'Выберите свой аккаунт в социальных сетях и прикрепите Pet ID к своему контенту в социальных сетях, чтобы другие пользователи могли найти вашего питомца',
            socialMediaEnergy: ' Энергии',
            referral: 'Добавьте свою реферальную ссылку',
            referralText:
                'Ваша реферальная ссылка должна быть прикреплена к ID питомца в истории. Другие игроки не смогут проверить ваше задание, если ссылка отсутствует!',
            errors: {
                FORBIDDEN: {
                    text: 'Вы не можете начать социальное задание с текущим социальным аккаунтом. Попробуйте после окончания таймера',
                },
            },
        },
        shareYourPetPhoto: {
            copyToClipboard: 'Имя пользователя скопировано в буфер обмена',
            title: 'Социальное задание',
            texts: {
                INSTAGRAM:
                    'Поделитесь своим контентом с прикрепленным Pet ID в истории Instagram и позвольте другим пользователям найти вашего питомца',
                TIKTOK: 'Поделитесь своим контентом с прикрепленным Pet ID питомца в TikTok и позвольте другим пользователям найти вашего питомца',
                TWITTER:
                    'Поделитесь своим контентом с прикрепленным Pet ID питомца в Twitter и позвольте другим пользователям найти вашего питомца',
                FACEBOOK:
                    'Поделитесь своим контентом с прикрепленным Pet ID питомца в Facebook и позвольте другим пользователям найти вашего питомца',
            },
            info: 'Как поделиться?',
            download: 'Скачать',
            share: 'Поделиться',
            createPhoto: 'Редактор',
            button: 'Поделиться и закончить',
            warningText:
                'Убедитесь, что ваш Pet ID доступен и легко виден для других пользователей, пока выполнение задания не будет засчитано',
            selectCreationMethod: 'Выберите фотографию',
            creationMethod: {
                camera: 'Сделайте фотографию',
                gallery: 'Выберите из галереи',
            },
            modalPetIdVisible: {
                title: 'Хорошо ли видно Pet ID и ссылку?',
                text: 'Вашу историю будут проверять другие пользователи. Если они не смогут найти Pet ID или ссылку или не смогут разглядеть ее содержимое, задание будет считаться невыполненным',
                button1: 'Да, продолжайте',
                button2: 'Нет, проверить еще раз',
            },
            modalShareYourPhoto: {
                title: 'Выберите способ',

                shareTemplate: {
                    title: 'Поделиться шаблоном',
                    text: 'Используйте созданный нами шаблон, чтобы поделиться Pet ID быстрее',
                },
                editToShare: {
                    title: 'Редактировать и поделиться',
                    text: 'Загрузите изображение из галереи или сделайте фото для редактирования Pet ID',
                },
                downloadPetId: {
                    title: 'Скачать Pet ID',
                    text: 'Оформите публикацию по своему усмотрению, не используя наши инструменты',
                },
                submit: 'Выполнено',
                loading: 'Подготовка контента..',
                saveSuccess: 'Фотография успешно сохранена',
            },
            petIdVisibleLoading: 'Создание задания Verify..',
            shareSuccess: {
                title: 'Найти других животных',
                text: 'Вы успешно поделились фотографией своего питомца. Ваше задание находится на проверке, которая обычно занимает от 6 до 12 часов. Теперь ваша очередь искать других домашних животных в социальных сетях',
                button1: 'Найти других домашних животных',
                button2: 'Вернуться к соц. заданию',
                button3: 'Назад к заданиям',
                toastSuccess: 'Все задания по проверке выполнены',
            },
            alert: 'Для правильного выполнения задания необходимо вставить ссылку на приложение в историю',
        },
        createShareTemplate: {
            screenTitle: 'Поделиться шаблоном',

            title: 'Поделиться с помощью шаблона',
            text: 'Делитесь контентом быстро и удобно, используя созданный нами шаблон',

            shareTemplate: {
                Default: 'Я играю в IguVerse и зарабатываю криптовалюту',
                BinanceNft: 'Зарабатывайте NFT питомцем вместе с IguVerse',
                BnbChain: 'Зарабатывайте NFT питомцем вместе с IguVerse',
                Okx: 'IGU готовится к высадке на Луну на OKX',
                KuCoin: 'IGU готовится к высадке на Луну на KUCOIN',
                Bybit: 'Проголосуйте за\nIguVerse на ByBit\nи разделите\n$121 000!',
            },
            placeForLink: 'Место для ссылки',
            socialCardTemplate: {
                Default: 'Я играю в IguVerse\nи зарабатываю криптовалюту',
                Bybit: 'Проголосуйте за\nIguVerse на ByBit\nи разделите\n$121 000!',
            },
        },
        welcomeSlidesVerify: {
            startVerify: 'Найти других животных',
            find: 'Найти других домашних животных',
            findText:
                'Ваш питомец нуждается во внимании со стороны других питомцев. Находите питомцев других игроков и получайте награды вместе с ними. Искать других питомцев — это хорошее дело, вы им нужны. Ваша ежедневная цель - найти всех питомцев.',
            findEnergy: ' Энергии',
            beResponsible: 'Быть ответственным',
            beResponsibleText:
                'Играйте честно и не пытайтесь жульничать, вводя систему в заблуждение, предоставляя неверные идентификаторы или утверждая, что вы не можете найти. Ваш аккаунт может быть помечен, если вы сделаете это ',
            beResponsibleEnergy: ' Энергии',
        },
        verifyUser: {
            title: 'Найти питомца',
            text: 'Вам нужно найти и ввести Pet ID, который можно найти в социальных сетях. За каждое удачное совпадение вы получите {{energy}} энергии',
            info: 'Как найти Pet ID?',
            label: 'Pet ID',
            placeHolder: 'Введите Pet ID',
            question: 'Как найти Pet ID?',
            buttonVerify: 'Проверить',
            buttonNotFound: 'Pet ID не найден',
            errorMessage:
                'Неверный Pet ID. Пожалуйста, попробуйте еще раз. Попыток осталось {{attempts}}!',
            loadingVerifyUser: 'Проверка..',
            errors: {
                noTasksText1: 'Сейчас нет доступных заданий',
                noTasksText2: 'Приходите позже',
                gameIterationExists1: 'Вам не разрешается создавать',
                gameIterationExists2: 'больше заданий в этой итерации игры',
            },
            toastNoPetVerification: {
                title: 'Ошибка',
                text: 'Нет доступных домашних животных для проверки',
            },
            toastSuccess: 'Поздравляем! Пользователь {{user}} верифицирован',
            toastFailedVerify: 'Провал! Пользователь {{user}} не проверен',
            regexError: 'Допускаются только цифры и символы A-Z',
            verifyEmpty: {
                title: 'Больше никаких домашних животных',
                text: 'Похоже, что сейчас никто не играет. Мы сообщим вам, когда появятся новые питомцы',
                button1: 'Изучите другие задания',
                button2: 'Попробуйте еще раз',
                refresh: 'Обновить',
            },
            verifyNotFound: {
                title: 'Питомец не найден',
                text: 'Надеемся, вы были правы. Если питомец всё-же был, вы получите предупреждение',
                button1: 'Найти еще',
                button2: 'Закончить игру',
            },
            verifyAlreadyCompleted: {
                title: 'Уже завершено',
                text: 'Задание уже завершено',
                button1: 'Проверить еще',
                button2: 'Закончить игру',
            },
            verifyMatch: {
                title: 'Мэтч питомцев!',
                text: {
                    step1: 'Поздравляем! Ваш питомец ',
                    step2: ' смэтчился с другим питомцем ',
                    step3: '! Теперь вы сможете взаимодействовать внутри приложения',
                },
                button1: 'Искать еще',
                button2: 'Закончить игру',
                like: 'Мне нравится',
                dislike: 'Не нравится',
                alreadyRate: 'Не можете изменить свое решение',
            },
            verifyFailed: {
                title: 'Не удалось',
                text: 'К сожалению, вы не указали правильный Pet ID домашнего животного',
                button1: 'Найти далее',
                button2: 'Закончить игру',
            },
            modalPetIdNotFound: {
                title: 'Pet ID не найден?',
                text: 'Пожалуйста, попробуйте найти Pet ID на фотографии пользователя. Если Pet ID присутствовал, но вы его не указали, то вы не заработаете очки энергии и можете получить предупреждение.',
                button1: 'Да, подтвердить',
                button2: 'Отмена',
            },
            tips: {
                title: 'Советы по проверке',
                alert: "Если Pet ID не соответствует правилам, нажмите кнопку 'Pet ID не найден'",
                post: 'Pet ID должен быть в истории',
                picture:
                    'Pet ID и вся информация на нем должны быть легко различимы на картинке',
                changes:
                    'Pet ID можно изменить, но изменения не должны противоречить другим правилам',
                cropping:
                    'Запрещается обрезать или скрывать изображение или его части',
                overlaying:
                    'Не допускается наложение или чрезмерное уменьшение размеров',
            },
        },
        petCardId: {
            link: 'Скачать приложение IguVerse ',
            earnStart: 'Мои питомцы зарабатывают ',
            earnEnd: ' в день',
            freeEarn: 'Мой бесплатный питомец зарабатывает ',
            donateMessage: 'Часть заработка идет на поддержку организации ',
            binanceMessage: 'IguVerse x Binance Продажа NFT',
            bnbMessage:
                'IguVerse x BNB Chain: Присоединяйтесь к новому тренду в Web3 и соцсетях',
            okxKuCoinMessage: 'Токен IGU листится на ',
            defaultMessage:
                'Мы создаем ИИ-маркетплейс и рекламную сеть — присоединяйся!',
        },
    },
    moveToEarn: {
        welcomeSlides: {
            walkPet: 'Выгуливайте своих питомцев',
            walkPetText:
                'Ваши питомцы нуждаются в ежедневных прогулках для поддержания здоровья так же, как и вы. Выгуливайте своих питомцев, и вы будете вознаграждены очками энергии',
            energyTotal: ' Энергии',
            complete: 'Выполните свою цель по ходьбе',
            completeText:
                'Выполняйте поставленные цели, отслеживайте свои результаты и наслаждайтесь здоровым образом жизни',
            antiCheating: 'Анти-читерские алгоритмы',
            antiCheatingText:
                'Наши анти-читерские алгоритмы способны обнаружить подозрительную активность пользователя. Пользователи, которые обманывают, теряют свои очки энергии',
        },
        modals: {
            prepare: 'Приготовиться к прогулке',
            prepareText:
                'Вы можете выполнить задание по ходьбе один раз в день. После завершения задания вы не сможете больше играть в этот день',
            leave: 'Вы хотите уйти?',
            leaveText:
                'Ваш текущий прогресс будет сохранен, и вы сможете приступить к сбору энергии завтра',
            leaveBtn1: 'Да, покинуть',
            leaveBtn2: 'Нет, продолжить',
            prepareBtn1: 'Начать прогулку',
            prepareBtn2: 'Отмена',
            permissionsInfoText:
                'IguVerse собирает данные о местоположении, даже когда приложение закрыто или не используется. Приложение может получать доступ к вашему местоположению в фоновом режиме для обеспечения функциональности задания Walking',
            permissionsInfoBtn1: 'Продолжить',
            permissionsInfoBtn2: 'Отмена',
            leaveWithOutFinish: 'Вы хотите выйти?',
            leaveWithOutFinishText:
                'После того как вы закроете задание, ваш прогресс будет утерян, но вы сможете начать задание еще раз',
            leaveWithOutFinishBtn1: 'Выйти',
            leaveWithOutFinishBtn2: 'Отменить',
        },
        notSupported: {
            title: 'Геолокация недоступна',
            text: 'Ваше устройство не поддерживает API геолокации, вы не можете выполнить задание Walking Task',
            button: 'OK',
        },
        locationProblem: {
            title: 'Проблема с геолокацией',
            text: 'Модуль геолокации перестал работать, причиной может быть отключение разрешения доступа. Попробуйте еще раз дать разрешение к геолокации в настройках устройства, и попробуйте еще раз.',
            button: 'Окей',
        },
        progress: {
            paused: 'Приостановлено',
            walking: 'Прогулка',
            stopped: 'Остановлено',
            tooFast: 'Слишком быстро',
            title: 'Выгул вашего питомца',
            timeLeft: 'Время до конца прогулки',
            tooFastMessage:
                'Ваша скорость не должна превышать 20 км/ч. Прогресс возобновится, когда скорость станет ниже',
            walkStoppedMessage:
                'Похоже, что вы перестали ходить. Ваш прогресс возобновится, как только вы продолжите ходить',
        },
        summary: {
            title: 'Статистика ходьбы',
            youEarned: 'Вы заработали',
            energy: 'Энергия',
            subtitle:
                'Поздравляем! Вы успешно выгуляли питомцев. Приходите завтра, чтобы узнать больше',
            distance: 'Расстояние',
            steps: 'Шаги',
            averageSpeed: 'Средняя скорость',
            viewMoreTasks: 'Просмотреть другие задания',
            finishPlaying: 'Закончить игру',
        },
        startWalking: 'Начать прогулку',
        skip: 'Нажмите, чтобы пропустить',
        km: 'км',
        kmH: 'км/ч',
    },
    playToEarn: {
        welcomeSlides: {
            energy: 'Восстанавливайте свою энергию',
            energyText:
                'Собирайте фрукты, перепрыгивайте через препятствия и восстанавливайте свой ежедневный уровень энергии. Будьте осторожны! У вас есть только одна попытка в день',
            energyAgainText:
                'Улучшайте свои навыки в игре, чтобы зарабатывать больше наград. Задание доступно только один раз в сутки, однако играть в игру можно в любое время',
            energyTotal: ' Энергии',
            energyAgainTotal: 'Тренировка',
            avoid: 'Преодолевайте препятствия',
            avoidText:
                'Ваша основная цель — перепрыгивать через препятствия и зарабатывать очки. Будьте осторожны!',
            food: 'Собирайте еду',
            foodText:
                'Собранная еда дает дополнительные очки. После того, как вы достигните достаточного количества очков, игра закончится и ваш запас энергии будет немедленно восстановлен',
        },
        modals: {
            prepareToPlay: {
                title: 'Приготовиться к игре',
                text: 'В своей первой игре вы будете играть, чтобы восстановить энергию. Если вы не сможете собрать всю энергию, вы сможете продолжить играть, но без увеличения энергии',
                accept: 'Начать играть',
                cancel: 'Отмена',
            },
            playAgain: {
                title: 'Приготовиться к игре',
                text: 'Сегодня вы уже собрали энергию в этой игре. Теперь вы можете просто играть для улучшения навыков в следующие дни',
                accept: 'Начать играть',
                cancel: 'Отмена',
            },
            loading: { text: 'Подготовка к игре..' },
            gameTimer: {
                text: 'Нажмите, чтобы перепрыгнуть через препятствия. Зарабатывайте очки и собирайте фрукты',
                textWebDesktop:
                    'Нажимайте пробел, либо левый клик мышкой чтобы перепрыгнуть преграды. Зарабатывайте очки и собирайте фрукты',
                textWebMobile:
                    'Нажмите, чтобы перепрыгнуть через препятствия. Зарабатывайте очки и собирайте фрукты',
            },
            pause: {
                title: 'Вы хотите уйти?',
                text: 'Ваш текущий прогресс будет преобразован в Энергию, однако вы не сможете больше играть в этот день',
                accept: 'Да, покинуть',
                cancel: 'Нет, продолжить',
            },
            win: {
                title: 'Задание выполнено',
                text: 'Поздравляем! Вы успешно выполнили ежедневное задание. Вы можете продолжать играть ради удовольствия, однако это не повлияет на уровень вашей энергии',
                accept: 'Закончить',
                cancel: 'Играть дальше',
            },
            loose: {
                title: 'Игра завершена',
                text: 'Вы не справились с ежедневным заданием. Вы можете продолжать играть ради удовольствия, однако это не повлияет на ваш уровень энергии',
                accept: 'Закончить',
                cancel: 'Играть дальше',
            },
            score: 'Ваши очки',
            energy: 'Восстановленная энергия',
            savedLives: 'Сохранённые жизни',
            fruitCollected: 'Собранные фрукты',
        },
        summary: {
            title: 'Игровая статистика',
            score: 'Кол-во очков',
            lives: 'Сохранённые жизни',
            fruitCollected: 'Собранные фрукты',
        },
        startPlaying: 'Начать играть',
        loadingStatuses: {
            downloading: 'Загрузка контента',
            preparing: 'Подготовка текстур',
            loadingGraphics: 'Загрузка графики',
            spawning: 'Создание игровых объектов',
            loading: 'Загрузка (не закрывайте приложение)',
        },
    },
    editNFTsScreen: {
        title: 'Выберите игровых животных',
        dragText:
            'Животные, которые будут участвовать в играх. Перетащите их, чтобы изменить порядок',
        selectList: 'Выберите животных из списка',
        warningMessage:
            'Первый по порядку питомец будет использован в вашем социальном задании в качестве Pet ID',
        cooldownMessage:
            'Ваш NFT находится в режиме Cooldown и не может участвовать в игре. Дождитесь окончания действия режима ожидания',
        button: 'Сохранить',
        errors: {
            saveChanges: {
                title: 'Несохраненные изменения',
                text: 'У Вас есть несохраненные изменения, Вы уверены, что хотите уйти?',
                button1: 'Отменить изменения и выйти',
                button2: 'Продолжить редактирование',
            },
        },
        loading: 'Идет сохранение..',
        success: 'Изменения сохранены!',
    },
    statuses: {
        COMPLETED: { title: 'Завершено' },
        AWAITS_VERIFICATION: { title: 'Ожидает проверки' },
        MODERATOR_VERIFICATION_REQUIRED: { title: 'Ожидает проверки' },
        FAILED: { title: 'Не удалось' },
    },
    profile: {
        title: 'Настройки',
        logOut: 'Выйти из системы',
        deleteAccount: 'Удалить аккаунт',
        logOutModal: {
            title: 'Уже уходите?',
            description:
                'Для использования приложения IguVerse вам нужно будет снова войти в систему или зарегистрировать новую учетную запись',
            okText: 'Да, выйти из системы',
            cancelText: 'Отмена',
        },
        deleteAccountModal: {
            title: 'Удалить аккаунт?',
            description:
                'Вы можете навсегда удалить свой аккаунт, но имейте в виду, что вы больше не сможете войти этим аккаунтом в систему',
            okText: 'Удалить аккаунт',
            inputLabel: 'Подтверждающая фраза',
            placeholder: 'Введите фразу подтверждения',
            preConfirmationPhrase: 'Введите ',
            afterConfirmationPhrase: ' чтобы подтвердить действие',
            success: 'Ваша учетная запись успешно удалена',
            loading: 'Удаление вашей учетной записи..',
        },
        lightTheme: 'Светлая',
        darkTheme: 'Темная',
        menuItems: {
            admin: {
                title: 'Проверка пользователей',
                description: 'Проверка социальных сетей пользователей',
            },
            security: {
                title: 'Безопасность',
                description: 'Настройте параметры безопасности',
            },
            socialAccounts: {
                title: 'Социальные аккаунты',
                description:
                    'Подключите свои социальные сети для участия в социальной игре',
            },
            assignRole: {
                title: 'Назначить роль',
                description: 'Выберите и назначьте пользователю роль',
            },
            language: {
                title: 'Язык',
                description: 'Установка языка отображения',
            },
            theme: { title: 'Тема', description: 'Выберите тему' },
            notifications: {
                title: 'Уведомления',
                description:
                    'Выберите виды уведомлений, которые вы хотите получать от приложения',
            },
            support: {
                title: 'Поддержка в чате',
                description:
                    'Оставьте свой запрос, и наш специалист ответит вам в чате',
            },
            supportEmail: {
                title: 'Отправить e-mail',
                description:
                    'Отправьте e-mail и наш специалист свяжется с вами',
            },
            knowledgeBase: {
                title: 'База знаний',
                description:
                    'Ознакомьтесь с другой полезной информацией о приложении IguVerse',
            },
            privacyPolicy: {
                title: 'Политика конфиденциальности',
                description:
                    'Узнайте больше о нашей политике конфиденциальности',
            },
            termsOfUse: {
                title: 'Условия',
                description: 'Узнайте больше о наших Условиях использования',
            },
            appVersion: {
                title: 'Версия приложения',
                description: 'Новейшая {{version}}',
            },
            webVersion: {
                title: 'Веб Приложение',
                description: 'Войти в веб приложение',
            },
            accessibility: {
                title: 'Доступность',
                description:
                    'Настройте интерфейс в соответствии с вашими предпочтениями',
            },
            socialMedia: {
                title: 'Наши соцсети',
                description:
                    'Подпишитесь на IguVerse в социальных сетях, чтобы быть в курсе последних новостей',
            },
            adminSendPushNotification: {
                title: 'Отправить push-уведомление',
                description:
                    'Создайте одноразовое уведомление, которое будет отображаться для всех пользователей',
            },
            adminReverification: {
                title: 'Повторная верификация',
                description:
                    'Как администратор, вы можете отправить социальную учетную запись на повторную проверку',
            },
            adminBlockUser: {
                title: 'Заблокировать пользователя',
                description:
                    'Заблокировать учетную запись пользователя, нарушившего правила IguVerse',
            },
            adminMaintenanceMode: {
                title: 'Режим обслуживания',
                description:
                    'В случае технических работ переведите приложение в режим обслуживания',
            },
            adminAssignWhiteList: {
                title: 'Отправить Вайтлист',
                description:
                    'Выберите количество и ранг NFT, чтобы отправить вайтлист победителю',
            },
        },

        languageSettings: {
            title: 'Языки',
            subtitle: 'Выберите язык',
            description:
                'Вы можете выбрать предпочтительный язык для отображения контента в приложении IguVerse',
            options: {
                pl: {
                    name: 'Польский',
                    change: 'Польский',
                },
                en: {
                    name: 'Английский',
                    change: 'Английский',
                },
                ru: {
                    name: 'Русский',
                    change: 'Русский',
                },
                uk: {
                    name: 'Украинский',
                    change: 'Украинский',
                },
                cn: {
                    name: 'Китайский',
                    change: 'Китайский',
                },
                id: {
                    name: 'Индонезийский',
                    change: 'Индонезийский',
                },
                es: {
                    name: 'Испанский',
                    change: 'Испанский',
                },
                tr: {
                    name: 'Турецкий',
                    change: 'Турецкий',
                },
            },
            switchLanguageModal: {
                title: 'Переключиться на язык {{localeId}}',
                description:
                    'Все содержимое приложения IguVerse переключится на {{localeId}}. Вы можете изменить его в любое время',
            },
        },
        notificationsSettings: {
            title: 'Уведомление',
            pushNotificationTitle: 'Push-уведомления',
            emailNotificationTitle: 'Email-уведомления',
            notifications: {
                pushDailyReminder: 'Ежедневное напоминание',
                pushRewardEarned: 'Заработанные награды',
                pushSocialTaskCompleted: 'Соц. задание выполнено',
                pushPetLowHealth: 'Низкое здоровье питомца',
                pushPetDead: 'Питомец умер',
                pushMysteryLikesGame: 'Загадочные лайки',
                emailPetDead: 'Питомец умер',
                emailSocialTaskCompleted: 'Соц. задание выполнено',
            },
            saved: 'Настройки уведомлений сохранены!',
        },
        socialAccountsSettings: {
            title: 'Социальные аккаунты',
            headerTitle: 'Подключить социальные сети',
            headerText:
                'Привяжите социальную учетную запись, чтобы иметь возможность выполнять социальное задание. Подробнее о требованиях к учетной записи читайте в базе знаний',
            headerInfo: 'Просмотреть базу знаний',
            alert: 'После подключения аккаунта необходимо выполнить социальное задание, чтобы аккаунт прошел верификацию',
            modal: {
                title: 'Пройдите верификацию',
                text: 'Вы успешно подключили свой аккаунт в социальной сети. Выполните социальное задание, чтобы аккаунт был верифицирован!',
                button: 'Перейти к заданиям',
            },
        },
        roles: {
            PLAYER: 'Игрок',
            ADMIN: 'Администратор',
            MODERATOR: 'Модератор',
        },
        support: {
            success: {
                title: 'Сообщение отправлено!',
                text: 'Мы свяжемся с вами в ближайшее время',
            },
            notSent: { text: 'Сообщение не отправлено' },
            errorOpen: {
                text: 'Ошибка при открытии почтового клиента',
            },
        },
        accessibilitySettings: {
            title: 'Доступность',
            faceId: 'Face ID / Пароль',
            shake: 'Окно обратной связи при тряске',
            vibration: 'Вибрация при взаимодействии',
            saved: 'Настройки доступа сохранены!',
        },
        socialMediaSettings: {
            screenTitle: 'IguVerse Медиа',
            communities: {
                title: 'Официальные сообщества',
                text: 'Присоединяйтесь к нашему удивительному сообществу любителей домашних животных, получайте помощь и общайтесь',
                socials: {
                    discord: 'Discord',
                    telegram: 'Telegram',
                },
            },
            media: {
                title: 'Официальные страницы в соцсетях',
                text: 'Следите за нашими каналами в социальных сетях, чтобы получать свежие новости и объявления',
                socials: {
                    twitter: 'Twitter',
                    instagram: 'Instagram',
                    youtube: 'Youtube',
                    tiktok: 'TikTok',
                    website: 'Вебсайт',
                    facebook: 'Facebook',
                },
            },
            telegram: {
                title: 'Telegram Сообщества',
                main: 'Новостной канал',
                en: 'Английский чат',
                uk: 'Украинский чат',
                ru: 'Русский чат',
                cn: 'Китайский чат',
                tr: 'Турецкий чат',
                id: 'Индонезийский чат',
                kr: 'Корейский чат',
                jp: 'Японский чат',
                ab: 'Арабский чат',
                in: 'Индийский чат',
                pp: 'Филиппинский чат',
                vt: 'Вьетнамский чат',
                bg: 'Бангладешский чат',
                pl: 'Польский чат',
                es: 'Испанский чат',
                fr: 'Французский чат',
                pt: 'Португальский чат',
            },
        },
        adminSendPushNotification: {
            title: 'Отправить push-уведомление',
            text: 'Создайте одноразовое уведомление, которое будет отображаться для всех пользователей',
            button: 'Отправить',
            selectLanguage: {
                label: 'Язык',
                placeHolder: 'Выберите язык уведомления',
                modalTitle: 'Выберите язык',
                button: 'Сохранить',
                title: '{{amount}} Выбранный язык',
            },
            titleInput: {
                label: 'Заголовок (менее {{amount}} символов)',
                placeHolder: 'Введите заголовок уведомления',
            },
            bodyInput: {
                label: 'Описание (менее {{amount}} символов)',
                placeHolder: 'Введите описание уведомления',
            },
            errors: {
                required: 'Это поле обязательно для заполнения',
            },
        },
        adminReverification: {
            screenTitle: 'Повторная верификация',
            title: 'Отправить на повторную верификацию',
            text: 'Выберите социальную сеть и введите имя пользователя для отправки аккаунта на проверку',
            button: 'Отправить',
            labelSocial: 'Социальная сеть',
            labelInput: 'Ссылка на аккаунт',
            placeHolder: 'Введите ссылку на аккаунт',
            socialMediaModal: {
                title: 'Выберите социальную сеть',
            },
            checkModal: {
                title: 'Проверьте детали профиля',
                text: 'Взгляните на социальную учетную запись ниже и проверьте, является ли она правильной. Будьте внимательны, так как это действие нельзя отменить',
                button1: 'Отправить на повторную верификацию',
                button2: 'Отменить',
            },
            toastSuccess: 'Аккаунт отправлен на повторную проверку',
        },
        adminBlockUser: {
            screenTitle: 'Заблокировать пользователя',
            title: 'Введите адрес кошелька',
            text: 'Введите кошелек, привязанный к аккаунту, который нарушил правила IguVerse',
            button: 'Заблокировать',
            modal: {
                title: 'Заблокировать пользователя?',
                text: 'Убедитесь, что вы блокируете нужного пользователя. Вы должны блокировать пользователей с полной уверенностью в своем решении. Это действие не может быть отменено!',
                button1: 'Отправить',
                button2: 'Отменить',
            },
            toastSuccess: 'Пользователь был успешно заблокирован',
            toastError: 'Не удалось найти пользователя',
            banReason: {
                screenTitle: 'Выберите причину блокировки',
                label: 'Причина блокировки',
                placeHolder: 'Выберите причину блокировки',
            },
            banComment: {
                label: 'Комментарий',
                placeHolder: 'При необходимости добавьте комментарий',
            },
            error: {
                banComment: 'Следует добавить комментарий',
                banReason: 'Пожалуйста, выберите причину бана',
            },
        },
        adminMaintenanceMode: {
            screenTitle: 'Режим обслуживания',
            on: {
                title: 'Включить режим обслуживания',
                text: 'Вы можете перевести приложение в режим обслуживания, и пользователи не смогут получить к нему доступ. Чтобы сделать его доступным снова, нажмите «Выключить режим обслуживания» в настройках',
                button: 'Включить',
                modal: {
                    title: 'Включить режим обслуживания?',
                    text: 'Пользователи не смогут получить доступ к приложению, если вы активируете режим обслуживания. Чтобы снова сделать приложение доступным, нажмите «Выключить режим обслуживания» в настройках',
                    button1: 'Включить',
                    button2: 'Отмена',
                },
                toastSuccess: 'Режим обслуживания Включен',
            },
            off: {
                title: 'Выключить режим обслуживания',
                text: 'Приложение находится в режиме обслуживания, и в настоящее время пользователи не могут получить к нему доступ. Отключите его, как только технические работы будут выполнены, нажав кнопку ниже. Не забудьте подтвердить!',
                button: 'Выключить',
                modal: {
                    title: 'Выключить режим обслуживания?',
                    text: 'Убедитесь, что технические работы закончены, и приложение будет работать правильно. Чтобы снова сделать приложение доступным, нажмите кнопку ниже',
                    button1: 'Выключить',
                    button2: 'Отмена',
                },
                toastSuccess: 'Режим обслуживания Выключен',
            },
        },
        adminAssignWhiteList: {
            screenTitle: 'Отправить Вайтлист',
            button: 'Отправить',
            title: 'Отправить Вайтлист',
            text: 'Введите адрес кошелька пользователя и выберите ранг и количество NFT',
            rank: {
                label: 'Ранг NFT',
                placeHolder: 'Выберите ранг',
            },
            quantity: {
                label: 'Количество',
            },
            modal: {
                screenTitle: 'Выберите ранг',
                title: 'Отправить Вайтлист?',
                text: 'Внимательно проверьте все данные: ранг NFT, количество NFT и адрес кошелька. Вы должны быть полностью уверены, подтверждая это действие, так как оно не может быть отменено',
                button1: 'Отправить',
                button2: 'Отмена',
            },
            toastSuccess: 'Вайтлист был успешно присвоен',
            error: {
                quantity: {
                    max: 'Максимальное количество {{quantity}}',
                    min: 'Минимальное количество {{quantity}}',
                    numbers: 'Только цифры',
                },
                rank: 'Необходимо выбрать ранг',
            },
            toastError: 'Не удалось найти пользователя',
        },
        adminAssignRole: {
            screenTitle: 'Назначить роль',
            button: 'Назначить',
            title: 'Назначить роль',
            text: 'Введите адрес кошелька пользователя и выберите подходящую роль',

            role: {
                label: 'Роль',
                placeHolder: 'Выберите роль',
            },
            roleModal: {
                title: 'Выберите роль',
            },
            attentionModal: {
                title: 'Назначить роль?',
                text: 'Внимательно проверьте все предоставленные данные: адрес кошелька и роль. Убедитесь, что вы не совершаете ошибку. Это действие не может быть отменено!',
                button1: 'Назначить',
                button2: 'Отменить',
            },
            error: {
                role: 'Роль должна быть выбрана',
            },
            success: 'Роль была успешно присвоена',
            toastError: 'Не удалось найти пользователя',
            toastSuccess: 'Роль была успешно присвоена',
        },
        walletInput: {
            label: 'Адрес кошелька',
            placeHolder: 'Введите адрес кошелька',
        },
        walletInputError: 'Не является адресом кошелька',
    },
    admin: {
        title: 'Администратор',
        verify: {
            title: 'Проверка пользователей',
            subtitle: 'Проверка социальных сетей пользователей',
            text: 'Откройте аккаунт в социальной сети и предоставьте Pet ID для успешной проверки',
            emptyTitle: 'Больше никаких задач',
            emptyText: 'Нет доступных задач для проверки, вернитесь позже',
            messages: {
                error: 'Неправильный Pet ID, попробуйте еще раз',
                success: 'Поздравляем! Пользователь верифицирован',
                notFound: 'Пользователю отказано',
                failed: 'Произошла ошибка, пожалуйста, сообщите об этом администратору',
            },
            modalPetIdNotFound: {
                title: 'Pet ID питомца не найден?',
                text: 'Пожалуйста, внимательно рассмотрите фотографию и, если у вас не получается верифицировать пользователя, выберите одну из следующих причин',
                reasons: {
                    notEnoughFollowers: {
                        title: 'Недостаточно подписчиков',
                        text: 'Аккаунт недостаточно активен в социальных сетях, не открыт и/или имеет мало подписчиков',
                    },
                    petIdNotFound: {
                        title: 'Pet ID питомца не найден',
                        text: 'Pet ID питомца не видно на фотографии, или он не опубликован',
                    },
                    petIdIncorrectPosition: {
                        title: 'Pet ID питомца имеет неправильное положение',
                        text: 'Pet ID питомца обрезан или размещен неправильно, так что невозможно увидеть код',
                    },
                    userNotFound: {
                        title: 'Пользователь не найден',
                        text: 'Аккаунт с публикацией либо удален, либо привязан неправильно и не может быть проверен',
                    },
                },
                button1: 'Да, подтверждаю',
            },
            label: 'Идентификатор животного (Pet ID)',
            placeHolder: 'Введите Pet ID',
            buttonVerify: 'Проверить',
            buttonNotFound: 'Pet ID не найден',
            loadingVerifyUser: 'Проверка..',
            regexError: 'Допускаются только цифры и символы A-Z',
        },
    },
    socialMediaConnect: {
        addSocialAccount: 'Добавить социальный аккаунт',
        selectAccountToShare: 'Выберите учетную запись',
        select: 'Дальше',
        connect: 'Подключить',
        disconnect: 'Отключить',
        unavailable: 'Пока что недоступно',
        status: {
            moderating:
                'Ваша учетная запись добавлена и будет проверена, как только вы опубликуете свой Pet ID для выполнения социального задания!',
            success:
                'Аккаунт успешно проверен нашими модераторами. Теперь вы можете использовать его для выполнения задания Socialize to Earn',
            reject: 'Ваш аккаунт не был одобрен модераторами. Пожалуйста, подключите учетную запись, соответствующую нашим правилам',
        },
        modalTerms: {
            start: 'Подключая социальный аккаунт, я соглашаюсь с ',
            and: ' и ',
            privacyPolicy: 'Политикой конфиденциальности',
            termOfUse: 'Условиями пользования',
        },
        connectTiktokModal: {
            title: 'Привязать аккаунт TikTok',
            label: 'Имя пользователя',
            placeHolder: 'Введите имя пользователя TikTok',
            button: 'Привязать',
            errors: {
                notExist:
                    'Этого аккаунта не существует. Пожалуйста, введите действительное имя пользователя TikTok',
                somethingWrong:
                    'Что-то пошло не так, пожалуйста, попробуйте еще раз',
                likeFollowers:
                    'Недостаточная активность на вашем аккаунте. Можно подключить только реальный аккаунт',
                cannotLoad:
                    'Не удается загрузить учетную запись пользователя. Пожалуйста, попробуйте еще раз',
                alreadyLinked:
                    'Указанное имя пользователя уже используется другим пользователем',
                notLinked: 'Учетная запись уже отвязана',
            },
        },
        socialPreview: {
            checkProfile: 'Проверьте свой профиль',
            takeALook: `Взгляните на учетную запись ниже и проверьте, принадлежит ли она вам`,
            view: 'Перейти',
        },
        connectInstagramModal: {
            title: 'Привязать аккаунт Instagram',
            label: 'Имя пользователя',
            placeHolder: 'Введите имя пользователя в Instagram',
            addAccount: 'Это я, Добавить аккаунт',
            cancel: 'Это не я, Отменить',
            button: 'Привязать',
            errors: {
                somethingWrong:
                    'Что-то пошло не так, пожалуйста, попробуйте еще раз',
                alreadyLinked:
                    'Указанное имя пользователя уже используется другим пользователем',
            },
            viaInstagram: 'или Войти с помощью Instagram',
        },
        connectTwitterModal: {
            title: 'Подключить аккаунт Twitter',
            label: 'Имя пользователя',
            placeHolder: 'Введите имя пользователя Twitter',
            button: 'Подключайтесь',
            errors: {
                notExist:
                    'Этого аккаунта не существует. Пожалуйста, введите действительное имя пользователя Twitter',
                somethingWrong:
                    'Что-то пошло не так, пожалуйста, попробуйте еще раз',
                alreadyLinked:
                    'Указанное имя пользователя уже используется другим пользователем',
            },
        },
        connectFacebookModal: {
            title: 'Подключить аккаунт Facebook',
            label: 'Имя пользователя',
            placeHolder: 'Введите имя пользователя Facebook',
            button: 'Подключайтесь',
            errors: {
                notExist:
                    'Этого аккаунта не существует. Пожалуйста, введите действительное имя пользователя Facebook',
                somethingWrong:
                    'Что-то пошло не так, пожалуйста, попробуйте еще раз',
                alreadyLinked:
                    'Указанное имя пользователя уже используется другим пользователем',
            },
            via: 'или Войти с помощью Facebook',
        },
        terms: {
            instagram: {
                one: 'Публичный профиль',
                two: 'Активный аккаунт с не менее чем 100 подписчиками',
                three: 'Не менее 5 постов старше 3 месяцев',
            },
            tikTok: {
                one: 'Не менее 500 подписчиков',
                two: 'Активный аккаунт с не менее чем 7 видеороликами старше 3 месяцев',
                three: 'Не менее 500 лайков на аккаунте',
            },
            twitter: {
                one: 'Публичный профиль',
                two: 'Активный аккаунт с не менее чем 500 подписчиками',
                three: 'Не менее 5 постов старше 3 месяцев',
            },
            facebook: {
                one: 'Публичный профиль',
                two: 'Активный аккаунт с не менее чем 100 друзьями',
                three: 'Не менее 5 постов старше 3 месяцев',
                four: 'Истории должны быть публичными',
            },
        },
        errors: {
            duplicate: {
                title: 'Ваш {{social}} уже подключен к другому аккаунту',
                text: 'Ваш профиль в социальной сети подключен к другому аккаунту. Сначала отключите его и повторите попытку',
                button: 'Закрыть',
            },
            disconnect: {
                title: 'Отвязать аккаунт?',
                text: 'Вы сможете использовать свою новый аккаунт для выполнения социального задания, как только начнется новый игровой день',
                button1: 'Да, отключить',
                button2: 'Нет, оставить',
            },
            userNameError:
                'Можно использовать только буквы, цифры, нижнее подчеркивание и точки',
        },
        success: {
            linkInstagram: 'Instagram успешно подключен',
            unLinkInstagram: 'Instagram отключен',
            linkTiktok: 'TikTok успешно подключен',
            unLinkTiktok: 'TikTok отключен',
            linkTwitter: 'Twitter успешно подключен',
            unLinkTwitter: 'Twitter отключен',
            linkFacebook: 'Facebook успешно подключен',
            unLinkFacebook: 'Facebook отключен',
        },
    },
    playTasksHistory: {
        title: 'История заданий',
        info: 'Здесь вы можете просмотреть историю своих заданий и свой прогресс',
        historyCard: {
            SocialTask: 'Социальное задание',
            VerificationTask: 'Поисковое задание',
            MoveTask: 'Прогулка',
            PlayTask: 'Игровое задание',
        },
        emptyState: {
            title: 'Заданий пока нет',
            text: 'Вы еще не выполнили ни одного задания. Но это не проблема, давайте сделаем это прямо сейчас',
            button: 'Начать играть',
        },
        historyTaskDetails: {
            title: 'Детали задания',
            text: 'Собранная энергия будет конвертирована в токены вознаграждения в вашем кошельке. Более подробная информация о заданиях приведена ниже',
            collectedEnergy:
                '{{earnedEnergy}} / {{maxEnergy}} Собранная энергия',
            viewRewardWaller: 'Смотреть в кошельке',
            details: {
                type: 'Тип:',
                type_SocialTask: 'Социальное задание',
                type_VerificationTask: 'Поисковое задание',
                type_MoveTask: 'Прогулка',
                type_PlayTask: 'Игровое задание',
                petExp: 'Опыт NFT-питомцев:',
                exp: '{{exp}} XP',
                date: 'Дата:',
            },
        },
    },
    successTaskEnergyBlock: {
        text: 'Энергия',
        collectedEnergy: '{{earnedEnergy}} / {{maxEnergy}} Собранная энергия',
    },
    successTaskPetsExp: {
        text: 'Собранный опыт (XP)',
        collectedExp: '{{collectedExp}} XP',
    },
    checkout: {
        title: 'Проверка транзакции',
        text: 'Перепроверьте информацию и подтвердите транзакцию',
        confirm: 'Оплатить',
        try: 'Попробуйте еще раз',
        cancel: 'Отмена',
        purchasingFrom: 'Способ оплаты',
        available: 'Баланс',
        deposit: 'Пополнить',
        wallet: '{{coin}} Кошелек',
        loadingPurchasing:
            'Завершение транзакции, пожалуйста, не закрывайте приложение..',
        free: 'Бесплатно',
        whiteList: 'Белый список (1)',
        explorerUrl: 'См. на BscScan',
        fields: {
            transaction: 'Транзакция',
            value: 'Значение',
            amount: 'Сумма',
            totalSummary: 'Всего',
            from: 'Способ оплаты',
            to: 'На (Кошелек)',
            fee: 'Комиссия',
            modalTitle: 'Подтвердить транзакцию',
            toWallet: 'В (кошелек)',
            gamingWallet: 'Игровой кошелек',
            mainWallet: 'Основной кошелек',
            confirm: 'Подтвердить',
            commissionFee: 'Комиссия',
            nft: 'NFT',
            nftWallet: 'NFT Кошелек',
            nftMarketplace: 'Торговая площадка',
        },
        errors: {
            notEnoughCoinFunds:
                'Недостаточно средств. Внесите средства в свой кошелек',
            notEnoughCoinFundsMulti:
                'Недостаточно средств. Выберите другой способ оплаты или внесите средства на свой кошелек',
            bnbNotEnough:
                'На вашем балансе недостаточно BNB чтобы оплатить комиссию за транзакцию. Пожалуйста пополните счет BNB',
            notEnoughBalanceFunds: 'Недостаточно средств',
            notEnoughBalanceFundsMulti:
                'Недостаточно средств. Выберите другой способ оплаты',
            insufficientVirtualBalance:
                'Недостаточное кол-во средств на вашем виртуальном балансе',
        },
        purchasingFromCoins: {
            coins: 'Токены',
            virtual: 'Электронный кошелек',
            inapp: {
                ios: 'Apple',
                android: 'Google Pay',
            },
        },
        storePurchase: {
            loadings: {
                PURCHASE:
                    'Платеж обрабатывается, пожалуйста, не закрывайте приложение..',
                FINALIZE:
                    'Транзакция обрабатывается, пожалуйста, не закрывайте приложение..',
            },
            button: 'Хорошо',
            storePurchaseError: {
                PURCHASE: {
                    title: 'Что-то пошло не так',
                    message:
                        'Что-то пошло не так во время обработки платежа. Пожалуйста, повторите попытку\nКод ошибки: {{code}}',
                },
                FINALIZE: {
                    title: 'Что-то пошло не так',
                    message:
                        'Что-то пошло не так во время обработки транзакции. Пожалуйста, повторите попытку',
                },
            },
        },
    },
    charity: {
        title: 'Благотворительность',
        description:
            'Пользователи IguVerse делают пожертвования из своего ежедневного дохода в пользу одной из заранее выбранных благотворительных организаций',
        current: 'Мой выбор',
        dailyDonation: 'Ежедневные пожертвования',
        howItWorks: 'Как это работает?',
        selectedOrganization: 'Выбранная организация',
        edit: 'Ред.',
        organizations: 'Организации',
        viewAll: 'Смотреть все',
        donated: 'пожертвовано',
        buttonSave: 'Сохранить',
        loadingPercentage: 'Обработка..',
        saveSuccess: 'Изменен процент ежедневных пожертвований',
        organizationsTitle: 'Все организации',
        infoRows: {
            address: 'Адрес',
            website: 'Сайт',
            email: 'Е-мейл',
            instagram: 'Instagram',
            twitter: 'Twitter',
        },
        readMore: 'Развернуть',
        hide: 'Скрыть',
        donations: 'Пожертвования',
        totalSummary: 'Всего',
        time: {
            minuteAgo: 'минуту назад',
            minutesAgo: 'минут назад',
            hourAgo: 'час назад',
            hoursAgo: 'несколько часов назад',
            dayAgo: 'день назад',
            daysAgo: 'дней назад',
        },
        payout: 'Благотворительная выплата',
        noDonations: 'Пожертвований пока нет',
        allDonations: 'Все пожертвования',
        modals: {
            confirmPercentage: {
                title: 'Подтвердите свои действия',
                text: 'Процент пожертвования влияет на сумму которая будет передана из вашего заработка непосредственно в благотворительную организацию, вы уверены, что хотите изменить процент пожертвования?',
            },
        },
        editOrganization: 'Выбор организации',
        editOrganizationNotChosen:
            'Вам необходимо выбрать минимум одну организацию для пожертвований',
        loadingOrganizationChange: 'Обработка..',
        changeOrganizationSuccess: 'Благотворительная организация сохранена',
        organizationDetails: 'Реквизиты организации',
        selectDescription: 'Выберите организацию из списка ниже',
        chooseOrganization: 'Выбрать организацию',
    },
    Marketplace: {
        title: 'Рынок',
        text: 'Вы можете покупать или продавать домашних животных другим пользователям на рынке',
        description: 'Скоро будет',
    },
    Feed: {
        title: 'Социальная лента',
        text: 'Здесь Вы можете просматривать всех доступных питомцев и взаимодействовать с ними',
        description: 'Скоро будет',
    },
    Leaderboard: {
        [ROUTES.LEADERBOARD_DAILY_TASKS]: {
            title: 'Лидеры по заданиям',
            text: 'Следите за успехами других пользователей и соревнуйтесь с ними в выполнении ежедневных заданий',
            emptyList: {
                title: 'Пока нет пользователей в таблице лидеров',
                text: 'К сожалению, пока ни один пользователь не выполнил ни одного задания. Но не беспокойтесь, это будет быстро исправлено',
            },
            energy: 'Собранная энергия',
            task: 'Выполненные задания',
        },
        [ROUTES.LEADERBOARD_PVP_GAMES]: {
            title: 'Лидеры по ПВП',
            text: 'Следите за успехами других пользователей и соревнуйтесь, выигрывая PvP-игры',
            emptyList: {
                title: 'Пока нет пользователей в таблице лидеров',
                text: 'К сожалению, пока ни один пользователь не сыграл ни в одну игру. Но не беспокойтесь, это будет быстро исправлено',
            },
            turnover: 'Оборот IGU',
            totalTurnover: 'Общий Оборот IGU',
            pnl: 'PNL (победы/поражения)',
            games: 'Всего сыграно',
        },
        emptyScreen: {
            title: 'Упс!',
            text: 'Что-то не так. Но не волнуйтесь, это будет быстро исправлено. Попробуйте потянуть.',
        },
    },
    playCollectedExperience: {
        screenTitle: 'Собранный опыт',
        title: 'Опыт NFT-питомцев',
        text: 'После выполнения задания ваши питомцы получают XP для повышения уровня',
    },
    playSuccessScreen: {
        button: 'Просмотреть другие задания',
        button2: 'Вернуться на главную',
        emptyStates: {
            VERIFY: {
                title: 'Поисковое задание выполнено',
                text: 'Поздравляем! Вы выполнили поисковое задание на сегодня. Приходите завтра за новыми заданиями',
                failTitle: 'Поисковое задание не удалось',
                failText:
                    'Вы не справились с поисковым заданием на сегодня. Приходите завтра, чтобы попробовать еще',
            },
            MOVE: {
                title: 'Задание прогулка выполнено',
                text: 'Поздравляю! Вы прошли всю дистанцию и выполнили задание. Приходите завтра за новыми заданиями',
                failTitle: 'Задание не выполнено',
                failText:
                    'Вы не справились с прогулкой на сегодня. Попробуйте завтра еще раз',
            },
            SOCIAL: {
                title: 'Социальное задание выполнено',
                text: 'Поздравляем! Вы поделились фотографией, и она прошла проверку. Приходите завтра за новыми заданиями',
            },
            PLAY: {
                title: 'Игровое задание выполнено',
                text: 'Поздравляем! Вы завершили игру на сегодня. Приходите завтра за новыми заданиями',
                failTitle: 'Игровое задание провалено',
                failText:
                    'К сожалению, вы провалили игру. Попробуйте еще раз завтра',
            },
        },
    },
    general: {
        howItWorks: 'Как это работает',
        comingSoon: 'Скоро',
        comingSoonDesc: 'Эта функция еще не готова.',
        copiedToClipboard: 'Скопировано в буфер обмена',
        createPet: 'Создать питомца',
        next: 'Следующий',
        or: 'или',
        ok: 'OK',
        loading: 'Загрузка..',
        loadMore: 'Загрузить еще',
        errors: {
            unknown: {
                title: 'Неизвестная ошибка',
                message: 'Пожалуйста, попробуйте еще раз',
            },
            error: { title: 'Ошибка' },
            networkRequestFailed: {
                title: 'Ошибка сети',
                message: 'Сетевой запрос не прошел. Попробуйте еще раз',
            },
            TASK_WRONG_STATE: {
                title: 'Ошибка',
                message:
                    'Срок действия задания истек, пожалуйста, попробуйте еще раз',
            },
            TASK_CREATE_FORBIDDEN: {
                title: 'Ошибка',
                message:
                    'Срок действия задания истек, пожалуйста, попробуйте еще раз',
            },
            UNPREDICTABLE_GAS_LIMIT: {
                title: 'Проблемы с кошельком',
                message:
                    'Скорее всего недостаточно BNB для покрытия комиссии за транзакцию. Убедитесь, что у вас достаточно средств и BNB для покрытия комиссии и повторите попытку',
            },
            INSUFFICIENT_FUNDS: {
                title: 'Недостаточно средств',
                message:
                    'Убедитесь, что у вас достаточно средств и BNB для покрытия комиссии за транзакцию. Отправьте криптовалюту на ваш кошелек и повторите попытку',
            },
            fileIsTooBig: {
                title: 'Файл слишком большой',
                text: 'Файл изображения должен быть меньше {{size}} МБ',
            },
            cantOpenUrl: {
                text: 'Ваше устройство не может открыть ссылку {{url}}. Скопируйте URL и перейдите по ней вручную',
            },
            gameAlreadyStarted: {
                text1: 'Игра уже началась',
                text2: 'Пожалуйста, выберите другую игру',
            },
            gameBanned: {
                text1: 'Вы забанены в этой игре',
                text2: 'Ждите дальнейших уведомлений',
            },
            wrongGameStatus: {
                text: 'Неправильный статус игры',
            },
            emptyErrorScreen: {
                title: 'Упс!',
                text: 'Что-то не так. Но не волнуйтесь, это будет быстро исправлено',
            },
            ops: {
                text1: 'Упс!',
                text2: 'Что-то пошло не так :(',
            },
        },
        success: { title: 'Успех' },
        socialLoading: 'Подключение..',
        cancel: 'Отмена',
        back: 'Назад',
        current: 'Текущий',
        knowledgeBaseButton: 'Узнать больше в базе знаний',
        timerTitle: 'Оставшееся время',
        hint: '{{hint}}/{{maxHints}} Подсказки',
        continue: 'Продолжить',
        skip: 'Пропустить',
        BUTTONS: {
            mintNewNft: 'Минт новой NFT',
            continue: 'Продолжить',
            continueLater: 'Продолжить позже',
            mintNft: 'Минт NFT',
            select: 'Выбрать',
            startPlaying: 'Начать играть',
            start: 'Начать',
            learnMore: 'Узнать больше',
            playPvpGames: 'Играть в PVP - игры',
            goToWallet: 'Перейти в кошелек',
            createNewOrder: 'Создать новый ордер',
            apply: 'Применить',
            clear: 'Очистить',
            viewProfile: 'Просмотр профиля',
            buyForWithAmount: 'Купить за {{amount}}',
            cancel: 'Отменить',
            delistNft: 'Удалить ордер',
            delist: 'Удалить',
            viewMarketplace: 'Просмотреть торговую площадку',
            getStarted: 'Начать',
            reloadApp: 'Перезагрузить приложение',
            createNewGame: 'Создать новую игру',
            exploreMoreGames: 'Просмотреть другие игры',
            viewGamesHistory: 'Просмотр истории игр',
            viewStatistics: 'Просмотреть статистику',
            tryAgain: 'Попробовать еще раз',
            createGame: 'Создать игру',
            topUpBalance: 'Пополнить баланс',
            continueToNextStep: 'Перейти к следующему шагу',
            continueShopping: 'Купить еще',
            enableNow: 'Включить сейчас',
            maybeLater: 'Может быть позже',
            backToSettings: 'Вернуться к настройкам',
            turnOff: 'Выключить',
            purchaseFor: 'Приобрести за {{amount}}',
            purchase: 'Приобрести',
            viewAll: 'Просмотреть все',
            view: 'Посмотреть',
            purchaseMore: 'Приобрести еще',
            viewDetails: 'Посмотреть детали',
            readMore: 'Читать дальше',
            hide: 'Скрыть',
            viewChart: 'Открыть график',
        },
        KEYS: {
            ranks: 'Ранги',
            price: 'Цена',
            chance: 'Шанс',
            rank: 'Ранг',
            sortedBy: 'Отсортировать по',
            typeOfNft: 'Тип NFT',
            totalSummary: 'Общий объем',
            totalSuccessfulOrders: 'Всего успешных ордеров',
            totalPurchasesSummary: 'Общий объем торгов',
            NFTs: 'NFTs',
            profile: 'Профиль',
            details: 'Детали',
            numberAndLevel: '{{level}} Уровень',
            numberAndHealth: '{{health}} Здоровье',
            deadByAge: 'Питомец был стар и умер',
            numberAndDaysAge: '{{days}} Возраст в днях',
            yourNFT: 'Ваш NFT',
            vs: 'VS',
            opponentsNFT: 'NFT соперника',
            yourPoints: 'Ваши очки',
            opponentsPoints: 'Очки противника',
            type: 'Тип',
            gameSettings: 'Настройки игры',
            difficulty: 'Сложность',
            mode: 'Режим',
            livesCount: 'Количество жизней',
            yourAccount: 'Ваш аккаунт',
            leaderboardPlace: 'Место в таблице лидеров',
            timeLeft: 'Оставшееся время',
            ticketsAmount: 'Количество билетов',
            tickets: 'Билеты',
            winner: 'Победитель',
            prizes: 'Призы',
            won: 'Выигран',
            hash: 'Хэш',
            date: 'Дата',
            roundId: 'ID Раунда',
            chainResults: 'Результаты',
            globalSeed: 'Глобальное значение',
            gamesHistory: 'История игр',
            users: 'Пользователи',
        },
        FILTERS: {
            byDate: {
                Day: 'Сегодня',
                Week: 'Последние 7 дней',
                Month: 'Последние 30 дней',
            },
        },
        ALERTS: {
            notEnoughCoinsOnGamingWallet:
                'Недостаточно токенов на игровом кошельке, чтобы присоединиться к игре. Пополните счет, чтобы начать играть',
        },
        MERGED: {
            selectText: 'Выберите {{text}}',
        },
        DECLINATION: {
            Ticket: {
                one: 'Билет',
                two: 'Билета',
                five: 'Билетов',
            },
        },
    },
    modal: {
        mintPetLeave: {
            title: 'Вы хотите уйти?',
            text: 'Вы почти закончили создание своего питомца. Не прекращайте!',
            keep: 'Закончить создание питомца',
            leave: 'Да, покинуть',
        },
        ModalFreeRank: {
            title: 'Вы упускаете возможность получить большой бонус',
            text: 'Вы действительно хотите отказаться от бонуса {{amount}} IGUP токенов (${{dollarValue}}) за создание питомца высокого ранга?',
            highest: 'Создать и получить бонус',
            proceed: 'Продолжить без бонуса',
        },
        askForPermissions: 'Попросить разрешения',
        goToSettings: 'Перейти к настройкам',
        try: 'Попробуйте еще раз',
        cancel: 'Отмена',
        deletePhoto: 'Удалить фотографию для NFT?',
        deletePhotoInfo: 'Вы уверены, что хотите удалить свою фотографию?',
        yesDelete: 'Да, удалить',
        noCancel: 'Нет, отмена',
        changeRank: 'Вы хотите изменить ранг?',
        changeRankInfo: 'Вы перейдете к первому шагу минта',
        changeRankGo: 'Изменение ранга',
        upgradeRank: {
            title: 'Повышение ранга "{{slug}}"',
            text: 'Некоторые функции открываются при повышении ранга. Повысьте свой ранг, чтобы получить доступ к этой функции',
            upgradeToRank: 'Повышение ранга',
        },
        savingName:
            'Сохранение имени занимает некоторое время. Пожалуйста, не закрывайте приложение',
        generatingNFT:
            'Обрабатывается запрос. Обычно это занимает до нескольких минут..',
        generateNewNFT: {
            title: 'Вернуться к предыдущему шагу?',
            text: 'Вы будете возвращены обратно и потеряете текущий прогресс. Ваш питомец уникален, мы не сможем создать точно такого же',
            yesGenerate: 'Да, вернуться обратно',
            noKeep: 'Нет, оставайтесь здесь',
        },
        askForCameraPermissions: {
            title: 'Отсутствие разрешений для камеры',
            text: 'Вы должны предоставить разрешения для камеры, чтобы иметь возможность использовать эту функцию',
        },
        askForLocationPermissions: {
            title: 'Нет разрешений для местоположения',
            text: 'Чтобы воспользоваться этой функцией, необходимо предоставить разрешения на определение местоположения',
        },
        askForCameraRollPermissions: {
            title: 'Отсутствие разрешений для галереи',
            text: 'Чтобы воспользоваться этой функцией, необходимо предоставить разрешения для галереи',
        },
        askForLocationPermissionsWeb: {
            title: 'Нет разрешений для местоположения',
            text: 'Чтобы воспользоваться этой функцией, необходимо предоставить разрешения на определение местоположения',
            additionalText:
                '. Перейдите в настройки и включите разрешения для определение местоположения',
            button: 'Закрыть',
        },
        nftPreview: {
            title: 'Пред. просмотр NFT',
            text: 'Это предварительный просмотр вашего питомца',
        },
        confirmation: {
            title: 'Вы уверены?',
            text: 'Пожалуйста, подтвердите свои действия для продолжения',
            yes: 'Да, подтвердите',
            cancel: 'Отмена',
        },
        modalChangeLanguage: {
            screenTitle: 'Изменить язык',
            button: 'Изменить',
        },
    },
    navigationBar: {
        wallet: {
            MAIN: 'Основной',
            NFT: 'NFT',
            REWARDS: 'Награды',
            GAMING: 'Игровой',
        },
        tasks: { active: 'Текущие', history: 'История' },
        admin: { verify: 'Проверить', dashboard: 'Приборная панель' },
        referrals: { invites: 'Пригласить', all: 'Мои рефералы' },
        collections: {
            collection: 'Питомцы',
            mystery: 'Коробки',
        },
        tooltip:
            'Это вкладка кошелька. Перейдите сюда, чтобы увидеть свой баланс и вознаграждения. В кошельке вы можете снимать, вносить, забирать награды и обменивать токены',
    },
    AppState: {
        GameMaintenanceState: {
            title: 'Обслуживание игры',
            text: 'Задания IguVerse находятся на техническом обслуживании и в настоящее время недоступны. Извините за неудобства и возвращайтесь в ближайшее время',
            button: 'Понятно',
        },
        FullMaintenanceState: {
            title: 'Приложение находится на техническом обслуживании',
            text: 'Приложение IguVerse находится на техническом обслуживании и в настоящее время недоступно. Извините за неудобства и возвращайтесь в ближайшее время. Следите за обновлениями наших социальных сетях',
        },
        GlobalErrorState: {
            title: 'Внеплановое техническое обслуживание',
            text: 'Приложение IguVerse находится в стадии разработки, и в настоящее время мы проводим незапланированное техническое обслуживание. Извините за неудобства и возвращайтесь в ближайшее время',
            button: 'Повторная попытка',
        },
        UpdateRequiredState: {
            title: 'Доступно обновление',
            text: 'Эта версия приложения устарела, пожалуйста, обновите приложение из {{store}} Store, чтобы продолжить использование актуальной версии',
            button: 'Скачать',
            cancel: 'Позже',
            error: 'Не можете открыть ссылку, откройте магазин {{store}} вручную и загрузите самую новую версию',
        },
        UpdateRequiredStateWeb: {
            title: 'Обновление приложения.',
            text: 'Приложение сейчас находится в процессе обновления, пожалуйста, повторите попытку через несколько минут',
            button: 'Попробуйте еще раз',
        },
        NoNetworkConnectionState: {
            title: 'Нет связи',
            text: 'Похоже, у вас возникли проблемы с подключением к Интернету. Интернет необходим для правильной работы приложения',
            button: 'Есть',
            reconnected: 'Соединение восстановлено!',
            reconnecting: 'Соединение потеряно. Переподключение..',
        },
    },
    ranks: {
        rankLongTitle: 'Ранг {{rank}}',
        level: '{{level}} LVL',
        upgradeRankButton: 'Повышение ранга',
        upgradeText:
            'Вы достигли всех уровней своего текущего ранга. Пришло время повысить {{rank}} свой ранг и награды',
        lockedText:
            'Ранг {{rank}} недоступен для минта. Вы можете получить его, повышая уровень и продвигаясь по игре',
        perDay: 'Ежедн.',
        dailyUnlock: 'Ежедн. разблок.',
        foodConsumption: 'Ежедн. потребление',
        maxAge: 'Макс. Возраст',
        days: 'Дней',
        list: {
            free: {
                title: 'Free',
                infoText:
                    'Ранг Free даст вам возможность изучить приложение и его функции. Однако вы не можете получить и выводить награды, пока не купите NFT или не повысите ранг своего бесплатного питомца',
            },
            starter: {
                title: 'Starter',
            },
            common: {
                title: 'Common',
            },
            uncommon: {
                title: 'Uncommon',
            },
            unusual: {
                title: 'Unusual',
            },
            rare: {
                title: 'Rare',
            },
            mystical: {
                title: 'Mystical',
            },
            legendary: {
                title: 'Legendary',
            },
            epic: {
                title: 'Epic',
            },
            exotic: {
                title: 'Exotic',
            },
            royal: {
                title: 'Royal',
            },
            diamond: {
                title: 'Diamond',
            },
        },
        ranksDetailedInfoScreen: { button: 'Минт NFT', current: 'Текущий' },
        rankDetailedInfo: {
            reward: {
                title: 'Ежедневная награда ≈ {{reward}} ≈ {{usd}}',
                text: 'Предполагаемое ежедневное вознаграждение в токенах при выполнении всех заданий',
                warning:
                    'Данная стоимость является лишь оценкой способности животного зарабатывать, и она может меняться',
                warningFree:
                    'В ранге Free есть случайный шанс получить награду в игре. Вознаграждение за ранг Free не гарантируется',
            },
            rate: {
                title: 'Ежедневная разблокировка ≈ {{reward}} ({{rate}}) ≈ {{usd}}',
                text: 'Вы можете перевести {{percent}}% доступных вознаграждений VIGUP на свой основной кошелек. После получения токен можно обменять, отправить на другой кошелек или вывести',
                alert: 'Остальные токены VIGUP заморожены и будут храниться в заблокированном кошельке',
            },
            consumption: {
                title: 'Потребление пищи = {{consumption}}',
                text: 'Ваш питомец потребляет токены каждый день. Если питомца не кормить вовремя, он теряет здоровье и может умереть',
            },
            age: {
                title: 'Максимальный возраст = {{maxAge}} дней',
                text: 'Как только ваша NFT достигнет этого возраста, она умрет, и ее нужно будет восстановить',
                alert: 'Повышение ранга обнулит возраст вашей NFT, а улучшенный виртуальный питомец будет жить в соответствии с возрастным лимитом нового ранга. После возрождения NFT будет иметь 1 уровень',
            },
        },
        modalWhatIsRank: {
            title: 'Что такое ранг?',
            text: 'Ранг влияет на способность вашего питомца зарабатывать и другие важные характеристики, такие как ежедневный процент разблокировки заработанных токенов и количество токенов нужных для кормления. Чем выше ранг, тем лучше характеристики',
            buttonAvailable: 'Просмотр доступных рангов',
            buttonAll: 'Посмотреть все ранги',
        },
        checkoutUpgradeRank: {
            title: 'Повышение ранга',
            text: 'Чем выше ранг, тем больше наград заработает ваш питомец',
            upgradeTo: 'Обновить до',
            transaction:
                'Повысить ранг до {{rank}} для вашего NFT-питомца "{{name}}"',
        },
        successUpgradeRank: {
            title: 'Повышение ранга!',
            text: 'Ранг NFT был успешно повышен. Выполняйте ежедневные задания и получайте еще больше наград',
            backToPet: 'Просмотр домашнего животного',
        },
    },
    localNotifications: {
        moveToEarnFinished: {
            title: 'Задание Move выполнено',
            message:
                'Откройте приложение и посмотрите, сколько энергии вы собрали',
        },
        noPets: {
            title: 'Скорее выберите своего питомца',
            message:
                'Заведите своего первого питомца и начните свое удивительное путешествие в IguVerse',
        },
    },
    monthPicker: {
        month1: 'Январь',
        month2: 'Февраль',
        month3: 'Март',
        month4: 'Апрель',
        month5: 'Май',
        month6: 'Июнь',
        month7: 'Июль',
        month8: 'Август',
        month9: 'Сентябрь',
        month10: 'Октябрь',
        month11: 'Ноябрь',
        month12: 'Декабрь',
        selectMonth: 'Выбирать',
    },
    staking: {
        stakeLoading: 'Включаем буст, пожалуйста, не закрывайте приложение...',
        unStakeLoading:
            'Выключаем буст, пожалуйста, не закрывайте приложение...',
        general: {
            dailyBoost: 'Ежедневный Буст',
            ended: 'Закончится',
            summary: 'Всего',
            days: '{{days}} Дней',
            current: 'Буст сейчас',
        },
        plans: {
            title: 'Детали вариантов',
            text: 'Каждый вариант буста имеет свой период блокировки и процент буста',
            days: ' Дней',
            boost: 'Усиление до {{boost}}%',
        },
        welcomeScreen: {
            title: 'Буст',
            headerTitleStart: 'Увеличьте доход ',
            headerTitleCenter: 'на {{number}}%',
            headerTitleEnd: '',
            headerText:
                'Вы можете увеличить награды в основной игре с помощью буста, заморозив токены на определенный промежуток времени',
            stake: {
                title: 'Варианты буста',
                text: 'Инвестируйте свои токены IGU и IGUP — получайте проценты с них или увеличенные награды',
            },
            lock: {
                title: 'Период блокировки',
                text: 'Ваши токены будут заморожены на период времени, указанный в варианте буста',
            },
            calculation: {
                title: 'Расчет буста',
                text: 'Буст пересчитывается каждый день в зависимости от выбранного варианта буста',
                alert: 'Если ваши награды изменились (нп. изменилось кол-во животных), изменится и процент буста. Вы всегда сможете увидеть текущий размер буста',
            },
            button: 'Включить буст',
        },
        optionsScreen: {
            toastAlready: 'Данный вариант буста уже включен',
            button: 'Продолжить',
            screenTitle: 'Вариант буста',
            title: 'Выберите вариант',
            text: 'Выберите вариант буста для ваших токенов. Можно использовать несколько вариантов одновременно',
            IGUP: {
                title: 'Буст за IGUP',
                text: 'Заблокируйте свой IGUP на определенный период времени и получите буст к ежедневным вознаграждениям!',
            },
        },
        plansScreen: {
            button: 'Продолжить',
            selectPlan: 'Выберите план',
            title: 'Выберите план бустинга',
            headerTitle: 'Выберите план',
            headerText:
                'Выбранная вами сумма будет зафиксирована в смарт-контракте до конца периода. Одновременно можно инвестировать только в один план',
            headerInfoText: 'Какой план выбрать?',
            lock: {
                title: 'Период блокировки = {{days}} дней',
                description:
                    'Период блокировки - это период времени, в течение которого ваши токены будут заблокированы, а буст будет активен',
            },
            boost: {
                title: 'Буст = ~{{boost}} %',
                description:
                    'Буст - модификатор, который увеличивает ваши внутриигровые награды на определенный процент',
            },
            calculation: {
                title: 'Ежедневная прибавка = ~{{boost}} %',
                description:
                    'Буст пересчитывается каждый день в зависимости от ваших наград',
                alert: 'Если ваши награды изменились, изменится и буст. Вы всегда сможете увидеть текущий размер буста',
            },
        },
        coinsInputScreen: {
            title: 'Выберите кол-во токенов',
            button: 'Рассчитать ежедневный буст',
            button2: 'Пропустить шаг',
            loading: 'Расчет буста..',
            available: 'Доступно ',
            maxButton: 'Макс.',
            errors: {
                digits: 'Должны быть только цифры',
                max: 'Недостаточно токенов на балансе. Пожалуйста, укажите другую сумму или пополните средства',
                min: 'Количество токенов должно быть не меньше {{limit}} {{coin}}',
                maxStack:
                    'Количество токенов должно быть не больше {{limit}} {{coin}}',
            },
            maxBoost:
                'Инвестируйте {{amount}} {{coin}} чтобы получить {{boost}}% буста',
            maxBoostModal: {
                title: 'Получите максимальный буст',
                text: 'Выберите предложенную сумму и получите максимально возможный буст!',
                button: 'Добавить монеты',
                deposit: {
                    title: 'Оптимальный депозит = {{amount}} {{coin}}',
                    text: 'Оптимальное кол-во токенов для максимальной доходности. Значение зависит от количества питомцев и их характеристик',
                },
                boost: {
                    title: 'Максимальный ежедневный буст = {{boost}}%',
                    text: 'Ежедневный буст от инвестирования оптимального депозита. Буст будет пересчитываться каждый день в зависимости от характеристик ваших питомцев. Вы всегда можете добавить токены, если это необходимо!',
                },
            },
        },
        dailyBoostScreen: {
            title: 'Ежедневный буст',
            headerTitle: 'Ежедневный буст = ',
            headerText:
                'Буст будет действовать определенный период времени, после которого вы сможете забрать токены',
            button: 'Подтвердить',
            confirmationModal: {
                title: 'Подтвердить',
                keys: {
                    from: 'С кошелька',
                    duration: 'План',
                    endingOn: 'Окончание',
                    dailyBoost: 'Ежедневный буст',
                    summary: 'Сумма',
                },
                values: {
                    from: 'Основной кошелек',
                    duration: '{{plan}}, {{days}} Дней',
                },
            },
        },
        successScreen: {
            title: 'Буст включен',
            text: 'Ваши токены заблокированы, и они будут храниться в контракте до конца плана. После окончания плана вам необходимо воспользоваться кнопкой "Получить токены", чтобы вернуть токены в свой кошелек',
            button: 'Перейти в кошелек',
        },
        successUnStakeScreen: {
            title: 'Буст прекращен',
            text: 'Вы успешно разблокировали токены. Токены возвращены в ваш основной кошелек',
            button: 'Перейти в кошелек',
        },
        alreadyScreen: {
            title: 'Буст',
            headerTitle: 'Детали плана',
            headerText:
                'Вы инвестировали свои токены, и они будут храниться до конца плана. После завершения плана токены могут быть выведены на основной кошелек',
            headerInfoText: 'Как это работает?',

            confirmationModal: {
                title: 'Подтвердить транзакцию',
                keys: {
                    from: 'На кошелек',
                    duration: 'Продолжительность',
                    endingOn: 'Окончен',
                    dailyBoost: 'Ежедневный буст',
                    summary: 'Всего',
                },
                values: {
                    from: 'Кошелек для вознаграждений',
                    duration: '{{plan}}, {{days}} Дней',
                },
            },
            staked: {
                title: '{{coin}} Буст',
                text: 'Активный план. Вы можете добавить больше токенов',
                timerTitle: 'Оставшееся время',
                staking: 'Буст:',
                deposit: 'Начало:',
                end: 'Конец:',
                boost: 'Ежедневный буст:',
                summary: 'Сумма:',
                buttonAdd: 'Добавить больше токенов',
                buttonUpgrade: 'Улучшить план',
                buttonUnstake: 'Получить токены',

                modalAddCoins: {
                    title: 'Добавить еще токенов?',
                    text: 'После того, как вы добавите токены, ваш вариант буста будет пересчитан на основе внесенной суммы, и таймер перезапустится',
                    button1: 'Добавить токены',
                    button2: 'Отмена',
                },
                modalUpgrade: {
                    title: 'Обновить план?',
                    text: 'После того, как вы улучшите вариант буста, он будет пересчитан на основе внесенной суммы, и таймер перезапустится',
                    button1: 'Обновить',
                    button2: 'Отмена',
                },
            },
        },
    },
    timer: {
        captions: { day: 'Дни', hour: 'Часы', min: 'Мин', sec: 'Сек' },
        newDay: 'Новый день',
        refreshed: 'Ваши задания обновлены',
    },
    referrals: {
        myReferrer: 'Вы ввели реферальный код этого пользователя',
        referralCode: 'Ваш реф. код',
        referralLink: 'Реф. ссылка',
        header: {
            title: 'Пригласить друзей',
            text: 'Приглашайте других пользователей и зарабатывайте еще больше благодаря нашей реферальной программе',
            infoText: 'Как это работает?',
        },
        direct: {
            title: 'Прямой реферал - {{directPercentage}}%',
            text: 'Вы будете получать {{directPercentage}}% от всех вознаграждений, заработанных друзьями',
        },
        indirect: {
            title: 'Косвенный реферал - {{inDirectPercentage}}%',
            text: 'Вы будете получать {{inDirectPercentage}}% от всех вознаграждений, заработанных друзьями друзей',
        },
        gaming: {
            title: 'Игровые бонусы',
            text: 'Реферальные бонусы действуют как для PvP-игр, так и для игровых заданий',
        },
        buttonShare: 'Пригласить пользователей',
        invitedReferrals: {
            card: {
                direct: 'Прямые рефералы',
                indirect: 'Косвенные рефералы',
                active: 'Активные рефералы (прямые)',
                turnover: 'Общий оборот',
            },
            viewReward: 'Посмотреть вознаграждения',
            indirectModal: {
                title: 'Косвенное направление',
                text: 'Этот пользователь был приглашен одним из ваших друзей',
            },
            header: {
                title: 'Приглашенные рефералы',
                text: 'Здесь вы можете увидеть всех приглашенных рефералов и ваш ежедневный буст, если вы выполнили все условия',
                infoText: 'Как работают бустеры?',
                list: 'Приглашенные',
                sort: 'Сортировать',
                filter: {
                    CreatedAt: 'Последние',
                    UserEnergy: 'Энергия',
                },
            },
        },
        emptyScreen: {
            title: 'Упс!',
            text: 'Что-то не так. Но не волнуйтесь, это будет быстро исправлено. Попробуйте позже',
        },
        emptyList: {
            title: ' Пока нет приглашенных рефералов',
            text: 'Вы еще не пригласили ни одного пользователя. Но это не проблема, давайте сделаем это прямо сейчас',
        },
        allInvitedReferralsScreen: { title: 'Все приглашенные рефералы' },
        inviteUsersScreen: {
            title: 'Пригласить пользователя',
            text: 'Скачайте приложение IguVerse и укажите реферальный код',
            myNFT: 'Мой NFT-питомец',
            collectedEnergy: 'Собранная энергия',
            leaderBoard: 'Место в таблице лидеров',
            button: 'Поделиться кодом',
            download: 'Скачать приложение IguVerse',
        },
        referralCard: {
            title: 'Введите реф. код',
            text: 'Введите код вашего друга, чтобы получить доп. бонусы',
            button: 'Введите код',
        },
        referrerModal: {
            title: 'Реферальный код',
            text: 'Введите код реферала и вы получите различные скидки и бонусы',
            label: 'Реферальный код',
            placeHolder: 'Введите реферальный код ',
            noCode: 'У вас нет кода? ',
            apply: 'Узнать больше',
            button: 'Отправить',
            success: {
                toastSuccess: {
                    title: 'Представленный реферальный код',
                    text: 'Теперь все функции доступны для вас',
                },
            },
            error: {
                empty: 'Реф. код не может быть пустым',
                incorrectCode:
                    'Неверный код. Реферальный код не существует или его срок действия истек',
                toastError: {
                    title: 'Неправильный код',
                    text: 'Реферальный код не существует или его срок действия истек',
                },
                forbidden:
                    'Невозможно использовать реферальный код на этом устройстве',
                toastForbidden: {
                    title: 'Запрещено',
                    text: 'Невозможно использовать реферальный код на этом устройстве',
                },
                toastAlreadyLinked: {
                    title: 'Уже используется',
                    text: 'Реферальный код уже использован в вашем аккаунте',
                },
            },
        },
        boostCards: {
            cardTitle: 'Ежедневный буст = {{boost}}%',
            cardText: 'Приглашенных ',
            users: ' Друзей',
            text: 'Чем больше друзей вы пригласите, тем больше ежедневных бонусов вы получите',
            button: 'Посмотреть бонусы',
        },
        howBoostWorks: {
            title: 'Получите буст к наградам за задания',
            text: 'Приглашайте пользователей и получайте прибавку к наградам за ежедневные задания после достижения определенного количества приглашенных друзей',
            alert: 'Бустер считается каждый день и действует только для активных рефералов, которые играют каждый день и достигают {{rewardEnergyThreshold}} Энергии',
        },
        modalReferee: {
            title: 'Познакомьтесь с вашим рефералом',
            text: 'Вы можете посетить социальные сети приглашенного пользователя, чтобы узнать больше о реферале или познакомиться с ним',
            energy: 'Собранная энергия (24ч)',
        },
    },
    aiQuoteInfo: {
        alertCard: {
            overload: { title: 'Система перегружена' },
            dailyAttempts: { title: 'Осталось попыток {{attempts}}' },
        },
        modalInfo: {
            title: 'NFT из вашего воображения',
            text: 'Вы можете создать NFT с помощью технологии ИИ, но эта операция дорогостоящая. Иногда из-за высокой нагрузки система может быть временно недоступна',
            daily: 'Использование за последние 24 часа = ',
            dailyText:
                'За 24-часовой период вы можете создать не более {{amount}} уникальных питомцев с помощью технологии искусственного интеллекта',
            systemLoad: 'Нагрузка на систему = {{load}}',
            systemLoadText:
                'Иногда система может быть перегружена из-за большого спроса. Вам придется немного подождать',
            load: {
                low: 'Низкая',
                medium: 'Средняя',
                high: 'Высокая',
                overloaded: 'Перегружена',
            },
            systemUsage: 'Использование системы = {{percentage}}%',
            systemUsageText:
                'Система находится в бета-версии и в настоящее время доступно только определенное кол-во попыток в день',
        },
        modalErrorNoMints: {
            title: 'Минтов не осталось',
            text: 'К сожалению, все попытки на сегодня израсходованы. Но не волнуйтесь, вы можете попробовать создать NFT с помощью технологии AI завтра',
            button1: 'Создать из фотографии',
        },
        modalErrorOverLoad: {
            title: 'Система перегружена',
            text: 'К сожалению, наша система ИИ сейчас перегружена из-за большего кол-ва запросов других пользователей. Вскоре она будет снова доступна, попробуйте еще раз позже',
            button1: 'Создать из фотографии',
        },
    },
    howTo: {
        fee: {
            stepOne: {
                title: 'Комиссия сети приблизительна',
                text: 'Все транзакции в приложении выполняются на блокчейне и имеют комиссию в BNB. Размер комиссии может быть определен только в момент выполнения транзакции, и мы показываем лишь приблизительную оценку',
            },
            stepTwo: {
                title: 'Комиссия за другие токены',
                text: 'В блокчейне вы должны одобрить использование токенов перед выполнением определенной транзакции. Для оплаты, используя BNB, потребуется только одна транзакция, в то время как для расходования других токенов требуется две транзакции: одобрение и выполнение',
            },
        },
        charity: {
            stepOne: {
                title: 'Помощь организациям по защите животных',
                text: 'Вы можете выбрать благотворительную организацую из списка и пожертвовать свой доход, чтобы помочь животным во всем мире',
            },
            stepTwo: {
                title: 'Установить предпочтительный процент',
                text: 'Вы можете выбрать процент от вознаграждения, который будет пожертвован (от 1% до 100%). Также вы можете изменить это значение в любое время',
            },
        },
        play: {
            button: 'Начать играть',
            stepOne: {
                title: 'Выберите питомцев для выполнения заданий',
                text: 'Выберите в разделе ниже питомцев, которые будут участвовать в игре. Первый питомец из выбранных будет использоваться в Социальном задании и будет отображаться как ваш главный питомец.',
            },
            stepTwo: {
                title: 'Восстановление энергии',
                text: 'У вас есть 24 часа, чтобы восстановить уровень Энергии, выполнив задания до конца дня. 100% Энергии означает, что вы заработаете 100% от максимально возможного вознаграждения, основанного на статистике питомцев. Каждый день, когда таймер достигает 00:00, уровень энергии сбрасывается',
            },
            stepThree: {
                title: 'Зарабатывайте вознаграждения',
                text: 'После окончания игрового раунда ваша энергия, полученая в заданиях, будет конвертирована в награды, в зависимости от характеристик ваших питомцев',
            },
            stepFour: {
                title: 'Повысьте показатели своих NFT',
                text: 'Повышайте уровень своих питомцев, заводите новых питомцев, повышайте ранги, чтобы получить больше наград. Добейтесь наивысшей позиции в таблице лидеров и получите еще больше',
            },
        },
        referrals: {
            button: 'Пригласить пользователей',
            stepOne: {
                title: 'Поделитесь своим реферальным кодом',
                text: 'Приглашайте пользователей в приложение IguVerse и зарабатывайте на их игре. За прямых рефералов вы получите - {{direct}}%, а за косвенных рефералов - {{inDirect}}%',
            },
            stepTwo: {
                title: 'Получите буст к выполнению ежедневных задач',
                text: 'Приглашайте пользователей и получайте буст к ежедневным заданиям после достижения определенного количества приглашений. Подробности на вкладке "Мои рефералы"',
            },
            stepThree: {
                title: 'Получайте больше скидок',
                text: 'В разделе "Ваши питомцы" выберите минимум одного питомца для участия в игре. Имейте в виду, что первый NFT собирает наибольшее кол-во опыта',
            },
            stepFour: {
                title: 'Получайте игровые бонусы',
                text: 'За каждую выигранную игру и за каждое пополнение прямые рефералы будут давать вам {{direct}}% от суммы, а непрямые рефералы — {{inDirect}}%',
            },
        },
        availableRewards: {
            stepOne: {
                titleOne: 'Получите ',
                titleTwo: ' от ваших вознаграждений',
                text: 'Вы можете перевести {{percent}}% доступных вознаграждений VIGUP на свой основной кошелек. После получения токен можно обменять, отправить на другой кошелек или вывести',
            },
            stepTwo: {
                title: 'Конверсия',
                text: 'Клейм - это операция на блокчейне, которая дает вам возможность конвертировать ваш баланс VIGUP в основной кошелек IGUP. После успешной транзакции средства будут доступны в основном кошельке',
            },
            stepThree: {
                title: 'Обменять IGUP на ',
                text: 'Вы сможете обменять заработанные токены на токены IGUAI после выхода торговой площадки. Использование приложения позволит вам стать одним из первых ранних пользователей нашего решения верхнего уровня',
            },
            stepFour: {
                title: 'Отрицательный баланс',
                text: 'Иногда ваш доступный баланс может быть отрицательным, что означает, что вы использовали заблокированные награды для различных внутриигровых транзакций, таких как лечение и повышение уровня. Мы позволяем вашим доступным вознаграждениям опускаться ниже нуля, вплоть до стоимости вашего заблокированного баланса. Как только вы разблокируете токены, доступный баланс также увеличится',
            },
            alert: 'Остальные токены VIGUP заморожены и будут храниться в заблокированном кошельке',
        },
        lockedRewards: {
            stepOne: {
                title: 'Заблокированные награды',
                text: 'Заработанные награды блокируются в соответствии со статистикой питомца (ранг и уровень). Улучшайте своих питомцев, чтобы уменьшить период блокировки',
            },
            stepTwo: {
                title: 'Конвертация в доступные вознаграждения',
                text: 'Заблокированные вознаграждения разблокируются автоматически и после разблокировки будут доступны в разделе "Доступный баланс вознаграждений"',
            },
            stepThree: {
                title: 'Обменять IGUP на ',
                text: 'Вы сможете обменять заработанные токены на токены IGUAI после выхода торговой площадки. Использование приложения позволит вам стать одним из первых ранних пользователей нашего решения верхнего уровня',
            },
        },
        socializeToEarn: {
            CONFIRMED: 'Правильно',
            FAILED: 'Неправильно',
            step: {
                title: 'Добавление ссылки на IguVerse',
                text: 'Всегда добавляйте ссылку на приложение IguVerse, которое можно найти на экране социального задания, при публикации Pet ID. Ссылка должна быть прикреплена к самой истории.',
            },
            stepOne: {
                title: 'Pet ID и ссылка полностью видимы',
                text: 'Информация на Pet ID и ссылка должны быть легко распознаваемыми. Ссылка на приложение должна быть активной',
            },
            stepTwo: {
                title: 'Небольшие модификации допускаются',
                text: 'Вы можете изменить размер и цвет Pet ID или его наклон. Естественно, эти модификации не должны противоречить первому правилу',
            },
            stepThree: {
                title: 'Pet ID трудно разобрать',
                text: 'Мы не допускаем никаких модификаций Pet ID, включая обрезку и скрытие изображения или его частей. Пролистните, чтобы узнать больше',
            },
            stepFour: {
                title: 'Pet ID спрятан',
                text: 'Не допускается наложение или закрашивание изображения, а также чрезмерное его уменьшение',
            },
        },
        verifyUser: {
            stepOne: {
                title: 'Найти идентификатор питомца в социальных сетях',
                text: 'Проследите за аккаунтом другого пользователя в социальных сетях, проверьте контент и найдите Pet ID. Введите код в приложении и выполните задание',
            },
            stepTwo: {
                title: 'Найдите Pet ID',
                text: 'Введите код из Pet ID или отсканируйте его с помощью сканера QR-кодов. Если его нет, нажмите кнопку что Pet ID не найден. Найдите всех пользователей для выполнения задания',
            },
            stepThree: {
                title: 'Будьте ответственным',
                text: 'Играйте честно и не пытайтесь мошенничать, вводя систему в заблуждение, предоставляя неверные идентификаторы или утверждая, что вы не можете найти. Ваш аккаунт может быть отмечен или заблокирован, если вы продолжите делать это',
            },
        },
        purchaseBNB: {
            screenTitle: 'Как купить BNB',
            title: 'Купить BNB на Binance',
            text: 'BNB — это криптовалюта, которая используется для оплаты комиссий в Binance Smart Chain, блокчейне, который мы используем. Посмотрите видео ниже, чтобы узнать больше о внесении BNB во внутриигровой кошелек',
            guideBlock: {
                title: 'Руководство по покупке и выводу средств',
                first: 'Войдите в приложение Binance. Скачайте, зарегистрируйтесь и пройдите верификацию, если у вас его нет',
                second: 'Купите крипту картой или с помощью p2p. Вы можете сразу выбрать BNB!',
                third: 'Откройте вкладку «Кошелек» и нажмите «Вывод»',
                fourth: 'Выберите криптовалюту, которую хотите вывести. В нашем случае BNB',
                fiveStepOne:
                    'Вставьте адрес, на который хотите вывести средства, и выберите сеть: ',
                fiveBold: 'BNB Smart Chain (BEP-20)',
                fiveStepTwo:
                    '. Адрес вашего кошелька можно найти на вкладке кошелька в приложении IguVerse. Он начинается с 0x и представляет собой комбинацию букв и цифр',
                six: 'Подождите несколько секунд, пока транзакция будет обработана, и все готово!',
            },
            resourceBlock: {
                title: 'Полезные ресурсы',
                buy: 'Руководство по покупке BNB (BNB)',
                withdraw: 'Вывод средств с Binance',
                status: 'Как проверить статус транзакции в блокчейнах разных криптовалют',
            },
        },
        petOrderId: {
            title: 'Выберите порядок питомцев',
            text: 'Выберите игровых питомцев в разделе «NFT to Play» и расставьте остальных по-порядку! Порядок питомцев будет определять получаемый ими опыт',
            cardFeatureInfo: {
                title: 'Приоритет питомцев',
                text: 'Первый игровой питомец будет представлять вас в вашем Pet ID, в голосовании, в таблице лидеров',
            },
            button: 'Изменить порядок',
        },
        howToGamingAvailableWallet: {
            screenTitle: 'Доступный кошелек',
            button: 'Пополнить',
            stepOne: {
                title: 'Играйте в соревновательные игры',
                text: 'Игровой кошелек позволяет соревноваться с другими игроками и выигрывать IGU. Используйте вкладку «Игры», чтобы увидеть доступные игры',
            },
            stepTwo: {
                title: 'Пополнить игровой кошелек',
                text: 'Чтобы принять участие, пополните свой игровой кошелек на IGU и получите VIGU. Используйте кнопку ниже, чтобы пополнить счет токенами',
            },
            stepThree: {
                title: 'Вывод на основной кошелек',
                text: 'Награды, выигранные в соревновательных играх, будут храниться в игровом кошельке. Вы можете вывести эти вознаграждения на основной кошелек в любое время',
            },
            stepFour: {
                title: 'Получайте бонусы от рефералов',
                text: 'За каждую выигранную игру и за каждое пополнение прямые рефералы будут давать вам {{direct}}% от суммы, а непрямые рефералы — {{indirect}}%',
            },
        },
        howToGamingPendingWallet: {
            screenTitle: 'Кошелек ожидания',
            alert: 'Токены в кошельке заморозки не контролируются IguVerse и заблокированы в смарт-контракте на протяжении игры',
            stepOne: {
                title: 'Заморозка во время игры',
                text: 'Средства в игровом кошельке будут заморожены до тех пор, пока вы не закончите игру. Эта мера введена для предотвращения мошенничества',
            },
            stepTwo: {
                title: 'Автоматическая разморозка',
                text: 'Если вы выиграли игру, ваши средства будут автоматически возвращены в игровой кошелек. В противном случае они будут переданы победителю',
            },
        },
        howToCommissionFee: {
            screenTitle: 'Комиссия',
            stepOne: {
                title: ' Комиссия',
                text: 'Мы взимаем комиссию в размере {{commission}}% за каждый вывод средств из игрового кошелька',
            },
            stepTwo: {
                title: 'Улучшенная токеномика',
                text: 'PvP-игры используют экономическую модель пула, которая превосходит экономику большинства проектов GameFi. Комиссия списывается для дальнейшего укрепления экономики',
            },
        },
        HowToCollections: {
            stepOne: {
                title: 'Виртуальный питомец-компаньон',
                text: 'Создайте NFT-питомца с помощью ИИ, который поможет вам зарабатывать в соцсетях. Вы также можете загрузить фотографию своего питомца для создания NFT',
            },
            stepTwo: {
                title: 'Восстановление энергии',
                text: 'У вас есть 24 часа, чтобы восстановить уровень Энергии, выполнив задания до конца дня. 100% Энергии означает, что вы заработаете 100% от максимально возможного вознаграждения, основанного на статистике питомцев. Каждый день, когда таймер достигает 00:00, уровень энергии сбрасывается',
            },
            stepThree: {
                title: 'Обменять IGUP на ',
                text: 'Вы сможете обменять заработанные токены на токены IGUAI после выхода торговой площадки. Использование приложения позволит вам стать одним из первых ранних пользователей нашего решения верхнего уровня',
            },
        },
    },
    energyInfoScreen: {
        title: 'Обменивайте собранную Энергию на токены',
        text: 'Ваш курс обмена Энергии/IGUP зависит от количества питомцев, рангов, уровней и других модификаторов, таких как буст',
        button: 'Начать играть',
        features: {
            first: {
                title: '1 Энергия ≈ {{amount}} IGUP',
                text: 'Это приблизительный обменный курс, который может меняться в зависимости от различных условий',
            },
            second: {
                title: 'Минимальный порог = {{energy}}',
                text: 'Если вы не достигли минимального порога {{energy}} Очков энергии, половина ваших очков энергии будет сожжена, а другая половина перенесена на следующий день',
            },
        },
    },
    initial: {
        initialMint: {
            title: 'Создайте своего первого питомца и начните Ваше путешествие в IguVerse',
            text: 'Это последний шаг перед тем как начать Ваше приключение в IguVerse. Выберите своего питомца, и наслаждайтесь ежедневными вознаграждениями за активность с ним',
            button: 'Заведите питомца',
        },
        initialReferral: {
            title: 'Наслаждайтесь бонусами и скидками',
            text: 'Вы были приглашены в приложение IguVerse, наслаждайтесь дополнительными бонусами и скидками. Поспешите создать своего вирутального питомца',
            button: 'Дальше',
        },
    },
    ModalShareOrSave: {
        title: 'Сохранить содержимое',
        text: 'Сохраняйте любимые материалы IguVerse в галерею или делитесь ими с друзьями',
        save: 'Сохранить в галерею',
        share: 'Поделиться',
        loading: 'Подготовка контента..',
        saveSuccess: 'Содержимое сохранено в галерею',
    },
    RelatedApps: {
        downloadApp: {
            titleiOS: 'Приложение доступно для IOS',
            titleAndroid: 'Приложение доступно для Android',
            description: 'Скачайте приложение для удобства',
            buttonOk: 'Загрузить',
            buttonCancel: 'Закрыть',
        },
        switchToApp: {
            titleiOS: 'Приложение доступно для IOS',
            titleAndroid: 'Приложение доступно для Android',
            description: 'Перейдите в приложение для удобства',
            buttonOk: 'Перейти',
            buttonCancel: 'Закрыть',
        },
    },
    ShareYourFeedback: {
        title: 'Поделиться отзывом',
        text: 'Вы можете поделиться с нами своим отзывом, и, отправив эту форму, вы отправите нам логи, чтобы мы могли помочь определить вашу проблему',
        placeholder: 'Подробно опишите свою проблему',
        button: 'Отправить',
        loading: 'Отправка..',
        accessibility:
            'Отключить функцию «отправлять обратную связь при встряхивании»',
    },
    ModalMainnet: {
        title: 'Функция недоступна',
        text: 'Эта функция недоступна до тех пор, пока IGU не начнет торговаться на биржах. Точная дата выхода на биржу будет объявлена в ближайшее время',
        button: 'OK',
    },
    ModalDailyRewards: {
        [DAILY_REWARD_STATUS.Bonus]: {
            title: 'Начислен PvP-бонус',
            text: 'За вашу активность в PvP-играх вы получили бонус.Токены уже в вашем игровом кошельке',
        },
        [DAILY_REWARD_STATUS.Daily]: {
            title: 'Вы получили свои награды!',
            text: 'Вам начислены награды за выполнение вчерашних заданий!',
        },
        [DAILY_REWARD_STATUS.Both]: {
            title: 'Вы получили ежедневную награду и PvP-бонус',
            text: 'Награды за выполнение заданий уже начислены и начинают разблокироваться! Вы также получили бонусные токены за участие в PvP-играх',
        },
        dailyReward: {
            title: 'Доступно {{availableAmount}} / {{totalAmount}} IGUP',
            text: '{{availableAmount}} IGUP доступно сразу в вашем кошельке',
        },
        unlocks: {
            title: 'Замороженные токены',
            text: '{{restAmount}} IGUP будут постепенно размораживаться в течение периода разблокировки',
        },
    },
    MintBonusScreen: {
        mintSuccess: { title: 'Бонусная программа', text: 'Бонус за минт' },
        BonusMintRanksDetailedInfoScreen: {
            title: 'Минт NFT - Получите мгновенный бонус IGUP',
            text: 'Мы предлагаем вам сминтить NFT и получить бонус, который вы сможете вывести в будущем. Перейдите к следующему шагу и завершите процесс минтинга',
            button1: 'Перейти к следующему шагу',
            button2: 'Посмотреть все бонусы',
            timeRemaining: 'Оставшееся время',
            features: {
                bonus: {
                    key: 'Бонус за ранг = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Токены, которые будут зачислены на ваш счет после успешного минта',
                },
                lock: {
                    key: 'Период блокировки = {{days}} Дней',
                    value: 'Токены будут доступны для снятия после окончания периода блокировки',
                },
            },
        },
        BonusMintRanksCarouselScreen: {
            screenTitle: 'Бонус за ранг',
            title: '{{slug}} Ранг',
            button1: 'Выберите ранг',
            features: {
                bonus: {
                    key: 'Бонус за ранг = {{amount}} IGUP (${{dollarValue}})',
                    value: 'Токены, которые будут зачислены на ваш счет после успешного минта',
                },
                lock: {
                    key: 'Период блокировки = {{days}} Дней',
                    value: 'Токены будут доступны для снятия после окончания периода блокировки',
                },
            },
        },
    },
    YourPetsAreHungry: {
        title: 'Ваши питомцы проголодались!',
        text: 'Потерянное здоровье уменьшит ваши награды и может через некоторое время сделать ваши NFT непригодными для использования в приложении. Кормите своих питомцев, чтобы стабильно зарабатывать!',
    },
    priceUpModal: {
        title: 'Увеличение цен на ',
        text: 'В связи с высоким спросом и быстрым ростом проекта наша команда решила поднять цены на NFT, чтобы вознаградить первых пользователей и убедиться, что экономика остается устойчивой и сбалансированной в долгосрочной перспективе',
        priceUpdate: 'Повышение цен через',
        button: 'Создать питомца',
    },
    updateModal: {
        banner: {
            title: 'Вышло новое обновление!',
            text: 'Проверьте новую {{version}} версию приложения',
        },
        screen: {
            screenTitle: 'Новое обновление',
            title: 'Вышло новое обновление!',
            text: 'Команда IguVerse усердно работает над улучшением приложения и разработкой новых функций. Наслаждайтесь следующими улучшениями в новой версии{{version}}',
            button: 'Начать играть',
        },
    },
    communityModal: {
        title: 'Получите помощь от нашего сообщества',
        text: 'Присоединяйтесь к нашим официальным чатам сообщества, чтобы получить ответы на свои вопросы от других игроков. Узнайте, как играть, максимизируйте свою прибыль и наслаждайтесь IguVerse вместе!',
        button1: 'Посмотреть остальные',
        button2: 'Больше не показывать',
    },
    socialTooltip: {
        text: 'Нажмите на тег «Не удалось, чтобы узнать, почему ваша учетная запись или Pet ID не соответствуют нашим критериям и были отклонены. Вы также сможете получить доступ к базе знаний, чтобы узнать, что это за критерии',
    },
    gameIterationText: {
        text: 'Сейчас подсчитываются вчерашние награды, что обычно занимает около {{minutes}} минут. Вы сможете играть снова, когда награды будут подсчитаны',
        toastErrorTitle: 'Сейчас подсчитываются вчерашние награды',
    },
    howConnectFacebookModal: {
        info: 'Как подключиться',
        screenTitle: 'Как подключить Facebook',
        title: 'Поиск Facebook ID',
        text: 'Чтобы подключить свою учетную запись Facebook, вам необходимо найти и скопировать свой Facebook ID. Зайдите на страницу своего профиля в Facebook и скопируйте часть ссылки после / — это и будет ваш Facebook ID',
        button: 'Подключить аккаунт',
    },
    listingIgu: {
        iguListing: 'IGU Листинг',
        title: ' готовится к листингу на ',
        textOne: 'Листинг на бирже {{exchange}} состоится ',
        textTwo:
            '. Пристегните ремни, Игуаны, — набираем скорость перед полетом',
        button: 'Перейти к бирже',
        listed: {
            title: ' торгуется на ',
            text: 'Наконец-то состоялся долгожданный запуск IGU — и это только начало нашей космической одиссеи! Покупайте и торгуйте IGU на бирже {{exchange}} прямо сейчас',
        },
    },
    bybitVote: {
        title1: 'Проголосуйте за IGU на ByBit и разделите ',
        title2: '!',
        text: 'IguVerse был выбран для участия в программе ByVotes — проект, набравший наибольшее количество голосов, появится на ByBit!',
        banner: {
            title1: 'Проголосуйте и разделите ',
            title2: '',
        },
        button: 'Подробнее',
    },
    howToPurchaseIGU: {
        modalTitle: 'Как купить IGU',
        exchangesModalTitle: 'Купить IGU на биржах',
        cardDeposit: {
            title: 'Ввод',
            text: 'Вы можете внести поддерживаемые токены из любого BSC BEP-20 кошелька',
        },
        cardExchange: {
            title: 'Купить на биржах',
            text: 'Покупайте и торгуйте IGU на биржах, на которых прошел листинг',
        },
        cardTrade: {
            title: 'Торгуйте в приложении',
            text: 'Быстро и удобно обменивайте IGU прямо в приложении',
        },
    },
    howToClaimFreePet: {
        title: 'Купите NFT для получения наград',
        text: 'Вы не можете получить награды, так как в вашей учетной записи нет NFT. Бесплатный питомец — это не NFT, поскольку он не находится на блокчейне. Покупка NFT-питомца или повышение ранга уже существующего даст вам доступ к наградам',
        alert: 'Мы храним информацию о всех ваших наградах, и вы сможете получить их после покупки NFT',
        button: 'Минт новой NFT',
    },
    howToClaimOnButton: {
        titleOne: 'Получите ',
        titleTwo: ' от ваших вознаграждений',
        text: 'Вы можете перевести {{percent}}% доступных вознаграждений VIGUP на свой основной кошелек. После получения токен можно обменять, отправить на другой кошелек или вывести',
        alert: 'Остальные токены VIGUP заморожены и будут храниться в заблокированном кошельке',
        button: 'Получите ваши вознаграждения',
    },
    onBoarding: {
        mainWallet: {
            title: 'Основной кошелек',
            stepOne: {
                title: 'Вся ваша криптовалюта здесь',
                text: 'В этом кошельке хранятся все поддерживаемые токены, доступные в вашей учетной записи. Неподдерживаемые токены не отображаются. Все ваши награды будут здесь после клейма',
            },
            stepTwo: {
                title: 'Навигация между кошельками',
                text: 'На вкладке «Основной кошелек» вы можете открыть все другие кошельки, доступные в вашей учетной записи, проведя пальцем по экрану. К остальным кошелькам отноятся кошелек NFT, кошелек вознаграждения и игровой кошелек',
            },
        },
        login: {
            stepOne: {
                title: 'Новый способ заработать криптовалюту',
                text: 'Превратите свою ежедневную рутину в соцсетях в способ заработка! Делитесь контентом, гуляйте и играйте в аркадную игру, получая награды',
            },
            stepTwo: {
                title: 'Виртуальный питомец-компаньон',
                text: 'Создайте NFT-питомца с помощью ИИ, который поможет вам зарабатывать в соцсетях. Вы также можете загрузить фотографию своего питомца для создания NFT',
            },
            stepThree: {
                title: 'Соревновательные игры',
                text: 'Хотите зарабатывать намного больше? Бросайте вызов другим игрокам в наших PvP-режимах и выигрывайте по-крупному',
            },
            stepFour: {
                title: 'Пожертвования для животных',
                text: '1% ваших ежедневных наград идет на защиту животных. Вы можете увеличить размер пожертвования в приложении',
            },
            stepFive: {
                title: 'Будущие продукты',
                text: 'Приложение является лишь первым продуктом в серии. Станьте одним из первых пользователей нашей торговой площадки на базе искусственного интеллекта и децентрализованной рекламной сети после их выхода',
            },
        },
    },
    HomeScreen: {
        MemsModal: {
            title1: 'Эйрдроп на сумму ',
            title2: ' в Дискорде MemeFi!',
            text: 'Команда MemeFi недавно запустила кампанию по раздаче NFT в Дискорде. За выполнение простого задания вы получите билеты на NFT с вшитым эйрдропом $MEMF',

            button1: 'Открыть Дискорд',
            button2: 'К сайту',
            banner: {
                title: '$450.000 Эйрдроп',
                text: 'Команда MemeFi недавно запустила кампанию по раздаче NFT в Дискорде',
            },
        },
        exploreGames: 'Исследовать игры',
        minimalBet: {
            title: 'Минимальная ставка = {{amount}}',
            text: 'Наименьшая сумма, на которую вы можете сыграть',
        },
        WelcomeHeader: {
            title: 'Добро пожаловать!',
            text: 'Играйте и зарабатывайте криптовалюту каждый день',
        },
        ModalGameComingSoon: {
            title: 'Игра скоро выйдет',
            text: 'Наша команда усердно работает над новой PvP-игрой, и она скоро будет выпущена. Попробуйте другие захватывающие игры в нашей библиотеке!',
        },
        GamesBlock: {
            header: 'Соревновательные игры',
            button: 'Играть',
            buttonContinue: 'Продолжить играть',
            buttonComingSoon: 'Скоро...',
            orders: '{{orders}} Комнат',
            games: {
                [MYSTERY_GAMES.mysteryLikes]: {
                    title: 'Загадочные лайки',
                    text: 'Угадайте количество лайков у NFT',
                },

                [MYSTERY_GAMES.nftRoyal]: {
                    title: 'Фруктовая гонка',
                    text: 'Устремитесь к победе на фруктово-ягодном пути',
                },
                [MYSTERY_GAMES.nftEvolution]: {
                    title: 'NFT - эволюция',
                    text: 'Скрещивайте NFT и получайте их более мощные версии',
                },
                [MYSTERY_GAMES.luckyStrike]: {
                    title: 'Лаки Страйк',
                    text: 'Приобретайте билеты, чтобы ухватить удачу и забрать все в игре, в которой правит фортуна',
                },
                [MYSTERY_GAMES.quantumSpin]: {
                    title: 'Квантовый диск',
                    text: 'Крути квантовое колесо, чтобы поймать удачу',
                },
                [MYSTERY_GAMES.tokenteller]: {
                    title: 'Игумания',
                    text: 'Берите свой магический шар и угадывайте будущую цену IGU',
                },
                socialProof:
                    '{{amount}} выиграли прямо сейчас в PvP-игре {{game}}',
            },
        },
        GamesFeatures: {
            orders: 'Свободные игровые комнаты',
            prizePool: 'Общий призовой фонд',
            turnover: 'Оборот в {{coin}}',
            totalSlots: 'Всего раундов',
        },
        VacantRoomsEmpty: {
            title: 'Нет свободных игр',
            text: 'На данный момент игровых запросов нет. Вы хотите создать его? Любой игрок сможет бросить вам вызов',
        },
        EmptyGameHistory: {
            title: 'Игр нет',
            text: 'Вы ни разу не участвовали в играх и не создавали их. Создайте игру сейчас и бросьте вызов случайному игроку!',
        },
        GamesNavigationBar: {
            ORDERS: 'Свободные комнаты',
            HISTORY: 'История',
            ROUNDS: 'Раунды',
            WHEEL: 'Диск',
        },
        ActiveOrdersFilters: {
            title: 'Свободные комнаты',
            modalTitle: 'Сортировать по',
            Newest: 'Самый новый',
            Oldest: 'Самый старый',
            Highest: 'Самый высокий приз',
            Lowest: 'Самый низкий приз',
        },
        ConfirmPlayModal: {
            title: 'Играть на ',
            title2: 'Повернуть за ',
            text: 'Присоединяясь к игре, вы подтверждаете, что указанный депозит будет переведен на кошелек ожидания',
        },
        GamesCreateWelcome: {
            screenTitle: 'Создать "{{game}}" игру',
            title: 'Бросьте вызов другим',
            text: 'Создайте игру с предпочтительной ставкой и завершите ее, чтобы другие игроки могли принять ваш вызов',
        },
        MaxMinimalBetFeature: {
            title: 'Минимальная ставка = {{min}}, Максимальная ставка = {{max}}',
            text: 'Наименьшая и наибольшая суммы, которые можно поставить',
        },
        GameTermination: {
            title: 'Автоматическое завершение = {{days}} Дней',
            text: 'Время, после которого игра истекает, если ни один другой игрок не бросит вам вызов',
            alert: 'Если никто не бросил вам вызов в течение семи дней, игра будет автоматически удалена, а депозит возвращен на ваш баланс',
        },
        EnterCoinsAmountScreen: {
            screenTitle: 'Введите сумму монет',
            error: {
                max: 'Недостаточный баланс, пополнить, чтобы продолжить',
                maxStake:
                    'Максимальная ставка {{amount}}, пожалуйста, уменьшите ставку',
                minStake:
                    'Минимальная ставка {{amount}}, пожалуйста, увеличьте ставку',
                digits: 'Должны быть только цифры',
            },
            confirmTransaction: {
                valueType: 'Создание игры "{{game}}"',
            },
        },
        PreviousGameModal: {
            title: 'Завершить предыдущую игру?',
            text: 'Завершите игру, к которой вы уже присоединились, чтобы другие пользователи могли бросить вам вызов. Игра автоматически исчезнет через {{days}} дней',
            button1: 'Закончить предыдущую игру',
        },
        GameHistoryScreen: {
            title: 'История',
            text: 'Здесь приведена история законченных игр. Вы можете просмотреть их по месяцам',
            status: {
                [MYSTERY_LIKES_STATUS.WaitingForMyself]: 'Ожидание вашего хода',
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: 'Ожидание оппонента',
                [MYSTERY_LIKES_STATUS.Refund]: 'Срок действия игры истек',
            },
        },
        MysteryGamesBanner: {
            oneGame: {
                title: 'Продолжить играть!',
                text: 'Закончите игру "{{game}}"',
            },
            more: {
                title: 'Продолжить играть!',
                text: 'У вас 2 незаконченные игры',
            },
        },
        MysteryGamesContinueModal: {
            title: 'Продолжить играть',
            text: '2 игры не закончено. Дойдите до конца и узнайте результаты',
        },
        MysteryLikes: {
            MysteryLikesHowItWorks: {
                stepOne: {
                    title: 'Угадайте количество лайков',
                    text: 'Каждый игровой раунд состоит из {{gamesAmount}} игр против другого игрока. Угадывайте чаще, чем ваш противник, чтобы выиграть',
                },
                stepTwo: {
                    title: 'Присоединяйтесь и создавайте игры',
                    text: 'Пользователи могут присоединяться к играм и создавать их. При создании игры необходимо выбрать сумму для ставки в токенах VIGU. Присоединяясь к игре, вы соглашаетесь играть на количество токенов, указанное создателем игры',
                },
                stepThree: {
                    title: 'Невозможность читинга',
                    text: 'Пользователи в принципе не могут получить доступ к количеству лайков у NFT. Если вы часто проигрываете, то вам просто не повезло. Поиграйте еще немного, и ситуация обязательно изменится',
                },
            },
            MysteryLikesCreateGameSuccess: {
                title: 'Игра была создана',
                text: 'Вы успешно создали игру! Пожалуйста, завершите раунд, чтобы мы могли сравнить ваши ответы с ответами вашего будущего оппонента',
                button: 'Начать игру',
            },
            MysteryLikesSelectRange: {
                title: 'Выберите диапазон',
                text: 'Выберите подходящий диапазон, в который входит значение с верным количеством лайков',
                button: 'Перейте к следующему изображению',
                toastError: 'Уже проголосовали',
                buttonFinish: 'Закончить игру',
                tooltip1:
                    'NFT вашего оппонента. Вам нужно угадать, сколько у нее лайков. Лайки невидимы ни вам, ни вашему оппоненту',
                tooltip2:
                    'Чтобы выбрать количество лайков, нажмите на одну из карточек и перейдите к следующей картинке с помощью кнопки ниже',
            },
            MysteryLikesSelectRangeFinish: {
                [MYSTERY_LIKES_STATUS.WaitingForOpponent]: {
                    title: 'В ожидании противника',
                    text: 'Вы завершили игру. Теперь ваш противник должен бросить вам вызов и присоединиться к игре. Если противник не завершит ее в течение семи дней, игра будет автоматически прекращена, а ваш депозит возвращен',
                },
                [MYSTERY_LIKES_STATUS.Won]: {
                    title: 'Вы выиграли!',
                    textOne:
                        'Поздравляю! Вам удалось превзойти своего соперника. ',
                    textTwo: ' будут немедленно переведены на ваш кошелек',
                },
                [MYSTERY_LIKES_STATUS.Draw]: {
                    title: 'Ничья!',
                    text: 'Как ни странно, вы оба набрали равное количество очков. Ваша ставка возвращена на ваш кошелек. Хотите сыграть еще один раунд?',
                },
                [MYSTERY_LIKES_STATUS.Lost]: {
                    title: 'Вы проиграли :(',
                    text: 'К сожалению, в этом раунде вашему сопернику удалось переиграть вас. Ваша ставка была переведена на его кошелек. Помните, вы всегда можете победить в следующей игре!',
                },

                statistics: 'Ваша статистика',
                alert: 'Если никто не бросил вам вызов в течение семи дней, игра будет автоматически удалена, а депозит возвращен на ваш баланс',
                likes: 'Лайков',
            },
            MysteryLikesConfirmPlay: {
                warning:
                    'Пользователи в принципе не могут получить доступ к количеству лайков у NFT',
            },

            MysteryLikesLoadingScreen: {
                prepare: {
                    title: 'Подготовка NFT',
                    text: 'Мы тасуем NFT, чтобы вы получили случайный расклад. Напоминаем, что лайки невидимы для игроков! Пожалуйста, подождите немного и не выходите из игры и приложения',
                },
                complete: {
                    title: 'Анализ результатов',
                    text: 'Обработка ваших ответов и ответов вашего оппонента для объявления результатов. Пожалуйста, подождите немного и не выходите из игры и приложения',
                },
            },
        },

        NftEvolution: {
            breedCost: {
                title: 'Стоимость скрещивания{{amount}}',
                text: 'Стоимость следующего ранга NFT, полученного в результате скрещивания, с учетом скидки в 40%',
                alert: 'Получение следующего ранга не гарантировано',
            },
            WelcomeNftEvolution: {
                BestRankToBreed: {
                    title: 'Лучшие комбо рангов',
                    text: 'Cписок лучших комбинаций рангов для скрещивания',
                },
                stepOne: {
                    title: 'Скрестить NFT',
                    text: 'Выберите и скрестите две NFT и получите NFT случайного ранга с определенной вероятностью. Ваши старые NFT не исчезнут!',
                },
                stepTwo: {
                    title: 'ДНК - Клонирование',
                    text: 'Наши высокотехнологичные лаборатории теперь могут брать ДНК мертвых животных и клонировать их! Итак, возьмите пару мертвых NFT и создайте новую. К сожалению, после клонирования здоровье восстановлено не будет',
                },
                stepThree: {
                    title: 'Вероятности рангов',
                    text: 'Узнайте, каковы шансы получить каждый ранг при скрещивании. NFT не обязательно должны иметь один и тот же ранг. Однако у вас есть возможность выиграть NFT любого ранга, в том числе более высокого ранга',
                },
                stepFour: {
                    title: 'Стоимость скрещивания',
                    text: 'Стоимость следующего ранга NFT, полученного в результате скрещивания, с учетом скидки в 40%. Вы получите уникальную NFT, сгенерированный ИИ. Генерация по фото недоступна',
                },
            },
            NftEvolutionSelectPets: {
                text: 'Cписок лучших комбинаций рангов для скрещивания',
                button: 'Рассчитать шансы',
                emptyCard: {
                    first: 'Выберите первую NFT для скрещивания',
                    second: 'Выберите вторую NFT для скрещивания',
                },
                loading: 'Анализ...',
            },
            NftEvolutionSelectPet: {
                title: 'Выбрать NFT',
            },
            NftEvolutionCheckout: {
                title: 'Шансы на скрещивание',
                text: 'Узнайте больше, что вы получите в результате скрещивания',
                button: 'Скрестить за {{amount}}',
                loading: {
                    title: 'NFT скрещиваются',
                    text: 'Пожалуйста, подождите, пока скрещиваются NFT. Не закрывайте приложение и вкладку. Процесс скрещивания обычно занимает до пяти минут',
                },
            },
            ConfirmBreedModal: {
                title: 'Скрестить за ',
                text: 'Присоединяясь к игре, вы соглашаетесь скрестить две NFT для получения новой NFT случайного ранга',
            },
            NftEvolutionSuccess: {
                title: 'Создана NFT ранга {{rank}}!',
                text: 'Поздравляем! Вы успешно скрестили свои NFT и получили NFT ранга {{rank}}',
            },
            NftEvolutionMintPet: {
                title: 'Выбор NFT',
                text: 'Мы автоматически сгенерировали для вас четыре изображения NFT. Выберите лучшее и введите имя для вашего нового NFT-питомца',
            },
            noPetModal: {
                title: 'Не хватает NFT для игры',
                text: 'Для того, чтобы принять участие в игре, необходимо как минимум два питомца. Создайте нового и начинайте играть прямо сейчас',
            },
        },

        NftRoyal: {
            lockPeriodWarning:
                'Чтобы предотвратить нечестную игру, мы используем умную анти-читинг систему',

            NftRoyalHowItWorks: {
                stepOne: {
                    title: 'Превзойдите противников в аркадной игре',
                    text: 'Преобразованная игра из ежедневных заданий, где вы столкнетесь с сильными противниками. В данной версии присутсвуют несколько игровых режимов. В каждой игре есть только один противик',
                },
                stepTwo: {
                    title: 'Присоединяйтесь и создавайте игры',
                    text: 'Пользователи могут присоединяться к играм и создавать их. При создании игры необходимо выбрать сумму для ставки в токенах VIGU. Присоединяясь к игре, вы соглашаетесь играть на количество токенов, указанное создателем игры',
                },
                stepThree: {
                    title: 'Читинг невозможен',
                    text: 'Чтобы предотвратить нечестную игру, мы используем умную анти-читинг систему, которая гарантирует, что только умение и удача определяют победителя',
                },
            },
            NftRoyalGameSettings: {
                gameMode: {
                    [NFT_ROYAL_GAME_MODE.Score]: {
                        title: 'Очки',
                        text: 'Соревнование за большее количество очков',
                    },
                    [NFT_ROYAL_GAME_MODE.Fruit]: {
                        title: 'Фрукты',
                        text: 'Соревнование за большее количество фруктов',
                    },
                },
                difficultyType: {
                    [GAME_DIFFICULTY.Easy]: {
                        title: 'Легкая',
                        text: 'Низкая скорость персонажа и появления кактусов',
                    },
                    [GAME_DIFFICULTY.Medium]: {
                        title: 'Средняя',
                        text: 'Средняя скорость персонажа и появления кактусов',
                    },
                    [GAME_DIFFICULTY.Hard]: {
                        title: 'Высокая',
                        text: 'Высокая скорость персонажа и появления кактусов',
                    },
                },
                lives: 'Максимальное количество жизней в игре',
            },
            NftRoyalGameSettingsModal: {
                title: 'Настройки игры',
                text: 'Игра может быть кастомизирована для более комфортного и интересного игрового процесса',
                feature: {
                    mode: {
                        description:
                            'В первом режиме вы соревнуетесь за очки, а во втором — за количество собранных фруктов',
                    },
                    difficulty: {
                        description:
                            'Три уровня сложности (легкий, средний и сложный) контролируют скорость игры и количество кактусов',
                    },
                    livesCount: {
                        description:
                            'Количество жизней в игре. Игра заканчивается потерей последней жизни одним из игроков',
                    },
                },
            },

            NftRoyalCreateGameSuccess: {
                title: 'Вы успешно создали игру!',
                text: 'Пожалуйста, завершите игру, чтобы мы могли сравнить ваши результаты с результатами вашего будущего соперника',
            },

            NftRoyalGameHistory: {
                [NFT_ROYAL_GAME_HISTORY_STATUS.WaitingForOpponent]: {
                    title: 'В ожидании противника',
                    text: 'Вы завершили игру. Теперь ваш противник должен бросить вам вызов и присоединиться к игре. Если противник не завершит ее в течение семи дней, игра будет автоматически прекращена, а ваш депозит возвращен',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Won]: {
                    title: 'Вы выиграли!',
                    textOne:
                        'Поздравляю! Вам удалось превзойти своего соперника. ',
                    textTwo:
                        ' будет переведен на ваш игровой кошелек немедленно',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Draw]: {
                    title: 'Ничья!',
                    text: 'Как ни странно, вы оба набрали равное количество очков. Ваша ставка возвращена на ваш кошелек. Хотите сыграть еще один раунд?',
                },
                [NFT_ROYAL_GAME_HISTORY_STATUS.Lost]: {
                    title: 'Вы проиграли :(',
                    text: 'К сожалению, в этом раунде вашему сопернику удалось переиграть вас. Ваша ставка была переведена на его кошелек. Помните, вы всегда можете победить в следующей игре!',
                },
                GameStatistics: {
                    title: 'Игровая статистика',
                    score: 'Кол-во очков',
                    lives: 'Сохранённые жизни',
                    fruitCollected: 'Собранные фрукты',
                },
            },
            NftRoyalLoadingScreen: {
                prepare: {
                    title: 'Подготовка игры',
                    text: 'Пожалуйста, подождите немного, пока загружается и настраивается игра. Это не займет много времени!',
                },
                complete: {
                    title: 'Анализ результатов',
                    text: 'Обрабатываем ваш результат и результат вашего соперника, чтобы выбрать победителя. Пожалуйста, подождите немного и не покидайте игру или приложение',
                },
            },
            emptyScreen: {
                title: 'Упс!',
                text: 'Что-то не так. Но не волнуйтесь, это будет быстро исправлено',
            },
        },

        [MYSTERY_GAMES.luckyStrike]: {
            keys: {
                participants: 'Участники',
                winners: 'Победители',
            },

            purchaseTicket: 'Приобрести билеты',
            ticketsGrabbed: 'Билетов приобретено',
            soldOut: 'Все билеты проданы',
            LuckyStrikeTimerBlock: {
                title: 'Раунд заканчивается через',
                text: 'Время до конца раунда',
            },
            HashSecuritySystem: {
                title: 'Безопасная система билетов',
                text: 'Каждый билет имеет уникальный код, который скрыт от других игроков. Код определяет победителя!',
            },
            LuckyStrikePricePool: {
                title: 'Приз = {{text}}',
                text: 'Общий пул, полученный от премий за билеты. Один победитель забирает все. Вознаграждение выплачивается на игровой кошелек',
            },
            LuckyStrikeParticipants: {
                title: 'Участники = {{text}}',
                text: 'Игроки, принимающие участие, и лимит игроков. При достижении лимита билеты становятся недоступными для приобретения',
            },
            LuckyStrikeHowItWorks: {
                stepOne: {
                    title: 'Представляем Лаки Страйк',
                    text: 'Примите участие в одном из раундов и выиграйте солидный приз! Каждый дополнительный билет в каком-либо из раундов увеличивает ваши шансы на победу',
                },
                stepTwo: {
                    title: 'Увеличьте свои шансы',
                    text: 'У каждого игрока есть шанс выиграть весь пул, собранный из средств, на которые были приобретены билеты. Чем больше билетов вы соберете, тем выше шанс получить награду',
                },
                stepThree: {
                    title: 'Читинг невозможен',
                    text: 'Поскольку код билета недоступен другим пользователям, мошенничество невозможно. Если вам кажется, что вам не повезло, так оно и есть. Поиграйте еще немного, и ситуация обязательно изменится',
                },
            },
            LuckyStrikeMain: {
                title: 'Раунды',
                text: 'Раунды различаются по продолжительности, количеству игроков и шансу на победу',
                emptyList: {
                    title: 'Нет победителей',
                    text: 'Пока нет пользователей, выигравших раунд. Скоро появятся.',
                },
            },
            LuckyStrikeWinners: {
                title: 'Победители',
                text: 'Взгляните на победителей игры!',
            },
            LuckyStrikePurchaseModal: {
                title: 'Приобрести билет на "{{type}}"',
                text: 'Средства собираются из игрового пула. Победитель забирает весь пул и определяется по хешу билета. Чем больше билетов вы соберете, тем выше шанс получить награду',
                alert: 'Для предотвращения читинга и улучшения игрового процесса нельзя приобрести более {{maxTickets}} билетов',
            },
            LuckyStrikeWaitingForResult: {
                title: 'Ожидание результатов!',
                text: 'Дождитесь окончания раунда, чтобы узнать результат игры. Вы можете приобрести больше билетов, чтобы увеличить свои шансы на выигрыш',
            },
            LuckyStrikeUserTickets: {
                text: 'Каждый билет имеет уникальный код, который скрыт от других игроков и помогает нам гарантировать честность игры',
                alert: 'Вы уже приобрели {{text}} билетов на игру',
            },

            LuckyStrikeHistoryItem: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: '{{round}} выигран',
                [LUCKY_STRIKE_GAMES_STATUS.Lost]: '{{round}} проигран',
                [LUCKY_STRIKE_GAMES_STATUS.WaitingForResults]:
                    'Ожидание результатов',
            },
            LuckyStrikeHistoryBlockHeader: {
                [LUCKY_STRIKE_GAMES_STATUS.Won]: {
                    title: 'Вы выиграли!',
                    textOne:
                        'Поздравляем! Ваш билет оказался счастливым, и вы выиграли весь призовой фонд. ',
                    textTwo: ' будут мгновенно зачислены на ваш кошелек',
                },

                [LUCKY_STRIKE_GAMES_STATUS.Lost]: {
                    title: 'Вы проиграли :(',
                    text: 'К сожалению, в этот раз вам не удалось выиграть раунд. Удачи в следующем!',
                },
            },
            LuckyStrikeGameHistoryInfo: {
                gameType: 'Тип игры',
                correctTicket: 'Выигрышный билет',
                yourTicket: 'Ваш билет',
                yourTickets: 'Ваши билеты',
            },
            toasts: {
                soldOut: {
                    text1: 'Ошибка!',
                    text2: 'Все билеты проданы!',
                },
                gameExpired: {
                    text1: 'Ошибка!',
                    text2: 'Раунд закончился!',
                },
                gamePending: {
                    text1: 'Упс!',
                    text2: 'Что-то пошло не так',
                },
            },
        },

        [MYSTERY_GAMES.quantumSpin]: {
            keys: {
                spin: 'Повернуть',
                spinning: 'Вращается',
            },
            QuantumSpinProvablyFair: {
                card: {
                    title: 'Проверяемая рандомизация',
                    text: 'Все результаты рассчитываются с помощью криптографической функции, которая позволяет каждому проверить честность игры',
                },

                title: 'Проверяемая рандомизация',
                text: 'Результаты объединены в криптографическую цепь, что делает невозможным обман системы. Поскольку мы опубликовали первый хэш в Твиттере, вы можете сами убедиться в справедливости результатов',
                algorithm: {
                    title: 'Алгоритм',
                    text: 'Результаты следующих {{rounds}} раундов заранее сгенерированы. Перед каждым раундом мы раскрываем хэш результата, что делает невозможным его изменение постфактум.\n\nВсе результаты связаны в криптографическую "цепь", что делает невозможным их изменение. Перед генерацией цепочки результатов мы опубликовали первый хэш в Твиттере, смешав его с заранее неизвестным нам хэшем блока Биткоина. Таким образом, результаты можно проверить, и они действительно произвольны.\n\nЦепочка хэшей была создана до первого раунда игры. Каждый хэш представляет собой 256-битное значение. Цепочка начинается со случайно выбранного 256-битного значения, и каждое последующее значение рассчитывается с использованием хэша BLAKE2b предыдущего значения.\n\nКриптографическая хэш-функция гарантирует, что можно легко вычислить любое значение в цепочке, используя предыдущее значение, но невозможно вычислить значения в обратном направлении. Последнее значение в заранее рассчитанной хеш-цепочке, начальный хэш, мы публично опубликовали и использовали в первом раунде игры. В каждом следующем раунде используется предыдущее значение хэша. Проходя цепочку таким образом, можно убедиться, что результаты всех прошлых игровых раундов соответствуют заранее рассчитанной цепочке, но исход будущих раундов остается для пользователей непредсказуемым.\n\nЧтобы исключить вероятность того, что мы намеренно создали цепочку с использованием конкретного начального значения, которое бы искажало результаты игры в нашу пользу, каждое значение в цепочке прибавляется к глобальному начальному значению, а полученное значение снова хэшируется с использованием BLAKE2b для вычисления окончательного значения. Так определяется исход каждого игрового раунда. Данное глобальное начальное значение соответствует хэшу блока Биткоина, который мы публично выбрали перед его майнингом. Глобальное начальное значение гарантирует, что исход игр был для нас неизвестен, когда было опубликовано значения хэша первой игры',
                },
                verification: {
                    title: 'Пример проверки',
                    text: 'Любой может убедиться, что результаты всех предыдущих игровых раундов были сгенерированы с использованием проверяемого алгоритма рандомизации с помощью следующего кода Python',
                },
            },
            QuantumSpinHowItWorks: {
                stepOne: {
                    title: 'Крути квантовое колесо',
                    text: 'Колесо находится в суперпозиции, так что заранее неизвестно, какой результат оно покажет. Крути колесо, чтобы вывести его из суперпозиции и выиграть самый большой приз!',
                },
                stepTwo: {
                    title: 'Каждый квантовый поворот требует энергии, то есть токенов',
                    text: 'Ваш приз может быть ниже или выше вашей ставки. Естественно, вы можете получить огромную награду!',
                },
                stepThree: {
                    title: 'Читинг невозможен',
                    text: 'Результаты поворота определяются в момент игры случайным образом и неизвестны команде. Мы ценим честность и прозрачность',
                },
            },
            QuantumSuccess: {
                coin: 'Поздравляем! Вы выиграли {{coin}}, которые будут немедленно переведены на ваш кошелек. Испытайте удачу еще раз и поделитесь своими результатами в соцсетях',
                rank: 'Поздравляем! Вы выиграли NFT ранга {{rank}}, и она будет немедленно переведена на ваш кошелек. Испытайте удачу еще раз и поделитесь своими результатами в соцсетях',
            },
            QuantumSpinGameHistory: {
                again: 'Повернуть снова',
            },
            QuantumSpinDetailsModal: {
                button: 'Назад к диску',
            },
            QuantumSpinHistory: {
                title: 'Тут пусто',
                text: 'Вы пока еще не сыграли ни одной игры',
            },
        },
        [MYSTERY_GAMES.tokenteller]: {
            predictPrice: 'Предсказать цену',
            addMoreTokens: 'Добавить токены',
            priceDirection: 'Направление цены',

            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'ВВЕРХ',
            [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]: 'ВНИЗ',
            TokenTellerConfirmationModal: {
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Up]: 'Бычий множитель',
                [TOKEN_TELLER_GAME_PREDICTION_DIRECTION.Down]:
                    'Медвежий множитель',
            },

            TokenTellerHowItWorks: {
                stepOne: {
                    title: 'Игумания',
                    text: 'Проверьте свои навыки предсказания в динамичной игре. Угадывайте движение цены IGU в {{min}}-минутных раундах. Вы можете использовать любые необходимые средства: хрустальные шары, животных-предсказателей и даже черную магию',
                },
                stepTwo: {
                    title: 'Размер награды',
                    text: 'В игре вы выбираете, пойдет ли токен вниз или вверх. Размер вашего вознаграждения зависит от множителя, который представляет собой отношение бычьего пула к медвежьему пулу. Множитель отображается на вкладке присоединения к раунду и может меняться до начала раунда',
                },
                stepThree: {
                    title: 'Читинг невозможен',
                    text: 'Мы используем надежный оракул, который обеспечивает соответствие текущей цены {{coin}} в приложении и цены на биржах. Вы всегда можете проверить цену',
                },
            },
            TokenTellerMainScreen: {
                title: 'Раунды',
                text: 'Вы можете присоединиться только к предстоящему раунду',
            },
            TokenTellerPurchaseModal: {
                title: 'Угадайте движение цены',
                text: 'Присоединяйтесь к раунду, чтобы предсказать, куда пойдет {{coin}}. Выберите ставку и направление ниже',
                alert: 'Вы уже выбрали, что токен пойдет {{direction}}. Теперь вы можете только увеличить свою позицию в этом направлении',
            },

            TokenTellerPricePool: {
                title: 'Пул = {{text}}',
                text: 'Пул собирается из ставок пользователей. Вознаграждение зависит от соотношения между бычьими и медвежьими ставками',
            },
            TokenTellerUpPayout: {
                title: 'Бычий множитель = {{coefficient}}X',
                text: 'Множитель награды победителя при росте цены',
            },
            TokenTellerDownPayout: {
                title: 'Медвежий множитель = {{coefficient}}X',
                text: 'Множитель награды победителя при падении цены',
            },
            TokenTellerParticipants: {
                title: 'Участники = {{text}}',
                text: 'Количество игроков, принимающих участие в раунде',
            },

            TokenTellerTimerBlock: {
                [TOKEN_TELLER_GAME_STATUS.Pending]: {
                    title: 'Раунд начинается через',
                },
                [TOKEN_TELLER_GAME_STATUS.Closed]: {
                    title: 'Раунд заканчивается через',
                },
            },
            TokenTellerHistoryItem: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: 'Победа',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: 'Проигрыш',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.WaitingForResults]:
                    'Ожидание результата',
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: 'Ничья',
            },

            TokenTellerHistoryBlockHeader: {
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Won]: {
                    title: 'Вы выиграли!',
                    textOne:
                        'Поздравляю! Вы правильно предсказали движение цены. ',
                    textTwo: ' будет немедленно зачислено на ваш кошелек',
                },

                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Lost]: {
                    title: 'Вы проиграли :(',
                    text: 'К сожалению, в этот раз вам не удалось победить. Хороший повод проявить себя в следующем раунде!',
                },
                [TOKEN_TELLER_HISTORY_GAMES_STATUS.Refund]: {
                    title: 'Ничья???',
                    text: 'Как ни странно, результат — ничья. Ваша ставка возвращена в кошелек',
                },
            },

            TokenTellerGameHistoryInfoItem: {
                iguBefore: 'Начальная цена',
                iguAfter: 'Цена закрытия',
                prediction: 'Позиция',
                totalPool: 'Общий пул',
                participants: 'Участники',
                upPayout: 'Бычий множитель',
                downPayout: 'Медвежий множитель',
            },
        },
        DailyTasks: {
            header: 'Ежедневные задания',
            collected: '{{collectedEnergy}} / {{maxEnergy}} Собрано',
            SocialTask: {
                title: 'Социальное задание',
                text: 'Делайте посты в социальных сетях',
            },
            VerificationTask: {
                title: 'Поисковое задание',
                text: 'Проверяйте сообщения других пользователей',
            },
            MoveTask: {
                title: 'Подвижное задание',
                text: 'Наслаждайтесь прогулками на улице со своим питомцем',
            },
            PlayTask: {
                title: 'Игровое задание',
                text: 'Сыграйте в увлекательную аркадную игру',
            },
        },
        ReferralCard: {
            title: '{{percent}}% скидка на NFT!',
            text: 'Приглашайте новых пользователей в приложение IguVerse и получайте скидку на минт NFT',
            button: 'Пригласить',
        },
        TimerTopUp: {
            title: 'за каждое пополнение',
            text1: 'Внесите токены сейчас и получите на свой кошелек {{percent}}% {{coin}}! Доступно только до:',
            text2: 'Начните играть в наши новые Pvp-игры и получите бонусные токены!',
        },
    },
    pvpBonus: {
        cardButton: 'PVP Бонус',
        title: 'PvP - бонусы',
        text: 'Владельцы NFT имеют право на дополнительные награды за участие в PvP. Начните прямо сейчас и получите свои бонусы!',
        pvpBonusModal: {
            title: 'Как заработать больше в PvP',
            text: 'Доходы IguVerse от PvP будут распределяться между игроками пропорционально обороту! Заведите NFT, и вы автоматически получите бонусы за игру',
            features: {
                games: {
                    title: 'Счетчик игр = {{games}}',
                    text: 'Количество игр, в которых вы сегодня участвовали. Может быть еще одну?',
                },
                bonus: {
                    title: 'PvP - бонусы = {{amount}}',
                    text: 'Это дополнительные токены, которые вы получите за участие в PvP-играх в конце дня. Сражайтесь с другими и зарабатывайте еще больше!',
                },
            },
        },
        pvpBonusModalFreePet: {
            title: 'Повысьте ранг, чтобы получить больше токенов в PvP',
            text: 'Ваш питомец ранга Free должен быть повышен до более высокого ранга, чтобы вы могли иметь право на бонусы от PvP',
        },
    },
    MarketPlace: {
        navigationBar: {
            ORDERS: 'Активные ордера',
            MY_PROFILE: 'Мой профиль',
        },
        MarketPlaceActiveOrdersScreen: {
            title: 'Торговая площадка',
            text: 'Место для торговли NFT',
            empty: {
                title: 'Нет NFT на продажу',
                text: 'Пока ордера на продажу отсуствуют. Создайте ордер первым!',
            },
            notFound: {
                title: 'Результатов не найдено',
                text: 'Мы не нашли таких ордеров. Введите другое ключевое слово для поиска',
            },
        },
        MarketPlaceSearch: {
            modalTitle: 'Фильтры',
            placeHolder: 'Поиск по nft, коллекции, пользователю...',
            typeSection: {
                [MARKETPLACE_PET_TYPE.AISystem]: 'AI Cистема',
                [MARKETPLACE_PET_TYPE.FromPhoto]: 'С фотографии',
                [MARKETPLACE_PET_TYPE.Alive]: 'Живой',
                [MARKETPLACE_PET_TYPE.Dead]: 'Мертвый',
            },

            sortBySection: {
                [MARKETPLACE_ORDERS_SORT_OPTION.FromHighestPrice]:
                    'От высоких цен к низким',
                [MARKETPLACE_ORDERS_SORT_OPTION.FromLowestPrice]:
                    'От низких цен к высоким',
                [MARKETPLACE_ORDERS_SORT_OPTION.RecentlyListed]:
                    'Недавно размещенные',
                [MARKETPLACE_ORDERS_SORT_OPTION.EndingSoon]:
                    'Скоро заканчивается',
            },
        },
        MarketPlaceWelcomeCreateOrderScreen: {
            screenTitle: 'Создать новый ордер',
            title: 'Подготовьте NFT к большому путешествию',
            text: 'Здесь вы можете разместить свою NFT и продать ее',
            features: {
                rank: {
                    title: 'Минимальный ранг – {{rank}}',
                    text: 'Ваша NFT должна иметь ранг выше {{lowRank}}. Только NFT, приобретенные в приложении, могут быть проданы на торговой площадке',
                },
                termination: {
                    title: 'Автоматическое завершение = {{days}} Дней',
                    text: 'Время, в течение которого ордер истечет, если NFT не был куплена раньше',
                    alert: 'Если никто не купил NFT в течение {{days}} дней, заказ будет автоматически удален из торговой площадки. Во время продажи вы можете продолжать играть и зарабатывать',
                },
                commission: {
                    title: 'Комиссионный сбор = {{commission}}%',
                    text: 'За каждую успешно проданную NFT взимается комиссия в {{commission}}%',
                },
            },
        },
        MarketPlaceModalNoPet: {
            title: 'У вас нет ни одной NFT',
            text: 'Создайте хотя бы одну NFT для продажи. Вы можете сминтить ее прямо сейчас!',
        },
        MarketPlaceSelectNftScreen: {
            screenTitle: 'Выберите NFT',
        },
        MarketPlaceSelectNftPriceScreen: {
            screenTitle: 'Введите цену NFT',
        },
        MarketPlaceCreateOrderSuccessScreen: {
            title: 'Создан ордер на продажу NFT',
            text: 'Вы успешно разместили свою NFT на торговой площадке. Теперь другие пользователи смогут ее приобрести',
        },
        navigationBarOverview: {
            OVERVIEW: 'Обзор',
            OWNER_HISTORY: 'История',
        },
        MarketPlaceOverview: {
            text: 'Это NFT другого пользователя. Вы можете посмотреть ее характеристики ниже:',
            textOwner: 'Это ваша NFT. Ее характеристики приведены ниже:',
            OverviewOwnerSection: {
                profileLabel: 'Профиль владельца',
            },
            proceedToCheckoutModal: {
                title: 'Перейти к покупке?',
                text: 'После покупки NFT она будет находиться в пассивном режиме в течение 24 часов. Убедитесь, что вы проверили все ее свойства перед покупкой',
            },
        },
        DelistNftModal: {
            title: 'Удалить ордер?',
            text: 'В случае делистинга NFT больше не будет размещена на продажу',
        },
        MarketplaceProfile: {
            joined: 'Присоединился {{date}}',
            myNFTs: 'Мои NFTs',
            exploreNFTs: 'Исследовать NFTs',
            emptyUser: {
                title: 'Ордера отсутствуют',
                text: 'Вы пока еще не создавали ордеров на торговой площадке',
            },
            empty: {
                title: 'Ордера отсутствуют',
                text: 'Этот пользователь пока еще не создавал ордеров на торговой площадке',
            },
        },
        MarketPlaceDelistSuccessScreen: {
            title: 'NFT "{{name}}" успешно удалена с торговой площадки',
        },
        MarketPlaceBuySuccessScreen: {
            title: 'Новая NFT в коллекции',
            text: 'Вы успешно приобрели новую NFT! Теперь ваша коллекция пополнилась новым питомцем и стала намного сильнее',
        },
        MarketPlaceNoTradeAvalibleScreen: {
            title: 'Вышел маркетплейс!',
            description:
                'Мы только что запустили нашу внутреннюю торговую площадку, где вы можете торговать своими NFT. Откройте его через веб-приложение и создайте свой первый ордер прямо сейчас!',
            button: 'Исследуйте в веб-приложении',
        },
    },
    SpaceId: {
        card: {
            title: 'Успейте получить SPACE ID',
            text: 'Используйте оригинальный никнейм в приложении и во всей криптовселенной',
        },
        how: {
            screenTitle: 'Как использовать SPACE ID',
            title: 'Создайте цифровой ID',
            text: 'Устали от сложных нечитаемых адресов? Замените свой адрес на подходящее доменное имя с помощью SPACE ID!',
            guideBlock: {
                first: 'Импортируйте свой кошелек IguVerse в любой некастодиальный DeFi-кошелек (например, Trustwallet, Metamask), используя сид-фразу',
                second: 'Добавьте сеть BEP-20 и подключите кошелек к сайту',
                third: 'Найдите нужное доменное имя на сайте',
                fourth: 'Купите подходящее доменное имя и обновите приложение IguVerse. Вы сможете увидеть свой пользовательский никнейм в кошельке, в таблице лидеров и в любом другом месте, где он используется',
                alert: 'Чтобы купить домен, необходимо иметь немного BNB в кошельке',
            },
            button1: 'Ознакомиться с доменами',
        },
        modal: {
            title: 'Уникальный SPACE ID!',
            text: 'Вы успешно приобрели и зарегистрировали собственный домен! Отныне ваше уникальное имя будет отображаться везде в приложении. Ваш настоящий адрес останется тем же. Чтобы скопировать его, нажмите кнопку "Копировать" в кошельке',
            link: 'Узнайте больше об SPACE ID',
        },
    },
    Achievements: {
        title: 'Достижения',
        text: 'Захватывающие задания, которые помогают отслеживать ваш уникальный прогресс и позволяют продемонстрировать свои навыки и игровой опыт',
        unlocked: 'Достижение {{achievement}} разблокировано!',
        unlockedText:
            'Поздравляем, вам удалось разблокировать новое достижение. Поделитесь им с друзьями в социальных сетях!',
        button: 'Поделиться Достижением',
        modal: {
            title: 'Выделяйтесь достижениями',
            text: 'Выполняйте задания, чтобы получить достижения. Гораздо интереснее играть, когда есть вызов, а в придачу грудь, полная наград',
        },
    },
};

export default ru;
